(function () {
    'use strict';

    angular
        .module('app.kpi', [
            'nvd3',
            'md.data.table'
        ])
        .config(config)
        .config(dateFormat);

    function dateFormat($mdDateLocaleProvider) {
        $mdDateLocaleProvider.formatDate = function (date) {
            return moment(date).format('DD/MM/YYYY');
        };
    }

    /** @ngInject */
    function config(msNavigationServiceProvider, $stateProvider) {
        // KPI
        $stateProvider.state('app.kpi', {
            parent: 'app',
            url: '/home/indicadores',
            views: {
                'content@app': {
                    templateUrl: 'app/main/home/apps/kpi/kpi.html',
                    controller: 'KpiController as vm'
                }
            },
            resolve: {
                DepartmentsList: function ($rootScope) {
                    $rootScope.activeContextApp = 'main';
                    return {};
                }
            },
            authenticate: true
        });

        // RESULT ANALYSIS
        $stateProvider.state('app.kpi.results', {
            parent: 'app.kpi',
            url: '/:departmentId/:indicatorId',
            views: {
                'indicators@app.kpi': {
                    templateUrl: 'app/main/home/apps/kpi/results/indicator-results.html',
                    controller: 'IndicatorResultsController as vm'
                }
            },
            params: {
                departmentId: null,
                departmentName: null,
                measureUnit: null,
                indicatorId: null
            },
            authenticate: true
        });
    }
})();
(function(){
    'use strict';
    
    angular
        .module('app.kpi')
        .controller('AttachResultController', AttachResultController);
    
    function AttachResultController($stateParams, $state, $mdToast, Indicator, User, Tasks, AuthService, KpiIndicators, KpiNonCompliances, $scope)
    {        
        var vm = this;
        
        vm.code = $stateParams.code;
        vm.selectedPeriod = $stateParams.selectedPeriod;
        vm.indicator = Indicator;
        vm.resultsData = $stateParams.resultsData;
        vm.resultModel = {};
        vm.improvementOption = 'yes';
        vm.improvementOptions = [
            {value: 'yes', title: 'Sim'},
            {value: 'no', title: 'Não'}
        ];
        vm.RACPOption = false;
        vm.RACPOptions = [
            {value: true, title: 'Sim'},
            {value: false, title: 'Não'}
        ];
        vm.actionPlanOption = 0;
        vm.actionPlanOptions = [
            {value: 0, title: 'Corretivo'},
            {value: 1, title: 'Preventivo'}
        ];
        vm.tasksList = [];
        
        vm.save = save;
        
        User.get(function(res){
            vm.users = res.data;
        });
        
        // Salva o indicador e cria o plano de ação se for necessário
        function save()
        {
            saveIndicator();
            if (vm.resultModel.RACPOption === 'true')
                createTaskActionPlan();
        }
        
        // Salva os dados do indicador
        function saveIndicator()
        {
            var d = new Date().getTime();
            if (!vm.indicator.resultAnalysis)
                vm.indicator.resultAnalysis = {};
            
            vm.indicator.resultAnalysis[d] = vm.resultModel;
            KpiIndicators.save(vm.indicator, true)
            .then(function(res){
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Análise salva com sucesso!')
                    .position('bottom right')
                    .hideDelay(3000)
                );
            }, function(e){
                console.log(e);
            });
        }
        
        // Cria o plano de ação "per se"
        function createTaskActionPlan()
        {
            var newTask = new Tasks();
            
            newTask.name = '#ap Plano de Ação do RACP ' + vm.resultModel.RACPTitle;
            newTask.description = '#ap Plano de Ação do RACP ' + vm.resultModel.RACPTitle;
            newTask.dueDate = vm.resultModel.dueDate;
            newTask.owner = AuthService.authSessions.activitiSession.username;
            newTask.assignee = vm.resultModel.assignee;
            newTask.priority = 100;
            newTask.$save(function(res){
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Tarefa de plano de ação criada com sucesso!')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                createTaskMethodAnalysis(res.id);
            });
        }
        
        // Cria a tarefa principal do plano de ação
        function createTaskMethodAnalysis(parentTaskId)
        {
            var newTask = new Tasks();

            newTask.name = 'Método de análise do plano de ação';
            newTask.description = vm.resultModel.methodAnalysis;
            newTask.dueDate = vm.resultModel.dueDate;
            newTask.owner = AuthService.authSessions.activitiSession.username;
            newTask.assignee = vm.resultModel.assignee;
            newTask.parentTaskId = parentTaskId;
            newTask.priority = 100;
            newTask.$save(function(){
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Tarefa de método de análise criada com sucesso!')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                createChildrenTasks(parentTaskId);
            });
        }
        
        // Cria as tarefas "filhas", geradas na diretiva <action-plan>
        function createChildrenTasks(parentTaskId)
        {
            for(var i = 0; i < vm.tasksList.length; i++){
                var task = vm.tasksList[i];
                if (task.title){
                    var newTask = new Tasks();

                    newTask.name = task.title;
                    newTask.dueDate = task.dueDate;
                    newTask.owner = AuthService.authSessions.activitiSession.username;
                    newTask.assignee = task.assignee;
                    newTask.parentTaskId = parentTaskId;
                    newTask.priority = 100;
                    newTask.$save(function(){});
                }
            }
            //$state.go('app.home.tasks');
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'angularSlideables',
                'ui.router',
                'ui.sortable',
                'ng-sortable',
                'as.sortable'
            ]);
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('kpiChart', KpiChartDirective);

    function KpiChartDirective(ResultAnalisysEndpoint, $timeout) {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                //department: '@departmentId',
                indicator: '=indicator',
                period: '@',
                update: '=',
                code: '@',
                width: '=',
                height: '=',
                data: '='
            },
            controller: 'KpiChartController as ctrl',
            templateUrl: 'app/main/home/apps/kpi/directives/chart/kpi-chart.html',
            link: function (scope, elements, attrs) {
                scope.$watch('period', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        plot(scope.period);
                    }
                });

                scope.$watch('update', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        plot(scope.period);
                    }
                });

                scope.ctrl.chartData = {};

                plot();

                function plot(period) {
                    if (!scope.data) {
                        var pi = '-6',
                            pf = '-1';

                        if (period) {
                            if (period === '12') {
                                pi = '-12';
                                pf = '-1';
                            } else if (period === 'current') {
                                var c = new Date();
                                c = c.getTime() + c.getTimezoneOffset() * 60000;
                                c = new Date(c);
                                c = c.getMonth() * (-1);
                                pi = c.toString();
                                pf = '-1';
                            }
                        }

                        var data = ResultAnalisysEndpoint.query({
                            //endpoint: 'convert_extraction_query_to_cda', 
                            path: '/system/ppa/endpoints/kettle/kpiValues.cda',
                            dataAccessId: "kpiValues",
                            //paramdepartment_key: scope.indicator.departmentId,
                            paramkpi_key: scope.indicator.id,
                            paramseq_mes_i: pi,
                            paramseq_mes_f: pf
                        });

                        data.$promise.then(function (res) {
                            var v = [],
                                m = [],
                                i = 1;

                            angular.forEach(res.resultset, function (value, key) {
                                var
                                    day = '01',
                                    month = parseInt(value[1].toString().substr(4, 2)) - 1,
                                    year = value[1].toString().substr(0, 4);
                                var d = new Date(year, month, day);

                                if (parseInt(value[2]) >= 0) {
                                    v.push({
                                        x: d,
                                        y: parseFloat(value[2]) || 0
                                    });

                                    m.push({
                                        x: d,
                                        y: parseFloat(value[3]) || 0
                                    });
                                }
                            });

                            var data = [{
                                    values: v,
                                    key: 'Resultados',
                                    color: '#ff7f0e'
                                },
                                {
                                    values: m,
                                    key: 'Metas',
                                    color: '#0e7fff'
                                }
                            ];

                            scope.ctrl.chartData[scope.code] = [];
                            scope.ctrl.chartData[scope.code] = data;

                            scope.refresh(data);
                        }, function (e) {
                            console.log(e.message)
                        })
                    } else {
                        scope.ctrl.chartData = scope.data;
                    }
                }

                scope.ctrl.chart.options.chart.width = scope.width;
                scope.ctrl.chart.options.chart.height = scope.height;
            }
        };
    }
}());

(function(){
  'use strict';

  angular
    .module('app.core')
    .controller('KpiChartController', KpiChartController);

  function KpiChartController($rootScope, $state, $scope)
  {
    var vm = this;

    vm.id = $scope.code;

    $scope.refresh = refresh;

    function refresh(data)
    {
      $scope.api.updateWithData(data);
    }

    vm.chart = {
      // Opções
      options: {
        chart: {
          type: 'lineChart',
          margin : {
            top: 20,
            right: 20,
            bottom: 40,
            left: 55
          },
          x: function(d){ return d.x; },
          y: function(d){ return d.y; },
          useInteractiveGuideline: true,
          dispatch: {
            stateChange: function(e){  },
            changeState: function(e){  },
            tooltipShow: function(e){  },
            tooltipHide: function(e){  }
          },
          showXAxis: true,
          showYAxis: true,
          xAxis: {
            //axisLabel: 'Mês',
            tickFormat: function(d){
              return d3.time.format('%b')(new Date(d))
            },
            tickValues: function(values) {
              return _.map(values[0].values, function(v) {
                return d3.time.format('%b')(new Date(v.x));
              });
            }
          },
          yAxis: {
            //axisLabel: 'Resultado',
            tickFormat: function(d){
              return d3.format('02d')(d);
            },
            axisLabelDistance: -5
          },
          callback: function(chart){

          },
          noData: 'Sem resultados.'
        }
      }
    }
  }
}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('actionPlan', ActionPlanDirective);

    function ActionPlanDirective(User) {
        return {
            restrict: 'E',
            scope: {
                taskslist: '=',
                taskId: '@taskid',
                readonly: '@readonly'
            },
            replace: true,
            controller: 'ActionPlanTasksController as ctrl',
            templateUrl: 'app/main/home/apps/kpi/directives/action-plan/action-plan.html',
            link: function (scope, elements, attrs) {
                scope.ctrl.tasksList = scope.taskslist;
                scope.ctrl.actionPlanTaskId = scope.taskId;
                scope.ctrl.readonly = scope.readonly;
                scope.ctrl.tasksList.push({
                    name: null,
                    assignee: null,
                    dueDate: new Date()
                });
                User.get(function (res) {
                    scope.ctrl.users = res.data;
                });
            }
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('ActionPlanTasksController', ActionPlanTasksController);

    function ActionPlanTasksController($rootScope, $scope, $state, SubTasks) {
        var vm = this;

        vm.tasksList = [];
        vm.users = [];

        // Se for informado o id da tarefa de plano de ação, busca as subtarefas
        $scope.$watch('taskId', function (newValue, oldValue) {
            if (newValue) {
                vm.subtasks = null;
                var data = SubTasks.query({
                    "taskId": $scope.taskId
                });

                data.$promise.then(function (res) {
                    vm.subtasks = res;
                }, function (e) {
                    console.log(e);
                });
            }
        });

        vm.newLine = newLine;

        function newLine() {
            var last = vm.tasksList[vm.tasksList.length - 1];
            if (last.name && last.assignee && last.dueDate) {
                vm.tasksList.push({
                    name: null,
                    assignee: null,
                    dueDate: new Date()
                });
            }
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.kpi')
        .controller('IndicatorDialogController', IndicatorDialogController);

    /** @ngInject */
    function IndicatorDialogController($mdDialog, $rootScope, Indicator, fuseTheming, KpiService, KpiIndicators, ConvertQueryToCDAEndpoint, LoadKpiValuesEndpoint, departmentId, newIndicator) {
        var vm = this;

        vm.indicator = Indicator;
        vm.selectedTarget = {};
        vm.newIndicator = newIndicator;

        // Lista de unidades de medida
        vm.kpiMeasureUnits = [{
                measureUnitId: 'percent',
                measureUnitName: 'Percentual',
                measureUnitSymbol: '%'
            },
            {
                measureUnitId: 'pacient',
                measureUnitName: 'Paciente',
                measureUnitSymbol: 'pac'
            },
            {
                measureUnitId: 'pacientday',
                measureUnitName: 'Paciente/Dia',
                measureUnitSymbol: 'pac/d'
            },
            {
                measureUnitId: 'pacientbed',
                measureUnitName: 'Paciente/Leito',
                measureUnitSymbol: 'pac/l'
            },
            {
                measureUnitId: 'bedday',
                measureUnitName: 'Leito/Dia',
                measureUnitSymbol: 'lei/d'
            },
            {
                measureUnitId: 'day',
                measureUnitName: 'Dias',
                measureUnitSymbol: 'dia'
            },
            {
                measureUnitId: 'hour',
                measureUnitName: 'Horas',
                measureUnitSymbol: 'hrs'
            },
            {
                measureUnitId: 'minute',
                measureUnitName: 'Minutos',
                measureUnitSymbol: 'min'
            },
            {
                measureUnitId: 'currency',
                measureUnitName: 'Moeda',
                measureUnitSymbol: 'R$'
            },
            {
                measureUnitId: 'unit',
                measureUnitName: 'Unidade',
                measureUnitSymbol: 'un'
            },
            {
                measureUnitId: 'kg',
                measureUnitName: 'Kilograma',
                measureUnitSymbol: 'kg'
            },
            {
                measureUnitId: 'ml',
                measureUnitName: 'Mililitros',
                measureUnitSymbol: 'ml'
            },
            {
                measureUnitId: 'pmil',
                measureUnitName: 'por Mil',
                measureUnitSymbol: '/1000'
            }
        ];

        // Lista de categorias
        vm.kpiCategories = ['Estratégico', 'Operacional', 'Tático e Operacional', 'Risco', 'Operacional e Risco', 'Operacional e Estratégico', 'Tático, Operacional e Risco'];
        vm.kpiSubcategories = ['Estrutura', 'Processo', 'Resultado'];

        // Lista de frequências
        vm.kpiVerificationFrequencies = ['Mensal', 'Bimestral', 'Trimestral', 'Quadrimestral', 'Semestral', 'Anual', 'Bianual'];

        // Lista de tipos de orientação
        vm.orientations = [{
                orientation: 1,
                orientationDesc: 'Quanto maior melhor'
            },
            {
                orientation: -1,
                orientationDesc: 'Quanto menor melhor'
            }
        ];

        // Lista de fonte de dados
        vm.kpiDataSources = ['SGHDW', 'SGHDADOS', 'DOCSTORE'];

        // Lista de tipos de query
        vm.kpiQueryTypes = ['SQL', 'MDX'];

        // Methods
        vm.closeDialog = closeDialog;
        vm.themes = fuseTheming.themes;
        vm.addTarget = addTarget;
        vm.removeTarget = removeTarget;
        vm.saveIndicator = saveIndicator;
        vm.convertExtractionQueryToCDA = convertExtractionQueryToCDA;
        vm.loadKpiValues = loadKpiValues;

        function closeDialog() {
            $mdDialog.cancel();
            //vm.saveIndicator();
        }

        // Adiciona novas metas
        function addTarget() {
            if (!vm.indicator.targets)
                vm.indicator.targets = {};

            vm.indicator.targets[vm.selectedTarget.validFromTmp.getTime()] = {
                target: vm.selectedTarget.target,
                source: vm.selectedTarget.source
            }

            vm.selectedTarget = {};
        }

        function removeTarget(target) {
            delete vm.indicator.targets[target];
            if (isEmpty(vm.indicator.targets)) {
                delete vm.indicator.targets;
            }
        }

        function isEmpty(ob) {
            for (var i in ob) {
                return false;
            }
            return true;
        }

        // Salva os dados do indicador
        function saveIndicator() {
            if (!vm.indicator.departmentId)
                vm.indicator.departmentId = departmentId;
            if (!vm.indicator.survey)
                vm.indicator.survey = false;

            KpiIndicators.salvar(vm.indicator, !newIndicator).then(function (res) {
                if (vm.indicator.automatedExtractionQuery) {
                    vm.convertExtractionQueryToCDA();
                } else {
                    vm.loadKpiValues();
                }
            });
        }

        function emitRefresh() {
            $rootScope.$broadcast('refreshindicator');
        }

        function convertExtractionQueryToCDA() {
            var data = ConvertQueryToCDAEndpoint.query({
                paramdepartment_key: vm.indicator.departmentId,
                paramkpi_key: vm.indicator.id
            });

            data.$promise.then(function (res) {
                vm.loadKpiValues();
            }, function (e) {
                console.log(e.message);
            });
        }

        function loadKpiValues() {
            var data = LoadKpiValuesEndpoint.query({
                paramdepartment_key: vm.indicator.departmentId,
                paramkpi_key: vm.indicator.id,
                paramskip_automated_extraction: vm.indicator.automatedExtractionQuery ? 'no' : 'yes'
            });

            data.$promise.then(function (res) {
                $mdDialog.hide();
            }, function (e) {
                console.log(e.message);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.kpi')
        .controller('ManualResultsDialogController', ManualResultsDialogController);

    /** @ngInject */
    function ManualResultsDialogController($mdDialog, $rootScope, Indicator, fuseTheming, KpiService, KpiIndicators, ConvertQueryToCDAEndpoint, LoadKpiValuesEndpoint, departmentId, $scope, Docstore) {
        var vm = this;

        vm.indicator = Indicator;
        vm.selectedResult = {};
        vm.btnSaveLbl = "GRAVAR E FECHAR";
        vm.btnSaveEnb = true;

        // Lista de unidades de medida
        vm.kpiMeasureUnits = [{
            measureUnitId: 'percent',
            measureUnitName: 'Percentual',
            measureUnitSymbol: '%'
        }, {
            measureUnitId: 'pacient',
            measureUnitName: 'Paciente',
            measureUnitSymbol: 'pac'
        }, {
            measureUnitId: 'pacientday',
            measureUnitName: 'Paciente/Dia',
            measureUnitSymbol: 'pac/d'
        }, {
            measureUnitId: 'pacientbed',
            measureUnitName: 'Paciente/Leito',
            measureUnitSymbol: 'pac/l'
        }, {
            measureUnitId: 'bedday',
            measureUnitName: 'Leito/Dia',
            measureUnitSymbol: 'lei/d'
        }, {
            measureUnitId: 'day',
            measureUnitName: 'Dias',
            measureUnitSymbol: 'dia'
        }, {
            measureUnitId: 'minute',
            measureUnitName: 'Minutos',
            measureUnitSymbol: 'min'
        }, {
            measureUnitId: 'currency',
            measureUnitName: 'Moeda',
            measureUnitSymbol: 'R$'
        }, {
            measureUnitId: 'unit',
            measureUnitName: 'Unidade',
            measureUnitSymbol: 'un'
        }, {
            measureUnitId: 'kg',
            measureUnitName: 'Kilograma',
            measureUnitSymbol: 'kg'
        }];

        // Lista de categorias
        vm.kpiCategories = ['Estrategico', 'Operacional', 'Tático/Operacional', 'Risco', 'Operacional e Risco', 'Operacional e Estratégico'];

        // Lista de frequências
        vm.kpiVerificationFrequencies = ['Mensal', 'Bimestral', 'Trimestral', 'Quadrimestral', 'Semestral', 'Anual', 'Bianual'];

        // Lista de tipos de orientação
        vm.orientations = [{
            orientation: 1,
            orientationDesc: 'Quanto maior melhor'
        }, {
            orientation: -1,
            orientationDesc: 'Quanto menor melhor'
        }];

        // Lista de fonte de dados
        vm.kpiDataSources = ['SGHDW', 'SGHDADOS'];

        // Lista de tipos de query
        vm.kpiQueryTypes = ['SQL', 'MDX'];

        // Methods
        vm.addResult = addResult;
        vm.removeResult = removeResult;
        vm.isEmpty = isEmpty;
        vm.closeDialog = closeDialog;
        vm.themes = fuseTheming.themes;
        vm.saveIndicator = saveIndicator;
        vm.loadKpiValues = loadKpiValues;
        vm.onlyFirstDay = onlyFirstDay;

        function closeDialog() {
            vm.saveIndicator();
        }

        // Adiciona novas metas
        function addResult() {
            if (!vm.indicator.results)
                vm.indicator.results = {};

            vm.indicator.results[vm.selectedResult.date.getTime()] = {
                value: vm.selectedResult.value
            };

            vm.selectedResult = {};
        }

      function assert (condition, message) {
        if (!condition) {
          throw message || "Assertion failed";
        }
      }

      // Will try to remove from Docstore/kpi-result a target/result record if it were
      // already loaded into
      // `kpi` is the complete object, d is the date object representing the date for which
      // should be removed the record
      function removeKpiResult(kpi, d, cb) {
        console.dir(kpi);
        console.dir(d);
        assert(typeof kpi === 'object', 'KPI should be an object');
        assert(typeof d === 'object');
        assert(typeof kpi.id === 'string', 'KPI ID should be a string');
        // o delete precisa ser feito usando id no formato '1hprs8r1bmjyl/20210201'
        const id = kpi.id + '/' + d3.time.format('%Y%m%d')(d);
        Docstore.delete(
          {
            type: 'kpi-result',
            id: id
          },
          cb
        )
      }

      function removeResult(result) {
        removeKpiResult(
          vm.indicator,
          new Date(parseInt(result)),
          function(r){
            if (r.success) {
              delete vm.indicator.results[result];
              if (isEmpty(vm.indicator.results)) {
                delete vm.indicator.results;
              }
            } else {
              alert('Não foi possível remover o resultado. Contacte o administrador do sistema');
            }
          }
        )
      }

        function isEmpty(ob) {
            for (var i in ob) {
                return false;
            }
            return true;
        }

        // Salva os dados do indicador
        function saveIndicator() {
            if (!vm.indicator.departmentId)
                vm.indicator.departmentId = departmentId;

          vm.btnSaveLbl = 'Aguarde...';
          vm.btnSaveEnb = false;
            KpiIndicators.salvar(vm.indicator, true).then(function (res) {
                vm.loadKpiValues();
                vm.btnSaveLbl = 'Pronto';
            });
        }

        function emitRefresh() {
            $rootScope.$broadcast('refreshindicator');
        }

        function loadKpiValues() {
            var data = LoadKpiValuesEndpoint.query({
                paramdepartment_key: vm.indicator.departmentId,
                paramkpi_key: vm.indicator.id,
                paramskip_automated_extraction: vm.indicator.automatedExtractionQuery ? 'no' : 'yes'
            });

            data.$promise.then(function (res) {
                vm.lastUpdate = new Date();
                $mdDialog.hide();
            }, function (e) {
                console.log(e.message);
            });
        }

        function onlyFirstDay(date) {
            if (vm.indicator.results)
                if (vm.indicator.results[date.getTime()]) return false;

            var day = date.getDate();
            return day === 1;
        }

      vm.isAddDisabled = function() {
        return (typeof vm.selectedResult.value) === 'undefined' || (vm.selectedResult.value != vm.selectedResult.confirm) || (!vm.selectedResult.date);
      }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.activiti', [])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $stateProvider)
    {   
        // Tasks
        $stateProvider.state('app.tasks', {
            parent   : 'app',
            url: '/home/tarefas',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/home/apps/activiti/tasks.html',
                    controller : 'TasksController as vm'
                }
            },
            resolve  : {
                TasksList: getTasksList
            },
            bodyClass: 'todo',
            authenticate: true
        });
        
        function getTasksList(Tasks, $rootScope, $q, AuthService)
        {
            var deferred = $q.defer();
            
            var data = Tasks.get({
                "size": 1000, 
                "owner": AuthService.authSessions.activitiSession.username
            });
            
            data.$promise.then(function(res){
                $rootScope.activeContextApp = 'main';
                deferred.resolve(res);
            }, function(e){
                console.log(e);
            });

            return deferred.promise;
        }
    }
})();
(function(){
    'use strict';
    
    angular
        .module('app.activiti')
        .filter('priority', PriorityFilter);
    
    function PriorityFilter(){
        return function(input){
            var result;

            if (input >= 0){
                if (input <= 35)
                    result = 'Baixa prioridade';
                else if (input <= 70)
                    result = 'Média prioridade';
                else
                    result = 'Alta prioridade';
            } else {
                result = 'Baixa prioridade (indefinida)';
            }
            
            return result;
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.activiti')
        .controller('TaskDialogController', TaskDialogController);

    /** @ngInject */
    function TaskDialogController($mdDialog, Task, TasksList, Tasks, event, FormData, ActivitiDataHandlerService, $rootScope, $http, AuthService, $mdToast, fuseTheming, UsersList, history)
    {
        var vm = this;

        // Adicionar nova tarefa
        if ( !Task )
        {
            vm.title = 'Nova tarefa';
            vm.task = {};
            vm.task.dueDate = null;
            vm.newTask = true;
        } else {
            vm.title = 'Dados da tarefa: #' + Task.id;
            vm.task = angular.copy(Task);
            vm.tasks = TasksList;
            vm.newTask = false;
        }

        // Methods
        vm.users = UsersList;
        vm.history = history;
        vm.finishTask = finishTask;
        vm.delegateTask = delegateTask;
        vm.closeDialog = closeDialog;
        vm.createTask = createTask;
        vm.themes = fuseTheming.themes;
        
        function finishTask(taskId)
        {
            if (vm.task.delegationState === 'pending'){
                var resource = new Tasks();
                resource.action = "resolve";
                
                resource.$save({"taskId": taskId}, function () {
                    emitRefresh();
                    $mdDialog.hide(resource.action);
                });
            } else {
                if (typeof vm.task.propertyForSaving != "undefined") {
                    var 
                        objectToSave = ActivitiDataHandlerService.extractDataFromForm(vm.task),
                        resource = new FormData();

                    resource.taskId = taskId;
                    resource.properties = objectToSave.properties;

                    resource.$save(function(){
                        emitRefresh();
                        $mdDialog.hide('complete');
                    });                
                } else {
                    var resource = new Tasks();
                    resource.action = "complete";

                    resource.$save({"taskId": taskId}, function () {
                        emitRefresh();
                        $mdDialog.hide(resource.action);
                    });
                }
            }
        }
        
        function delegateTask(taskId)
        {
            var resource = new Tasks();
            resource.action = "delegate";
            resource.assignee = vm.task.assigneeTmp;
            resource.$save({"taskId": taskId}, function () {
                emitRefresh();
                $mdDialog.hide(resource.action);
            });
        }

        function closeDialog()
        {
            $mdDialog.cancel();
        }
        
        function createTask()
        {
            if (vm.newTask && vm.task.name) {
                var newTask = new Tasks();
                newTask.name = vm.task.name;
                newTask.description = vm.task.description;
                newTask.dueDate = vm.task.dueDate;
                newTask.owner = AuthService.authSessions.activitiSession.username;
                newTask.assignee = vm.task.assignee || newTask.owner;
                if (newTask.assignee != newTask.owner)
                    newTask.delegationState = 'pending';
                newTask.priority = vm.task.priority;
                newTask.parentTaskId = vm.task.parentTaskId;
                newTask.$save(function(){
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Tarefa criada com sucesso!')
                        .position('bottom right')
                        .hideDelay(3000)
                    );
                    emitRefresh();
                    $mdDialog.hide('create');
                });
            }
        }
        
        function emitRefresh() {
            $rootScope.$broadcast('refreshtasks');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.activiti')
        .controller('ProcessDialogController', ProcessDialogController);

    /** @ngInject */
    function ProcessDialogController($mdDialog, $rootScope, Process, ProcessDefinition, ActivitiDataHandlerService, FormData, fuseTheming)
    {
        var vm = this;

        vm.title = Process.name || ActivitiDataHandlerService.getNameFromResource(Process.resource);
        vm.process = angular.copy(Process);

        // Methods
        vm.startProcess = startProcess;
        vm.closeDialog = closeDialog;
        vm.themes = fuseTheming.themes;
        
        function startProcess(processId)
        {
            if (typeof vm.process.propertyForSaving != "undefined") {
                var 
                    objectToSave = ActivitiDataHandlerService.extractDataFromForm(vm.process),
                    resource = new FormData();
                
                resource.processDefinitionId = processId;
                //resource.businessKey = Process.businessKey;
                resource.properties = objectToSave.properties;
                
                resource.$save(function(){
                    emitRefresh();
                    $mdDialog.hide();
                });
            } else {
                /*var resource = new ProcessDefinition();
                resource.action = "complete";
                resource.$save({"processDefinitionId": processId}, function () {
                    emitRefresh();
                    $mdDialog.hide();
                });*/
            }
        }

        function closeDialog()
        {
            $mdDialog.cancel();
        }
        
        function emitRefresh() {
            $rootScope.$broadcast('refreshtasks');
        }
    }
})();
(function(){
    'use strict';
    
    angular
        .module('app.kpi')
        .controller('IndicatorResultsController', IndicatorResultsController);
    
    function IndicatorResultsController($state, $scope, $stateParams)
    {        
        var vm = this;
        
        vm.departmentId = $stateParams.departmentId;
        vm.indicatorId = $stateParams.indicatorId;
    }
}());
(function () {
    'use strict';

    angular
        .module('app.admintools', ['datatables'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $stateProvider) {

        // ADMIN
        $stateProvider.state('app.admintools', {
            parent: 'app',
            url: '/home/ferramentas-administrativas/dados',
            views: {
                'content@app': {
                    templateUrl: 'app/main/home/apps/admin/admin-tools.html',
                    controller: 'AdminToolsController as vm'
                }
            },
            resolve: {
                DepartmentsList: function ($rootScope) {
                    $rootScope.activeContextApp = 'main';
                    return {};
                }
            },
            authenticate: true
        });

        $stateProvider.state('app.admintools.usersdepartments', {
            parent: 'app',
            url: '/usuarios-departamentos',
            views: {
                'content@app': {
                    templateUrl: 'app/main/home/apps/admin/usersdepartments/usersdepartments.html',
                    controller: 'UserDepartmentController as vm'
                }
            },
            resolve: {
                DepartmentsList: function ($rootScope) {
                    $rootScope.activeContextApp = 'main';
                    return {};
                },
                Context: function ($rootScope) {
                    return $rootScope.getContext
                }
            },
            authenticate: true
        });

        $stateProvider.state('app.admintools.department', {
            parent: 'app',
            url: '/departamentos',
            views: {
                'content@app': {
                    templateUrl: 'app/main/home/apps/admin/department/department.html',
                    controller: 'DepartmentController as vm'
                }
            },
            resolve: {
                DepartmentsList: function ($rootScope) {
                    $rootScope.activeContextApp = 'main';
                    return {};
                },
                Context: function ($rootScope) {
                    return $rootScope.getContext
                }
            },
            authenticate: true
        });

        // DB-ASSOCIATION
        $stateProvider.state('app.admintools.dbassociation', {
            parent: 'app.admintools',
            url: '/associacao-de-cadastros',
            views: {
                'tools@app.admintools': {
                    templateUrl: 'app/main/home/apps/admin/db-association/db-association.html',
                    controller: 'DBAssociationController as vm'
                }
            },
            params: {},
            authenticate: true
        });

        // ACTION PLAN WITHOUT DEPARTMENT
        $stateProvider.state('app.admintools.acwithoutdept', {
            parent: 'app.admintools',
            url: '/planos-de-acao-sem-departamentos',
            views: {
                'tools@app.admintools': {
                    templateUrl: 'app/main/home/apps/admin/ation-plan-without-department/ac-without-dept.html',
                    controller: 'ACWithoutDeptController as vm'
                }
            },
            params: {},
            authenticate: true
        });
    }
})();
(function (module) {
    'use strict';

    module.controller('DepartmentDialogController', function (Departamento, UsersList, $scope, $mdDialog, fuseTheming, $mdToast, KpiDepartments) {

        if (!Departamento) {
            $scope.departamento = {};
            $scope.departamento;
            $scope.edicao = 0;
        } else {
            $scope.departamento = angular.copy(Departamento);
            $scope.edicao = 1;
        }

        $scope.users = UsersList;
        $scope.themes = fuseTheming.themes;

        $scope.fechar = function () {
            $mdDialog.hide();
        };

        $scope.salvarDepartamento = function () {
            KpiDepartments.salvar($scope.departamento, $scope.edicao).then(function success(response) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Departamento ' + ($scope.edicao ? 'editado' : 'criado') + ' com sucesso!')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                $scope.departamento = {};
                $mdDialog.hide(true);
            }, function error(response) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Ocorreu um erro ao cadastrar o departamento! ' + response.statusText)
                    .position('bottom right')
                    .hideDelay(3000)
                );
            });
        };
    });

}(angular.module('app.admintools')));
(function (module) {
    'use strict';

    module.controller('DepartmentController', ['$scope', '$http', 'PENTAHO_APP_URL', '$cookies', 'User', '$timeout', '$mdDialog', '$document', '$rootScope', '$httpParamSerializerJQLike', '$mdToast', 'KpiDepartments', 'DTOptionsBuilder', 'DT_LANGUAGE', 'DTColumnDefBuilder',
        function ($scope, $http, PENTAHO_APP_URL, $cookies, User, $timeout, $mdDialog, $document, $rootScope, $httpParamSerializerJQLike, $mdToast, KpiDepartments, DTOptionsBuilder, DT_LANGUAGE, DTColumnDefBuilder) {

            getListaUsers();

            $scope.dtOptions = DTOptionsBuilder.newOptions().withLanguage(DT_LANGUAGE);

            $scope.dtInstance = {};

            $scope.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(4).notSortable(),
                DTColumnDefBuilder.newColumnDef(5).notSortable()
            ];

            ($scope.getDepartamentos = function () {
                $scope.isAdmin = ($rootScope.userContext.isAdmin || $rootScope.userContext.isQualityManager);
                $scope.loading = 1;

                KpiDepartments.getDepartamentos().then(function success(response) {
                    $scope.departamentos = KpiDepartments.format(response.data.documents);

                    $timeout(function () {
                        $scope.loading = 0;
                    }, 500);
                }, function error(response) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Ocorreu um erro ao buscar os departamentos!')
                        .position('bottom right')
                        .hideDelay(3000)
                    );

                    $timeout(function () {
                        $scope.loading = 0;
                    }, 500);
                });
            })();

            $scope.excluirDepartamento = function (departamento) {
                KpiDepartments.delete(departamento).then(function success(response) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Departamento excluído com sucesso!')
                        .position('bottom right')
                        .hideDelay(3000)
                    );
                    $scope.getDepartamentos();
                }, function error(response) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Ocorreu um erro ao excluir o departamento!')
                        .position('bottom right')
                        .hideDelay(3000)
                    );
                });
            };

            $scope.openDialogChangeResponsible = function (ev, departamento) {
                $mdDialog.show({
                    controller: 'DepartmentChangeResponsibleDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/home/apps/admin/department/department.change-responsible.modal.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        Departamento: departamento,
                        UsersList: $scope.usuarios,
                        event: ev
                    }
                }).then(function (action) {
                    if (action)
                        $scope.getDepartamentos();
                });
            };

            $scope.openDialog = function (ev, departamento) {
                $mdDialog.show({
                    controller: 'DepartmentDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/home/apps/admin/department/department.modal.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        Departamento: departamento,
                        UsersList: $scope.usuarios,
                        event: ev
                    }
                }).then(function (action) {
                    if (action)
                        $scope.getDepartamentos();
                });
            };

            function getListaUsers() {
                User.get(function (res) {
                    $scope.usuarios = res.data;
                });
            };
        }
    ]);

    module.directive('uppercase', function () {
        return {
            restrict: "A",
            require: "?ngModel",
            link: function (scope, element, attrs, ngModel) {

                ngModel.$parsers.push(function (input) {
                    return input ? input.toUpperCase() : "";
                });

                element.css("text-transform", "uppercase");
            }
        };
    });
}(angular.module('app.admintools')));
(function (module) {
    'use strict';

    module.controller('DepartmentChangeResponsibleDialogController', function (Departamento, UsersList, $scope, $mdDialog, fuseTheming, $mdToast, KpiDepartments) {

        $scope.departamento = angular.copy(Departamento);
        $scope.edicao = 1;

        $scope.responsible = angular.copy($scope.departamento.responsible);

        $scope.departamento.responsible = undefined;

        $scope.users = UsersList;
        $scope.themes = fuseTheming.themes;

        $scope.fechar = function () {
            $mdDialog.hide(false);
        };

        $scope.salvarDepartamento = function () {
            KpiDepartments.salvar($scope.departamento, $scope.edicao).then(function success(response) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Departamento editado com sucesso!')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                $scope.departamento = {};
                $mdDialog.hide(true);
            }, function error(response) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Ocorreu um erro ao cadastrar o departamento! ' + response.statusText)
                    .position('bottom right')
                    .hideDelay(3000)
                );
            });
        };
    });

}(angular.module('app.admintools')));
(function (module) {
    'use strict';

    module.controller('UserDepartmentDialogController', function (ListUserDepartments, UserDepartments, UsersList, DepartamentList, $scope, $mdDialog, fuseTheming, $mdToast, UserDepartmentsService) {

        if (!UserDepartments) {
            $scope.userDepartments = {};
            $scope.edicao = 0;
        } else {
            $scope.userDepartments = angular.copy(UserDepartments);
            $scope.edicao = 1;
        }

        $scope.users = UsersList;
        $scope.themes = fuseTheming.themes;
        $scope.departments = DepartamentList;

        $scope.close = function () {
            $mdDialog.hide();
        };

        $scope.save = function () {

            var x = _.find(ListUserDepartments, function (item) {
                return item.user === $scope.userDepartments.user && item.id !== $scope.userDepartments.id;
            });

            if (x) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('O usuário selecionado já possui associações!')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                return;
            }

            UserDepartmentsService.save($scope.userDepartments, $scope.edicao).then(function success(response) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Associações realizadas com sucesso!')
                    .position('bottom right')
                    .hideDelay(3000)
                );
                $scope.userDepartments = {};
                $mdDialog.hide(true);
            }, function error(response) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Ocorreu um erro ao processar a solicitação ' + response.statusText)
                    .position('bottom right')
                    .hideDelay(3000)
                );
            });
        };
    });

}(angular.module('app.admintools')));
(function (module) {
    'use strict';

    module.controller('UserDepartmentController', ['$scope', 'KpiDepartments', '$http', 'PENTAHO_APP_URL', '$cookies', 'User', '$timeout', '$mdDialog', '$document', '$rootScope', '$httpParamSerializerJQLike', '$mdToast', 'UserDepartmentsService', 'DTOptionsBuilder', 'DT_LANGUAGE', 'DTColumnDefBuilder',
        function ($scope, KpiDepartments, $http, PENTAHO_APP_URL, $cookies, User, $timeout, $mdDialog, $document, $rootScope, $httpParamSerializerJQLike, $mdToast, UserDepartmentsService, DTOptionsBuilder, DT_LANGUAGE, DTColumnDefBuilder) {

            $scope.dtOptions = DTOptionsBuilder.newOptions().withLanguage(DT_LANGUAGE);

            $scope.dtInstance = {};

            $scope.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(2).notSortable(),
                DTColumnDefBuilder.newColumnDef(3).notSortable()
            ];

            ($scope.getUsers = function () {
                User.get(function (res) {
                    $scope.usuarios = res.data;
                });
            })();

            $scope.getDepartamentos = function () {
                KpiDepartments.getDepartamentos().then(function success(response) {
                    $scope.departamentos = KpiDepartments.format(response.data.documents);

                    $timeout(function () {
                        $scope.loading = 0;
                    }, 500);
                }, function error(response) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Ocorreu um erro ao buscar os departamentos!')
                        .position('bottom right')
                        .hideDelay(3000)
                    );

                    $timeout(function () {
                        $scope.loading = 0;
                    }, 500);
                });
            };

            ($scope.get = function (notReloadDepartments) {
                $scope.isAdmin = ($rootScope.userContext.isAdmin || $rootScope.userContext.isQualityManager);
                $scope.loading = 1;

                UserDepartmentsService.get().then(function success(response) {
                    $scope.listUserDepartments = UserDepartmentsService.format(response.data.documents);

                    if (notReloadDepartments) {
                        $timeout(function () {
                            $scope.loading = 0;
                        }, 500);
                    } else {
                        $scope.getDepartamentos();
                    }
                }, function error(response) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Ocorreu um erro ao buscar os cadastros!')
                        .position('bottom right')
                        .hideDelay(3000)
                    );

                    $timeout(function () {
                        $scope.loading = 0;
                    }, 500);
                });
            })();

            $scope.delete = function (departamento) {
                UserDepartmentsService.delete(departamento).then(function success(response) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Excluído com sucesso!')
                        .position('bottom right')
                        .hideDelay(3000)
                    );
                    $scope.get();
                }, function error(response) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Ocorreu um erro ao excluir!')
                        .position('bottom right')
                        .hideDelay(3000)
                    );
                });
            };

            $scope.openDialog = function (ev, userDepartments) {
                $mdDialog.show({
                    controller: 'UserDepartmentDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/home/apps/admin/usersdepartments/usersdepartments.modal.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        ListUserDepartments: $scope.listUserDepartments,
                        UserDepartments: userDepartments,
                        UsersList: $scope.usuarios,
                        DepartamentList: $scope.departamentos,
                        event: ev
                    }
                }).then(function (action) {
                    if (action)
                        $scope.get(true);
                });
            };

            $scope.showDepartments = function (ev, userDepartments) {
                $mdDialog.show({
                    controller: 'ShowDepartmentsDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/home/apps/admin/usersdepartments/showdepartments.modal.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        UserDepartments: userDepartments,
                        DepartamentList: $scope.departamentos,
                        event: ev
                    }
                });
            };
        }
    ]);

    module.directive('uppercase', function () {
        return {
            restrict: "A",
            require: "?ngModel",
            link: function (scope, element, attrs, ngModel) {

                ngModel.$parsers.push(function (input) {
                    return input ? input.toUpperCase() : "";
                });

                element.css("text-transform", "uppercase");
            }
        };
    });
}(angular.module('app.admintools')));
(function (module) {
    'use strict';

    module.controller('ShowDepartmentsDialogController', function (UserDepartments, DepartamentList, $scope, $mdDialog, fuseTheming, $mdToast, DT_LANGUAGE) {

        $scope.userDepartments = angular.copy(UserDepartments);

        $scope.themes = fuseTheming.themes;
        $scope.departments = DepartamentList;

        $scope.dtOptions = {
            ordering: false,
            searching: false,
            paging: false,
            language: DT_LANGUAGE
        };

        $scope.dtInstance = {};

        $scope.close = function () {
            $mdDialog.hide();
        };
    });

}(angular.module('app.admintools')));
(function(){
    'use strict';
    
    angular
        .module('app.admintools')
        .controller('DBAssociationController', DBAssociationController);
    
    function DBAssociationController($state, $scope, $stateParams, EntitiesEndpoint, SourcesEndpoint, SourceItemsEndpoint, MasterItemsEndpoint, MappingsEndpoint)
    {        
        var vm = this;
        
        vm.name = 'ASSOCIAÇÃO DE CADASTROS';
        vm.searchMaster = '';
        vm.searchSource = '';
        vm.currentTabIndex = 0;
        vm.selectedMasterEntity = null;
        vm.selectedSource = null;
        vm.sourceItems = [];
        vm.masterItems = [];
        vm.linkedItems = [];
        vm.sourceItensSelected = 0;
        vm.wait = false;
        
        vm.sortableOptions = {
            handle        : '.handle',
            forceFallback : false,
            ghostClass    : 'item-placeholder',
            fallbackClass : 'item-placeholder',
            fallbackOnBody: true,
            sort          : true
        };
        
        vm.entities = EntitiesEndpoint.query({}, function(res){
            //Sucesso
        }, function(e){
            console.log(e.message);
        });
        
        $scope.$watch('vm.selectedMasterEntity', function(newValue){
            if (newValue){
                vm.sources = SourcesEndpoint.query({paramentity_key: newValue[0]}, function(res){
                    //Sucesso
                }, function(e){
                    console.log(e.message);
                })
            }
        });
        
        $scope.$watch('vm.selectedSource', function(newValue){
            // Verifica se o source e a entity foram definidos
            if (newValue && vm.selectedMasterEntity){
                // Obtém os itens associados...
                vm.linkedItems = MappingsEndpoint.query({
                    paramentity: vm.selectedMasterEntity[0],
                    paramsource: newValue[1]
                }, function(res_li){
                    // Em seguida obtém os itens da source
                    vm.sourceItems = SourceItemsEndpoint.query({
                        dataAccessId: vm.selectedSource[1] + '__' + vm.selectedMasterEntity[0]
                    }, function(res_si){
                        // Resolve o nome dos itens associados
                        angular.forEach(res_li.resultset, function(value, key){
                            var itemsNames = getItemsNames(value[3], value[2]);
                            value.sourceName = itemsNames.sourceItemName;
                            value.targetName = itemsNames.targetItemName;
                        });
                        
                        refreshPendingSourceItems();
                    }, function(e){
                       console.log(e.message); 
                    });
                }, function(e){
                    console.log(e.message);
                });
            }
        });
        
        $scope.$watch('vm.selectedMasterEntity', function(newValue){
            if (newValue){
                vm.masterItems = MasterItemsEndpoint.query({
                    paramentity_key: vm.selectedMasterEntity[0]
                }, function(res){
                    //Sucesso
                }, function(e){
                   console.log(e.message); 
                });
            }
        });
        
        vm.linkedItems = {};
        
        vm.selectMasterEntity = selectMasterEntity;
        vm.selectSource = selectSource;
        vm.onlyCheckedFilter = onlyCheckedFilter;
        vm.notLinkedFilter = notLinkedFilter;
        vm.linkItem = linkItem;
        vm.unlinkItem = unlinkItem;
        vm.countSourceItemsSelected = countSourceItemsSelected;
        vm.preventDefault = preventDefault;
        
        function selectMasterEntity(item)
        {
            vm.sourceItems = null;
            vm.sources = null;
            
            vm.selectedMasterEntity = item;
            item.selected = true;
            vm.currentTabIndex = 1;
        }
        
        function selectSource(item)
        {
            vm.selectedSource = item;
        }
        
        function onlyCheckedFilter(item)
        {
            if (vm.showOnlyChecked)
                return item.selected === true;
            else
                return true;
        }
        
        function notLinkedFilter(item)
        {
            return !(item.linked === true);
        }
        
        function linkItem(masterItem)
        {
            angular.forEach(vm.sourceItems.resultset, function(value){
                if (value.selected === true && !(value.linked)){
                    var objToSave = {};
                    value.selected = false;
                    
                    objToSave.paramentity = vm.selectedMasterEntity[0];
                    objToSave.paramsource = vm.selectedSource[1];
                    objToSave.paramsource_code = value[0];
                    objToSave.paramtarget_code = masterItem[0];
                    objToSave.paramlinked = 1;
                    
                    saveLinkedItem(objToSave);
                }
            });
            vm.searchMaster = '';
            vm.searchSource = '';
            refreshPendingSourceItems();
        }
        
        function saveLinkedItem(params)
        {
            MappingsEndpoint.save(params, function(res){
                vm.linkedItems = [];
               // Obtém os itens associados...
                vm.linkedItems = MappingsEndpoint.query({
                    paramentity: vm.selectedMasterEntity[0],
                    paramsource: vm.selectedSource[1]
                }, function(res_li){
                    // Resolve o nome dos itens associados
                    angular.forEach(res_li.resultset, function(value, key){
                        var itemsNames = getItemsNames(value[3], value[2]);
                        value.sourceName = itemsNames.sourceItemName;
                        value.targetName = itemsNames.targetItemName;
                    });
                }, function(e){
                    console.log(e.message);
                });
            }, function(e){
                console.log(e.message);
            });
        }
        
        function unlinkItem(item)
        {
            var objToSave = {};
            objToSave.paramentity = vm.selectedMasterEntity[0];
            objToSave.paramsource = vm.selectedSource[1];
            objToSave.paramsource_code = item[3];
            objToSave.paramtarget_code = item[2];
            objToSave.paramlinked = 0;
                    
            saveLinkedItem(objToSave);
        }
        
        function countSourceItemsSelected(itemChecked)
        {
            itemChecked ? vm.sourceItensSelected++ : vm.sourceItensSelected--;
        }
        
        function getItemsNames(sourceItemCode, targetItemCode)
        {
            var res = {
                sourceItemName: '',
                targetItemName: ''
            }
            
            if (sourceItemCode){
                angular.forEach(vm.sourceItems.resultset, function(value, key){
                    if (value[0] == sourceItemCode)
                        res.sourceItemName = value[1];
                });
            }
            
            if (targetItemCode){
                angular.forEach(vm.masterItems.resultset, function(value, key){
                    if (value[0] == targetItemCode)
                        res.targetItemName = value[1];
                });
            }
            
            return res;
        }
        
        function refreshPendingSourceItems()
        {
            var linkedRef = {};
            angular.forEach(vm.linkedItems.resultset, function(value, key){
                linkedRef[value[3]] = true;
            });
            
            // Captura somente os items pendentes (não associados)
            angular.forEach(vm.sourceItems.resultset, function(value, key){
                if (linkedRef[value[0]])
                    value.linked = true;
            });
        }
        
        function preventDefault(e)
        {
            e.preventDefault();
            e.stopPropagation();
        }
    }
}());
(function(){
    'use strict';
    
    angular
        .module('app.admintools')
        .controller('ACWithoutDeptController', ACWithoutDeptController);
    
    function ACWithoutDeptController($state, $scope, $rootScope, $stateParams, FixProcessInstances, KpiDepartments, KpiNonCompliances, ProcessInstances, SghqNonCompliances, $mdToast)
    {        
        var vm = this;
        
        vm.departments = KpiDepartments.getAllDepartments();
        vm.foundActionPlans = [];
        vm.actionPlan = null;
        vm.nonCompliance = null;
        vm.newProcess = null;
        vm.canFix = false;
        vm.selectedCase = '';
        vm.currentProcessInstanceId = '';
        vm.counter = {
            i: 0,
            currentDeparmentId: ''
        }
        vm.countDepartment = 0;
        
        vm.loadNC = loadNC;
        vm.fix = fix;
        
        vm.departments.$loaded(function(){
            fixProcessWithoutDepartmentId();
            vm.countDepartment = vm.departments.length;
        });
        
        function fixProcessWithoutDepartmentId()
        {
            $rootScope.loadingProgress = true;
            FixProcessInstances.get({}, function(res){
                angular.forEach(res.data, function(value){
                    var hasDId = false, 
                        hasNCId = false, 
                        NCId = '',
                        emailSubjectStr = '',
                        userName = '';
                    
                    angular.forEach(value.variables, function(v){
                        if (v.name == 'departmentId')
                            hasDId = true;
                        
                        if (v.name == 'nonComplianceId'){
                            hasNCId = true;
                            NCId = v.value;
                        }
                    });
                    
                    if ((hasNCId) && (!hasDId) /*&& (value.activityId == 'createActionPlan')*/){
                        vm.foundActionPlans.push({
                            name: 'ID DO PROCESSO: ' + value.id + ' | NCId: ' + NCId,
                            NCId: NCId,
                            PId: value.id
                        });
                        console.log('PId: ' + value.id + ' | NCId: ' + NCId);
                    }
                });
                
                $rootScope.loadingProgress = false;
            });
        }
        
        function loadNC(actionPlanRef)
        {
            vm.canFix = false;
            vm.currentProcessInstanceId = '';
            vm.selectedCase = actionPlanRef.NCId;
            $rootScope.loadingProgress = true;
            findNC(actionPlanRef);
        }
        
        function findNC(actionPlanRef)
        {            
            vm.nonCompliance = null;
            if (vm.counter.i < vm.countDepartment) {
                vm.counter.currentDeparmentId = vm.departments[vm.counter.i].$id;
                var nonCompliances = null;
                nonCompliances = KpiNonCompliances.getAll(vm.counter.currentDeparmentId);
                nonCompliances.$loaded(function(){
                    var found = false;
                    angular.forEach(nonCompliances, function(value, key){
                        if (actionPlanRef.NCId == value.$id) {
                            vm.nonCompliance = SghqNonCompliances.getByKey(value.occurrenceDepartment, value.$id);
                            console.log('NAO CONFORMIDADE: ', vm.nonCompliance)
                            
                            vm.nonCompliance.$loaded(function(){
                                vm.canFix = true;
                            });
                            
                            found = true;
                        }
                    });
                    
                    if (!found){
                        vm.counter.i++;
                        vm.counter.currentDeparmentId = '';
                        vm.loadNC(actionPlanRef);
                    } else {
                        vm.counter.i = 0;
                        $rootScope.loadingProgress = false;
                        vm.currentProcessInstanceId = actionPlanRef.PId;
                    }
                });
            } else {
                $rootScope.loadingProgress = false;
            }
        }
        
        function fix()
        {
            if (vm.currentProcessInstanceId) {
                vm.processKey = 'registrar_nao_conformidade';

                var obj = {
                    "processDefinitionKey": vm.processKey,
                    variables: [
                        {name: 'nonComplianceId', value: vm.nonCompliance.$id},
                        {name: 'departmentId', value: vm.nonCompliance.occurrenceDepartment}
                    ]
                }
                var resource = new ProcessInstances(obj);

                resource.$save(function (res) {
                    vm.processId = res.id;
                    
                    vm.newProcess = res.id;
                    
                    vm.nonCompliance.processId = vm.processId;

                    SghqNonCompliances.save(vm.nonCompliance, true).then(function(){

                        var sentObj = SghqNonCompliances.getSentByKey(vm.nonCompliance.claimant, vm.nonCompliance.$id);
                        sentObj.$loaded(function(){
                            sentObj.processId = vm.processId;
                            SghqNonCompliances.save(sentObj, true);

                            obj = {
                                "processInstance": vm.currentProcessInstanceId
                            }
                            var oldProcessResource = new ProcessInstances(obj);
                            
                            oldProcessResource.$delete({action: "suspend"})
                            .then(function(res){
                                console.log('NEW PROCESS: ', res);
                                
                                $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Processo corrigido com sucesso!')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                );
                            }, function(e){
                                console.log(e.message);
                                
                                $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('A correção do processo falhou!')
                                    .position('bottom right')
                                    .hideDelay(3000)
                                );
                            });
                        });
                        console.log('SENT NC: ', sentObj);
                    }, function(e){
                        console.log(e);
                    });
                }, function(e){
                    console.log(e.message);
                });
            }
        }
    }
}());

//159567, 159597
(function(){
    'use strict';
    
    angular.module('app.pentaho-connector.pentaho-viewer', []);
}());
(function () {
    'use strict';

    angular.module('app.pentaho-connector.pentaho-viewer')
        .controller('TabController', TabController);

    /** ngInject **/
    function TabController(PentahoConnectorService, $scope) {
        var vm = this;

        var mainViewContainer = $('#main');
        vm.iframeHeight = 0;
        var elScope = angular.element(mainViewContainer).scope();

        elScope.$watch(function () {
            return $(mainViewContainer).css('height');
        }, function (newValue) {
            var h = newValue;
            h = newValue.substr(0, newValue.indexOf('px'));
            h = h - 112;
            h = h + 'px';
            vm.iframeHeight = h;
        }, true);

        $(window).resize(function () {
            var newValue = $(mainViewContainer).css('height');

            $scope.$apply(function () {
                var h = newValue;
                h = newValue.substr(0, newValue.indexOf('px'));
                h = h - 112;
                h = h + 'px';
                vm.iframeHeight = h;
                console.log(vm.iframeHeight)
            });
        });
    }
}());
(function(){
    'use strict';
    
    angular.module('app.pentaho-connector.pentaho-viewer')
    .directive('pentahoTab', PentahoTabDirective);
    
    function PentahoTabDirective(){
        return {
            restrict: 'E',
            templateUrl: 'app/ppa-ui-core/pentaho-connector/pentaho-viewer/tab/tab.tmpl.html',
            controller: 'TabController as vm',
            bindToController: true,
            scope: {
              src: '@'
            },
            link: function(scope, elements, attrs){
              scope.src = attrs.src;
            }
        }
    }
}());
(function () {
    'use strict';

    angular.module('app.pentaho-connector.pentaho-viewer')
        .controller('PlaceholderController', PlaceholderController);

    /** ngInject **/
    function PlaceholderController($scope, PentahoViewerService, $state) {
        var vm = this;
        // Captura a aba ativa (nenhuma a princípio)
        $scope.indexCurrentTab = PentahoViewerService.tabs.active;
        // Captura as abas abertas (nenhuma a princípio)
        $scope.tabs = PentahoViewerService.tabs;

        vm.indexCurrentTab = $scope.indexCurrentTab;
        vm.tabs = $scope.tabs;
        vm.closeTab = closeTab;
        vm.setCurrent = setCurrent;
        vm.openNewTab = openNewTab;
        vm.current = 0;

        function setCurrent(index) {
            vm.current = index;
        }

        function openNewTab(url) {
            var win = window.open(url, '_blank');
            win.focus();
        }

        // Observa as alterações na aba ativa
        $scope.$watch('tabs.active', function () {
            vm.tabs = PentahoViewerService.tabs;
            vm.indexCurrentTab = PentahoViewerService.tabs.active;
            vm.current = PentahoViewerService.tabs.active;
        });

        // Invoca a função do PentahoViewerService responsável por fechar abas, passando o ID da aba como parâmetro
        function closeTab(id) {
            PentahoViewerService.closeTab(id);
        }
    }
}());
(function(){
    'use strict';
    
    angular.module('app.pentaho-connector.pentaho-viewer')
    .directive('pentahoPlaceholder', PentahoPlaceholderDirective);
    
    function PentahoPlaceholderDirective(){
        return {
            restrict: 'E',
            templateUrl: 'app/ppa-ui-core/pentaho-connector/pentaho-viewer/placeholder/placeholder.tmpl.html',
            scope: true,
            controller: 'PlaceholderController as vm',
            bindToController: true        
        }
    }
}());
(function(){
    'use strict';
    
    angular.module('app.admintools-data-handler', []);
}());
(function(){
    'use strict';
    
    angular
        .module('app.admintools-data-handler')
        .factory('SourcesEndpoint', SourcesEndpoint);
    
    function SourcesEndpoint($resource, PENTAHO_APP_URL, AuthService)
    {
        return $resource(PENTAHO_APP_URL + '/plugin/cda/api/doQuery', 
            {
                path: '/system/ppa/endpoints/kettle/mappings.cda',
                dataAccessId: 'sources',
                paramentity_key: '@paramentity_key',
                kettleOutput: 'Json'
            },
            {
                query: {
                    method: 'get',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    }
                }
            });
    }
}());
(function(){
    'use strict';
    
    angular
        .module('app.admintools-data-handler')
        .factory('SourceItemsEndpoint', SourceItemsEndpoint);
    
    function SourceItemsEndpoint($resource, PENTAHO_APP_URL, AuthService)
    {
        return $resource(PENTAHO_APP_URL + '/plugin/cda/api/doQuery', 
            {
                path: '/system/ppa/endpoints/kettle/sourceItems.cda',
                dataAccessId: '@dataAccessId', //'$source_key__$entity_key'
                kettleOutput: 'Json'
            },
            {
                query: {
                    method: 'get',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    }
                }
            });
    }
}());
(function(){
    'use strict';
    
    angular
        .module('app.admintools-data-handler')
        .factory('Settings', Settings);
    
    function Settings($resource, PENTAHO_APP_URL, AuthService)
    {
        return $resource(PENTAHO_APP_URL + '/plugin/cda/api/doQuery', 
            {
                path: '/system/ppa/endpoints/kettle/settings.cda',
                dataAccessId: '@dataAccessId',
                kettleOutput: 'Json'
            },
            {
                query: {
                    method: 'get',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    },
                    params: {
                        paramcfgName: '@paramcfgName',
						paramusrName: '@paramusrName'
                    }
                },
                save: {
                    method: 'post',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    },
                    params: {
                        paramkey: '@paramkey',
                        paramvalue: '@paramvalue'
                    }
                }
            });
    }
}());
(function(){
    'use strict';
    
    angular
        .module('app.admintools-data-handler')
        .factory('ResultAnalisysEndpoint', ResultAnalisysEndpoint);
    
    function ResultAnalisysEndpoint($resource, PENTAHO_APP_URL, AuthService)
    {
        return $resource(PENTAHO_APP_URL + '/plugin/cda/api/doQuery',
            {
                kettleOutput: 'Json'
            },
            {
                query: {
                    method: 'get',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    }
                }
            });
    }
}());
(function(){
    'use strict';
    
    angular
        .module('app.admintools-data-handler')
        .factory('MasterItemsEndpoint', MasterItemsEndpoint);
    
    function MasterItemsEndpoint($resource, PENTAHO_APP_URL, AuthService)
    {
        return $resource(PENTAHO_APP_URL + '/plugin/ppa/api/entityItems', 
            {
                paramentity_key: '@paramentity_key',
                kettleOutput: 'Json'
            },
            {
                query: {
                    method: 'get',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    }
                }
            });
    }
}());
(function(){
    'use strict';
    
    angular
        .module('app.admintools-data-handler')
        .factory('MappingsEndpoint', MappingsEndpoint);
    
    function MappingsEndpoint($resource, PENTAHO_APP_URL, AuthService)
    {
        return $resource(PENTAHO_APP_URL + '/plugin/ppa/api/mappings', 
            {
                kettleOutput: 'Json'
            },
            {
                query: {
                    method: 'get',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    },
                    params: {
                        paramentity: '@paramentity',
                        paramsource: '@paramsource',
                        parammethod: 'GET'
                    }
                },
                save: {
                    method: 'post',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    },
                    params: {
                        paramentity: '@paramentity',
                        paramsource: '@paramsource',
                        paramsource_code: '@paramsource_code',
                        paramtarget_code: '@paramtarget_code',
                        paramlinked: '@paramlinked',
                        parammethod: 'POST'
                    }
                }
            });
    }
}());
(function(){
    'use strict';
    
    angular
        .module('app.admintools-data-handler')
        .factory('LoadKpiValuesEndpoint', LoadKpiValuesEndpoint);
    
    function LoadKpiValuesEndpoint($resource, PENTAHO_APP_URL, AuthService)
    {
        return $resource(PENTAHO_APP_URL + '/plugin/ppa/api/loadKpiValues', 
            {
                kettleOutput: 'Json'
            },
            {
                query: {
                    method: 'get',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    }
                }
            });
    }
}());
(function(){
    'use strict';
    
    angular
        .module('app.admintools-data-handler')
        .factory('EntitiesEndpoint', EntitiesEndpoint);
    
    function EntitiesEndpoint($resource, PENTAHO_APP_URL, AuthService)
    {
        return $resource(PENTAHO_APP_URL + '/plugin/cda/api/doQuery', 
            {
                path: '/system/ppa/endpoints/kettle/mappings.cda',
                dataAccessId: 'entities',
                kettleOutput: 'Json'
            },
            {
                query: {
                    method: 'get',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    }
                }
            });
    }
}());
(function(){
    'use strict';

    angular
        .module('app.admintools-data-handler')
        .factory('Docstore', Docstore);

    function Docstore($resource, PENTAHO_APP_URL, AuthService) {
        var url = PENTAHO_APP_URL + '/plugin/ppa/api/docstore',
            defparam = null,
            actions = {
                read: {
                    method: 'get',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    },
                    params: {
                        parammethod: 'GET',
                        paramtype: '@type'
                    }
                },
              delete: {
                method: 'post',
                headers: {
                  'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                  'Content-Type': 'application/json'
                },
                params: {
                  parammethod: 'DELETE',
                  paramtype: '@type',
                  paramid: '@id'
                }
              }
            };

        return $resource(url, defparam, actions);
    }
}());

/*
(defn delete! [{:keys [type id handler]}]
  {:pre [(seq type) (seq id)]}
  (POST endpoint-path
        {:params {:parammethod "DELETE"
                  :paramtype   type
                  :paramid     id}
         :format :raw
         :response-format :json
         :keywords? true
         :error-handler #(js/console.error %)
         :handler (or handler #(js/console.dir %))}))
         */

(function(){
    'use strict';
    
    angular
        .module('app.admintools-data-handler')
        .factory('ConvertQueryToCDAEndpoint', ConvertQueryToCDAEndpoint);
    
    function ConvertQueryToCDAEndpoint($resource, PENTAHO_APP_URL, AuthService)
    {
        return $resource(PENTAHO_APP_URL + '/plugin/ppa/api/convertExtractionQuerytoCda', 
            {
                kettleOutput: 'Json'
            },
            {
                query: {
                    method: 'get',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    }
                }
            });
    }
}());
(function(){
    'use strict';

    angular
        .module('app.admintools-data-handler')
        .factory('CDAQuery', CDAQuery);

    function CDAQuery($resource, PENTAHO_APP_URL, AuthService)
    {
        return $resource(PENTAHO_APP_URL + '/plugin/cda/api/doQuery',
            {
                kettleOutput: 'Json'
            },
            {
                query: {
                    method: 'get',
                    headers: {
                        'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                        'Content-Type': 'application/json'
                    }
                }
            });
    }
}());

(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-data-handler', []);
}());
(function(){
  'use strict';
    
  angular
    .module('app.activiti-connector.activiti-data-handler')
    .factory('User', UserService);
    
  /** @ngInject */
  function UserService($resource, APP_CFG, ActivitiConf, PENTAHO_APP_URL/*, AuthService*/) {
    if (APP_CFG['ACTIVE_APPS'].indexOf('activiti') != -1) {
      return $resource(
               ActivitiConf.activitiRestBaseURL + '/service/identity/users/:user', 
               {user: "@user", size: ActivitiConf.activitiUserLoadLimit}
             )
    } else {
      return $resource(
               PENTAHO_APP_URL + '/api/users',
               {},
               {
                 get: {
                   method: 'get',
                   // headers: {
                   //   'Authorization': 'Basic ' + AuthService.authSessions.pentahoSession.authKey,
                   //   'Content-Type': 'application/json'
                   // },
                   transformResponse: function (cnv) {
                     var x2js = new X2JS();
                     var aftCnv = x2js.xml_str2json(cnv);
                     console.dir(aftCnv)
                     var u = aftCnv.users.user.map(function(u){
                       return {
                         id: u,
                         firstName: u,
                         lastName: null,
                         email: null,
                         pictureUrl: null,
                         url: null
                       }
                     });
                     return {data: u}
                   }
                 }
               }
             )
    }
  }
}());

(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-data-handler')
    .factory('Tasks', TasksService);
    
    /** @ngInject */
    function TasksService($resource, ActivitiConf, AuthService) {
        return $resource(ActivitiConf.activitiRestBaseURL + '/service/runtime/tasks/:taskId', 
                         {
                            taskId: '@taskId',
                            processInstanceId: '@processInstanceId',
                            includeProcessVariables: '@includeProcessVariables'
                         },
                         {
                            save: {
                                method: 'POST' 
                            },
                            update: {
                                method: 'POST'
                            }
                         });
    };
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-data-handler')
    .factory('TasksVariables', TasksVariablesService);
    
    /** @ngInject */
    function TasksVariablesService($resource, ActivitiConf) {
        return $resource(ActivitiConf.activitiRestBaseURL+'/service/runtime/tasks/:taskId/variables/:variableName', 
                         {
                            taskId: "@taskId", 
                            variableName: "@variableName"},
                            {
                                update: {
                                    method: 'PUT', 
                                    params: {
                                        taskId: "@taskId", 
                                        variableName: "@variableName"
                                    }
                                },
                                save: {
                                    method: 'POST', 
                                    params: {
                                        taskId: "@taskId"
                                    }, 
                                    isArray: true
                                }
                            });
    };
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-data-handler')
    .factory('ActivitiMetaTables', ActivitiMetaTablesService);
    
    /** @ngInject */
    function ActivitiMetaTablesService($resource, ActivitiConf, AuthService) {
        return $resource(ActivitiConf.activitiRestBaseURL + 
                         '/service/management/tables/:table/data?orderDescendingColumn=:orderDescendingColumn&size=:size', 
                         {
                            table: '@table',
                            orderDescendingColumn: '@orderDescendingColumn',
                            size: '@size'
                         });
    };
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-data-handler')
    .factory('SubTasks', SubTasksService);
    
    /** @ngInject */
    function SubTasksService($resource, ActivitiConf) {
        return $resource(ActivitiConf.activitiRestBaseURL + '/service/runtime/tasks/:taskId/subtasks', 
                         {taskId: "@taskId"},
                         {query: {
                             method: 'GET', 
                             isArray: true
                         }});
    };
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-data-handler')
    .factory('ActivitiUserRoles', ActivitiUserRolesService);
    
    /** @ngInject */
    function ActivitiUserRolesService($resource, ActivitiConf) {
        return $resource(ActivitiConf.activitiRestBaseURL + '/service/identity/groups', 
                         {member: "@member"});
    };
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-data-handler')
    .factory('ProcessInstances', ProcessInstancesService);
    
    /** @ngInject */
    function ProcessInstancesService($resource, ActivitiConf) {
        return $resource(ActivitiConf.activitiRestBaseURL + '/service/runtime/process-instances/:processInstance', 
                         {
                            processInstance: "@processInstance"
                         }, 
                         {
                            update: {
                                method: 'PUT',
                                params: {
                                    action: '@action'
                                }
                            },
                            delete: {
                                method: 'DELETE'
                            }
                         });
    };
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector', [
        
        //Autenticacao para o Activiti
        'app.activiti-connector.activiti-authentication',
        
        //Manipulador de dados e requisições REST
        'app.activiti-connector.activiti-data-handler'
    ]);
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector')
    .factory('ProcessInstance', ProcessInstanceService);
    
    /** @ngInject */
    function ProcessInstanceService($resource, ActivitiConf) {
        return $resource(ActivitiConf.activitiRestBaseURL + '/service/process-instance/:processInstance', 
                         {processInstance: "@processInstance"});
    };
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-data-handler')
    .factory('ProcessDefinition', ProcessDefinitionService);
    
    /** @ngInject */
    function ProcessDefinitionService($resource, ActivitiConf) {
        return $resource(ActivitiConf.activitiRestBaseURL + '/service/repository/process-definitions/:processDefinitionId', 
                         {processDefinitionId: "@processDefinitionId", size: 1000, suspended: "false"}, 
                         {update: {
                             method: 'PUT', 
                             params: {processDefinitionId: "@processDefinitionId"}
                         }});
    };
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-data-handler')
    .factory('HistoricTasks', HistoricTasksService);
    
    /** @ngInject */
    function HistoricTasksService($resource, ActivitiConf) {
        return $resource(ActivitiConf.activitiRestBaseURL + '/service/history/historic-task-instances/:taskId', 
                         {taskId: "@taskId", size: ActivitiConf.activitiUserLoadLimit},
                         {update: {
                             method: 'PUT', 
                             params: {taskId: "@taskId"}
                         }});
    };
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-data-handler')
    .factory('Group', GroupService);
    
    /** @ngInject */
    function GroupService($resource, ActivitiConf) {
        return $resource(ActivitiConf.activitiRestBaseURL + '/service/identity/groups/:group', 
                         {group: "@group"});
    };
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-data-handler')
    .factory('FormData', FormDataService);
    
    /** @ngInject */
    function FormDataService($resource, ActivitiConf) {
      return $resource(ActivitiConf.activitiRestBaseURL + '/service/form/form-data', 
                       {},
                       {
                        startTask: {
                           method:'GET',
                           params: {processDefinitionId: "@processDefinitionId"}
                       }});
    };
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-data-handler')
    .factory('FixProcessInstances', FixProcessInstancesService);
    
    /** @ngInject */
    function FixProcessInstancesService($resource, ActivitiConf) {
        return $resource(ActivitiConf.activitiRestBaseURL + 
                         '/service/runtime/process-instances/:processInstance?includeProcessVariables=true&size=10000', 
                         {});
    };
}());
(function () {
    angular.module('app.activiti-connector.activiti-data-handler')
        .factory('ActivitiConf', activitiConf);

    /** @ngInject */
    function activitiConf(ACTIVITI_APP_URL) {
        return {
            activitiRestBaseURL: ACTIVITI_APP_URL,
            activitiUserLoadLimit: '1200'
        };
    }
}());
(function(){
    'use strict';
    
    angular.module('app.kpi')
    .service('KpiService', KpiService);
    
    /** @ngInject */
    function KpiService($q, $document, $mdDialog, StateFactory, msNavigationService, APP_CFG)
    {
        var vm = this;
        
        // Métodos
        vm.initSideNav = initSideNav;

        // Cria o menu lateral dos processos
        function initSideNav()
        {   
            
        }
        
        // Exibe o modal de um indicador
        function loadIndicator(indicator) {
            openIndicatorDialog(null, indicator);
        };
        
        /**
         * Abre o modal de um indicador
         *
         * @param ev
         * @param indicator
         */
        function openIndicatorDialog(ev, indicator)
        {
            $mdDialog.show({
                controller         : 'IndicatorDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/home/apps/kpi/dialogs/indicators/indicator-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Indicator : indicator,
                    event: ev
                }
            })
            .then(function(){
                //console.log('Saiu!');
            });
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.kpi')
        .controller('KpiController', KpiController);

    /** @ngInject */
    function KpiController(fuseTheming, $q, $mdDialog, KpiDataHandlerService, KpiDepartments, KpiIndicators, KpiNonCompliances, $state, $rootScope, AuthService, APP_CFG, Tasks) {
        var vm = this;
        vm.departments = null;
        vm.indicators = null;
        vm.selectedDepartment = {
            name: 'Carregando...'
        };
        vm.lastUpdate = {};
        vm.canSelectDepartment = true;
        vm.statusFilters = [{
                name: 'Ativos',
                value: true
            },
            {
                name: 'Inativos',
                value: false
            }
        ];
        vm.kpiMeasureUnits = {
            percent: 'Percentual',
            pacient: 'Paciente',
            pacientday: 'Paciente/Dia',
            pacientbed: 'Paciente/Leito',
            bedday: 'Leito/Dia',
            day: 'Dias',
            hour: 'Horas',
            minute: 'Minutos',
            currency: 'Moeda',
            unit: 'Unidade',
            kg: 'Kilograma',
            ml: 'Mililitros',
          pmil: 'por Mil'
        }

        vm.selectedActiveFilter = vm.statusFilters[0];

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            vm.canSelectDepartment = toState.name === 'app.kpi';
        });

        vm.themes = fuseTheming.themes;

        // Métodos
        vm.selectDepartment = selectDepartment;
        vm.openIndicatorDialog = openIndicatorDialog;
        vm.openManualResultDialog = openManualResultDialog;
        vm.openIndicatorResults = openIndicatorResults;
        vm.newIndicator = newIndicator;
        vm.filterActive = filterActive;
        vm.toggleActive = toggleActive;
        vm.selectActiveFilter = selectActiveFilter;
        vm.showConfirm = showConfirm;

        //Obtém a listagem de departamentos
        //  vm.departments = KpiDepartments.getDepartments(AuthService.authSessions.pentahoSession.username);

        //  vm.departments.$loaded(function () {
        //     if (vm.departments.length > 0)
        //         selectDepartment(vm.departments[0]);
        //     else
        //         vm.selectedDepartment = {
        //             name: 'Nenhum disponível'
        //         };
        // });

        KpiDepartments.getDepartamentos().then(function success(response) {
            vm.departments = KpiDepartments.format(response.data.documents);
            if (vm.departments.length > 0)
                selectDepartment(vm.departments[0]);
            else
                vm.selectedDepartment = {
                    name: 'Nenhum disponível'
                };
        });

        // Vai para a view dos resultados do indicador
        function openIndicatorResults(indicator) {
            if (APP_CFG['ACTIVE_APPS'].indexOf('activiti') > -1) {
                $state.go('app.kpi.results', {
                    departmentId: indicator.departmentId,
                    departmentName: vm.selectedDepartment.name,
                    measureUnit: vm.kpiMeasureUnits[indicator.measureUnit],
                    indicatorId: indicator.id
                });
            }
        }

        // Seleciona o departamento
        function selectDepartment(department) {
            vm.selectedDepartment = department;
            // Obtém a listagem de indicadores para o departamento
            KpiIndicators.getIndicadores(department.id).then(function success(response) {
                vm.indicators = KpiIndicators.format(response.data.documents);
            });
        }

        // Abre o modal de edição/criação do indicador
        function openIndicatorDialog(ev, indicator, newIndicator) {
            $mdDialog.show({
                controller: 'IndicatorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/home/apps/kpi/dialogs/indicators/indicator-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Indicator: indicator,
                    departmentId: vm.selectedDepartment.id,
                    newIndicator: newIndicator
                }
            }).then(function (result) {
                selectDepartment(vm.selectedDepartment);
            });
        }

        // Abre o modal de criação de resultado manual
        function openManualResultDialog(ev, indicator) {
            $mdDialog.show({
                controller: 'ManualResultsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/home/apps/kpi/dialogs/manual-results/manual-results-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Indicator: indicator,
                    departmentId: vm.selectedDepartment.id
                }
            }).then(function (result) {
                vm.lastUpdate[indicator.id] = new Date();
                selectDepartment(vm.selectedDepartment);
            });
        }

        function showConfirm(ev, kpi) {

            var texto = (angular.isUndefined(kpi.active) || kpi.active === true) ? 'inativar' : 'ativar';

            var confirm = $mdDialog.confirm()
                .title('Confirmar ação')
                .textContent('Deseja realmente ' + texto + ' o indicador?')
                .targetEvent(ev)
                .ok('Sim')
                .cancel('Não');
            $mdDialog.show(confirm).then(function () {
                toggleActive(kpi);
            }, function () {});
        };

        function newIndicator(ev) {
            openIndicatorDialog(ev, null, true);
        }

        function filterActive(item) {
            return vm.selectedActiveFilter.value ? item.active !== false : item.active === false;
        }

        function toggleActive(indicator) {
            indicator.active = indicator.active === false ? true : false;
            KpiIndicators.salvar(indicator, true);
        }

        function selectActiveFilter(status) {
            vm.selectedActiveFilter = status;
        }

        /*vm.fixModelNonCompliancesDepartments = fixModelNonCompliancesDepartments;
        function fixModelNonCompliancesDepartments()
        {
            console.log('Iniciou!');
            KpiNonCompliances.fixModelNonCompliancesDepartments();
        }
        
        vm.fixModelNonCompliancesItems = fixModelNonCompliancesItems;
        function fixModelNonCompliancesItems()
        {
            console.log('Iniciou!');
            KpiNonCompliances.fixModelNonCompliancesItems();
        }
        
        vm.fixModelNonCompliancesDepartmentsSent = fixModelNonCompliancesDepartmentsSent;
        function fixModelNonCompliancesDepartmentsSent()
        {
            console.log('Iniciou!');
            KpiNonCompliances.fixModelNonCompliancesDepartmentsSent();
        }
        
        vm.fixModelSurvey = fixModelSurvey;
        function fixModelSurvey()
        {
            console.log('Iniciou!');
            KpiNonCompliances.fixModelSurvey();
        }
        
        vm.fixDateFormat = fixDateFormat;
        function fixDateFormat()
        {
            console.log('Iniciou!');
            KpiNonCompliances.refixDateFormat();
        }
        
        vm.fixActiveNC = fixActiveNC;
        function fixActiveNC()
        {
            KpiNonCompliances.fixActiveNC();
        }
        
        function genInsert()
        {
            KpiNonCompliances.genInsert();
        }
        
        vm.fix = fix;
        function fix()
        {
            genInsert();
        }*/
    }
}());

/*angular.module('sghi')
.controller('KpiCtrl', function ($location, $mdDialog, $mdMedia, $rootScope, $routeParams, $scope,
                                 Department, Kpi, KPIValuesSrvc, SGHiEndpoint) {

  if( !$rootScope.loggedin ) $location.path('/');
  
  $scope.departmentKey = $routeParams.departmentKey;
  $scope.department = Department.get($scope.departmentKey);
  $scope.kpis = Kpi.all($scope.departmentKey);

  function blank(){
    return { 
      "code": "",
      "name": "",
      "description": "",
      "descriptionOfMeasureFormula": "",
      "category": "",
      "measureUnit":"",
      "verificationFrequency": "",
      "objectives": {},
      "targets": []
    };
  }

  $scope.kpi = blank();

  $scope.add = function(ev) {
    $scope.kpi = blank();
    $scope.openEditForm(ev);
  };

  $scope.save = function(){
    Kpi.save($scope.kpi).then(function(){
      $scope.convertExtractionQueryToCDA($scope.kpi.$id);
      $scope.kpi = blank();
    });
    $mdDialog.hide();
  };
  
  $scope.convertExtractionQueryToCDA = function(kpiKey){
    SGHiEndpoint.query({
      endpoint: 'convert_extraction_query_to_cda', 
      paramdepartment_key: $scope.departmentKey,
      paramkpi_key: kpiKey
    }).$promise.then(function(d){ //todo: melhorar o tratamento incluido msg de status e resultado
      console.log(d);
    });
  };

  $scope.delete = function(o){
    if (!confirm("Confirma a exclusão?")) return;
    Kpi.delete(o);
    $scope.kpi = blank();
  };

  $scope.edit = function(o){
    $scope.kpi = o;
    $scope.openEditForm();
  };

  $scope.cancel = function(){
    $scope.kpi = blank();
    $mdDialog.hide();
  };

  $scope.addTarget = function(){
    if(!$scope.kpi.targets) $scope.kpi.targets = [];
    $scope.kpi.targets.push($scope.selectedTarget);
    $scope.selectedTarget = {};
  };

  $scope.kpiMeasureUnits = [
    { measureUnitId:'percent', measureUnitName:'Percentual', measureUnitSymbol:'%' },
    { measureUnitId:'pacient', measureUnitName:'Paciente', measureUnitSymbol:'pac' },
    { measureUnitId:'pacientday', measureUnitName:'Paciente/Dia', measureUnitSymbol:'pac/d' },
    { measureUnitId:'pacientbed', measureUnitName:'Paciente/Leito', measureUnitSymbol:'pac/l' },
    { measureUnitId:'bedday', measureUnitName:'Leito/Dia', measureUnitSymbol:'lei/d' },
    { measureUnitId:'day', measureUnitName:'Dias', measureUnitSymbol:'dia' },
    { measureUnitId:'minute', measureUnitName:'Minutos', measureUnitSymbol:'min' },
    { measureUnitId:'currency', measureUnitName:'Moeda', measureUnitSymbol:'R$' },
    { measureUnitId:'unit', measureUnitName:'Unidade', measureUnitSymbol:'un' },
    { measureUnitId:'kg', measureUnitName:'Kilograma', measureUnitSymbol:'kg' }
  ];

  $scope.kpiCategories = ['Estrategico','Operacional','Tático/Operacional','Risco','Operacional e Risco','Operacional e Estratégico'];

  $scope.kpiVerificationFrequencies = ['Mensal','Bimestral','Trimestral','Quadrimestral','Semestral','Anual','Bianual'];

  $scope.orientations = [{orientation:1, orientationDesc:'Quanto maior melhor'},{orientation:-1, orientationDesc:'Quanto menor melhor'}];

  $scope.kpiDataSources = ['SGHDW', 'SGHDADOS'];

  $scope.kpiQueryTypes = ['SQL', 'MDX'];

  var originatorEv;
  $scope.openMenu = function($mdOpenMenu, ev) {
    originatorEv = ev;
    $mdOpenMenu(ev);
  };

  $scope.kpisValuesData = {};
  $scope.kpisValuesLabels = {};
  $scope.kpisValuesSeries = {};

  $scope.kpis.$loaded().then(function(){
    angular.forEach($scope.kpis, function(k,v){
      var id = $scope.kpis[v].$id;
      var data = KPIValuesSrvc.query({paramid_indicador: id, path: '/kpi/kpi.cda', dataAccessId: 'kpi'});

      data.$promise.then(function(d){
        $scope.kpisValuesLabels[id] = $scope.getLabelsFromCDAResult(d);
        $scope.kpisValuesData[id] = $scope.getDataFromCDAResult(d);
        $scope.kpisValuesSeries[id] = $scope.getSeriesFromCDAResult(d);
      });
    });
  });

  $scope.getSeriesFromCDAResult = function(rs){
    var result = [];
    angular.forEach(rs.metadata, function(d,idx){
      if (idx > 0) {
        result.push(d['colName']);
      }
    });
    return result;
  };

  $scope.getLabelsFromCDAResult = function(rs){
    var result = [];
    angular.forEach(rs.resultset, function(d,idx){
      result.push(d[0]);
    });
    return result;
  };

  $scope.getDataFromCDAResult = function(rs){
    var len = rs.metadata.length || 1;
    var result = new Array(len-1);
    for(var i=0; i < result.length; i++) {
      result[i] = [];
      angular.forEach(rs.resultset, function(d){
        result[i].push(d[i+1]);
      });
    }
    return result;
  };
  
  $scope.updateData = function(kpiKey){
    SGHiEndpoint.query({
      endpoint: 'load_kpi_values', 
      paramdepartment_key: $scope.departmentKey,
      paramkpi_key: kpiKey
    }).$promise.then(function(d){ //todo: melhorar o tratamento incluido msg de status e resultado
      console.log(d);
    });
  };
  
});


angular.module('sghi')
  .controller('KpiDialogCtrl', function ($scope, $mdDialog) {
  });

*/
(function ()
{
    'use strict';

    angular
        .module('app.pentaho', [])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {   
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pentaho')
        .service('PentahoService', PentahoService);

    /** @ngInject */
    function PentahoService($q, msUtils, msNavigationService, PentahoDataHandlerService, PentahoConnectorService, StateFactory, $rootScope, PENTAHO_APP_URL, APP_CFG, $state, AuthService) {
        var
            vm = this,
            mountNavTree = mountNavTreeFn,
            objTree = [];

        var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
        var IDBTransaction = window.IDBTransaction || window.webkitIDBTransaction || window.msIDBTransaction;
        var IDBKeyRange = window.IDBKeyRange || window.webkitIDBKeyRange || window.msIDBKeyRange;

        vm.initSideNav = initSideNav;
        vm.refreshMenu = refreshMenu;
        var ACTIVE_APPS = APP_CFG['ACTIVE_APPS'];
        var FEATURE_FLAGS = APP_CFG['FEATURE_FLAGS'] || {};

        var transformations = {
            def1: function (url) {
                return url + '/generatedContent';
            },
            def2: function (url) {
                return url + '/viewer';
            },
            def3: function (url) {
                return url + '/content';
            },
            def4: function (url) {
                return url + '/run';
            }
        }

        var extensionsAdapter = {
            saiku: transformations.def1,
            xcdf: transformations.def1,
            wcdf: transformations.def1,
            prpt: transformations.def2,
            easy: transformations.def1,
            analysis: transformations.def1,
            xaction: transformations.def1,
            xjpivot: transformations.def1,
            htm: transformations.def3,
            html: transformations.def3,
            vdd: transformations.def4
        }

        function sortPentahoNavbar(a, b) {
            if (a.level != b.level) {
                return a.level < b.level ? -1 : 1;
            }
            if (!(a.dnf && b.dnf) && a.title != b.title) {
                return a.title < b.title ? -1 : 1;
            }
            return 0;
        }

        function refreshMenu() {
            var request = window.indexedDB.open("menu");
            var userName = AuthService.authSessions.activitiSession.username;
            request.onsuccess = function (event) {
                var db = event.target.result;
                var menuStore = db.transaction("menu" + userName, "readwrite").objectStore("menu" + userName);
                var deleteAction = menuStore.delete(userName);

                deleteAction.onsuccess = function (event) {
                    initSideNav();
                };

                deleteAction.onerror = function (event) {
                    initSideNav();
                };
            }
        }

      function initSideNav() {
        var deferred = $q.defer();
        var userName = AuthService.authSessions.activitiSession.username;
        if (indexedDB) {
          var menu = undefined;
          var request = indexedDB.open("menu");
          request.onerror = function(e) {
            console.log("Error when trying to read 'menu' from indexedDB")
            console.log(e)
            getMenu(deferred);
          }
          request.onsuccess = function (event) {
            try {
              var db = event.target.result;
              var menuStore = db.transaction("menu" + userName, "readwrite").objectStore("menu" + userName);
              var menuRequest = menuStore.get(userName);
              menuRequest.onsuccess = function (event) {
                if (event.target && event.target.result && event.target.result.data) {
                  var dataHoraInsercao = event.target.result.dataHora;
                  if (!angular.isDefined(dataHoraInsercao)) {
                    getMenu(deferred);
                  } else {
                    var dataAtual = moment().toDate();
                    var diff = moment(dataAtual).diff(dataHoraInsercao, 'days');

                    if (diff > 2) {
                      getMenu(deferred);
                    } else {
                      init(event.target.result.data, deferred);
                    }
                  }
                } else {
                  getMenu(deferred);
                }
              }
            } catch (error) {
              getMenu(deferred);
            }
          };
        } else {
          getMenu(deferred);
        }

        return deferred.promise;
      }

        function getMenu(deferred) {
            var userName = AuthService.authSessions.activitiSession.username;
            console.info("Calling BISERVER to get the repository content...")
            PentahoConnectorService.dh.getDirStructure(':').then(function (r) {
              console.info("Got response for BISERVER repository content...")
              $rootScope.$broadcast('repository-content-loaded');
                if (indexedDB) {
                    var request = indexedDB.open("menu", new Date().getTime());
                    request.onupgradeneeded = function (event) {
                        var db = event.target.result;

                        var objectStore = db.createObjectStore("menu" + userName, {
                            keyPath: "id"
                        });

                        objectStore.transaction.oncomplete = function (event) {
                            var menuStore = db.transaction("menu" + userName, "readwrite").objectStore("menu" + userName);
                            var menu = {
                                id: userName,
                                data: r.data,
                                dataHora: new Date()
                            }
                            menuStore.add(menu);
                        };
                    };
                }
                init(r.data, deferred);
            }, function (e) {
                /*FAZER TRATAMENTO DE ERROS COM BASE NO STATUS DA RESPOSTA*/
                console.log('Falha ao obter listagem do diretório!');
                deferred.reject();
            });
        }

      function hasFeatureFlag(f) {
        var ff = APP_CFG['FEATURE_FLAGS'];
        return (ff && ff[f])
      }

        function init(data, deferred) {
            var treeNav = data;

            msNavigationService.saveItem('ANALYTICS', {
                title: 'ANALYTICS',
                group: true,
                weight: 3
            });

            if (FEATURE_FLAGS['tasks'] == true) {
              defineMenuItem(
                '',
                'newtasks',
                'Tarefas',
                false,
                '/pentaho/api/repos/ppa/static/tasks.html',
                'icon-checkbox-marked',
                null,
                0,
                null
              )
            }

            if (FEATURE_FLAGS['old-kpi'] == true) {
              msNavigationService.saveItem('old-kpi', {
                title: 'Indicadores',
                icon: 'icon-chart-histogram',
                state: 'app.kpi',
                weight: 3
              });
            }

            if (FEATURE_FLAGS['kpi'] == true) {
              defineMenuItem(
                '',
                'kpi',
                'Indicadores',
                false,
                '/pentaho/api/repos/ppa/static/public/kpi.html',
                'icon-chart-histogram',
                null,
                0,
                null
              );
            }

            // Cria o state estático para o Saiku
            defineMenuItem('', 'nova-analise', 'Nova Análise', false, '/pentaho/content/saiku-ui/index.html?biplugin5=true&lang=pt&splash=false', 'icon-cube-outline', null, 0, null);

          // Cria o state estático para o Easy
          hasFeatureFlag('easy') &&
            defineMenuItem('', 'novo-painel', 'Novo Painel', false, '/pentaho/api/repos/%3Aplugins%3AEasyDashboards.xcdf/generatedContent', 'icon-apps', null, 0, null);

            if ($rootScope.userContext) {
              if (($rootScope.userContext.isAdmin
                    || PentahoDataHandlerService.hasRole('Power User', $rootScope.userContext.userRoles))
                   && hasFeatureFlag('query-runner')) {
                defineMenuItem(
                  '',
                  'nova-consulta',
                  'Nova Consulta',
                  false,
                  '/pentaho/api/repos/ppa/static/public/query-runner.html',
                  'icon-play',
                  null,
                  0,
                  null
                );
              }
            }

          // Define menu para 'Playlists'
          defineMenuItem('', 'playlists', 'Playlists', false, '/pentaho/api/repos/ppa/static/play.html', 'icon-presentation-play', null, 0, null);

          createNavTree(treeNav);

          if ($rootScope.userContext && $rootScope.userContext.isAdmin) {
            // Creates the submenu for 'Configurações'
            msNavigationService.saveItem('SETTINGS', {
              title: 'CONFIGURAÇÕES',
              group: true,
              weight: 4
            });

            defineMenuItem('', 'ect', 'Notificações Automáticas', false, '/pentaho/api/repos/ppa/static/ect.html', 'icon-email', null, 0, null);
            // Permissões OLAP
            defineMenuItem('', 'olapperm', 'Permissões OLAP', false, '/pentaho/api/repos/ppa/static/olapperm.html', 'icon-security', null, 0, null);
            // Datasets
          }

          deferred.resolve();
          $rootScope.$emit('finishReload');
        }

        function createNavTree(treeNav) {
            mountNavTree(treeNav, '', 0);

            objTree.sort(sortPentahoNavbar);
            angular.forEach(objTree, function (value) {
                defineMenuItem(value.path, value.id, value.title, value.group, value.url, value.icon, value.urlPath, value.level, value.transformation);
            });
        }

        /* Percorre os itens recursivamente para criar os estados */
        function mountNavTreeFn(treeNode, dp, lvl) {
            var re = new RegExp('^[-._]');
            angular.forEach(treeNode, function (value, key) {
                if (key === 'file') {
                    if (value.folder === "true") {
                        dp = (dp || '') + '/' + value.title;
                    } else {
                        if (dp)
                            dp = dp + '/' + value.title;
                        if ((value.hidden === "false")) {
                            var tmp = isValidExtension(value.name);
                            if (tmp.valid) {
                                if (!re.test(value.title)) {
                                    objTree.push({
                                        path: dp || value.path,
                                        id: value.id,
                                        title: value.title,
                                        group: false,
                                        url: null,
                                        icon: 'icon-view-dashboard',
                                        urlPath: value.path,
                                        level: lvl,
                                        transformation: tmp.urlTransformation
                                    });
                                }
                            }
                        }
                    }
                } else {
                    var node = null;
                    if (value && value.file) {
                        node = {};
                        node.file = value.file;
                        node.subNode = value.children;
                    } else if (value) {
                        node = value;
                    }
                    mountNavTree(node, dp, lvl + 1);
                }
            });
        }

        function isValidExtension(fileName) {
            var availableExt = [
                'saiku',
                'xcdf',
                'wcdf',
                'prpt',
                'easy',
                'analysis',
                'xaction',
                'xjpivot',
                'htm',
                'html',
                'vdd'
            ]

            var ext = fileName.split('.');
            ext = ext[ext.length - 1];
            //return availableExt.contains(ext);
            return {
                valid: availableExt.contains(ext),
                urlTransformation: extensionsAdapter[ext]
            }
        }

        // $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
        //     if (toState.name.indexOf('novaanalise') > -1) {
        //         msUtils.clearLocalStorage();
        //     }
        // });

        function containsState(stateName) {
            return _.find($state.get(), function (i) {
                return i.name === stateName;
            });
        }

        /* Cria o menu */
        function defineMenuItem(_path, _id, title, group, _url, icon, urlPath, level, transformation) {
            var url, path, id;

            if (_url) {
                url = _url;
                path = _path;
            } else {
                url = PENTAHO_APP_URL + '/api/repos/' + urlPath.toString().replace(/\//g, '%3A');
                if (transformation)
                    url = transformation(url);

                // Troca as barras por pontos para serem usados como níveis dos estados
                path = _path.split('/');
                path = path.slice(1, path.length - 1);
                path = path.join('.') + '.';
            }

            // Remove os traços para utilizar como estado
            id = _id.toString();
            id = id.replace(/-/g, '');

            // Se não for um grupo
            if (!group) {
                // Cria o estado

                var newState = {
                    name: 'app.analytics-' + id,
                    title: title,
                    options: {
                        parent: 'app',
                        resolve: {
                            tabControl: function () {
                                var tabData = {
                                    title: title,
                                    id: id,
                                    url: url
                                }

                                // Controle de abas recentes
                                /*var lsData;
                                var d = localStorageService.get('recent-analytics');

                                if (d) {
                                    lsData = {
                                        data: JSON.parse(d).data
                                    };
                                } else {
                                    lsData = {
                                        data: []
                                    };
                                }

                                lsData.data.push({datetime: new Date(), title: title, state: 'app.analytics-' + id});
								console.log('app.analytics-' + id)
                                localStorageService.set('recent-analytics', angular.toJson(lsData));
                                $rootScope.$broadcast('restorestate');*/
                                // ---- Controle de abas recentes

                                // if (id == 'novaanalise') {
                                //     msUtils.clearLocalStorage();
                                // }

                                // Abre a aba requisitada
                                return PentahoConnectorService.viewer.openTab(tabData);
                            }
                        },
                        authenticate: true
                    }
                }
                if (!containsState(newState.name)) {
                    StateFactory(newState);
                }

                var tmpPath = path.split('.');
                var parent = '';
                var counter = 2;
                /*msNavigationService.saveItem(tmpPath[0], {
                	title    : tmpPath[0],
                	weight   : 3
                });*/

                if (path != undefined && path.indexOf('plugins.') < 0) {

                    angular.forEach(tmpPath, function (value, key) {
                        parent = parent + (parent != '' ? '.' : '') + value;
                        counter++;
                        if (!containsState(parent)) {
                            msNavigationService.saveItem(parent, {
                                title: value,
                                weight: counter,
                                hidden: parent.indexOf('plugins') >= 0 ? true : false
                            });
                        }
                    });

                    // Cria o item de menu
                    if (title.indexOf('.') != -1) {
                        title = title.substr(0, title.indexOf('.'));
                    }

                    if (!containsState(path + id)) {
                        msNavigationService.saveItem(path + id, {
                            title: title,
                            icon: icon || 'icon-tile-four',
                            state: 'app.analytics-' + id,
                            weight: 3,
                            hidden: path.indexOf('plugins') >= 0 ? true : false
                        });
                    }
                }
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pentaho')
        .controller('PentahoController', PentahoController);

    /** @ngInject */
    function PentahoController()
    {
        var vm = this;
    }
})();

(function () {
  'use strict';

  angular.module('app.admintools')
    .service('AdminToolsService', AdminToolsService);

  /** @ngInject */
  function AdminToolsService($q, $document, $mdDialog, ProcessDefinition, StateFactory, msNavigationService, User, FormData, ActivitiDataHandlerService, ACTIVITI_APP_URL, APP_CFG, $rootScope, $state) {
    var vm = this;

    vm.initSideNav = initSideNav;

    // Cria o menu lateral dos processos
    function initSideNav() {
      if (($rootScope.userContext.isDataAdministrator)
           || ($rootScope.userContext.isAdmin)
           || ($rootScope.userContext.isQualityManager)) {
        // Cria o grupo do menu
        msNavigationService.saveItem('admin', {
          title: 'ADMINISTRAÇÃO',
          group: true,
          weight: 4
        });

        // Navigation
        msNavigationService.saveItem('admin.data', {
          title: 'Dados',
          icon: 'icon-checkbox-marked',
          state: 'app.admintools',
          stateParams: {
            ref: 'datamanagement'
          },
          weight: 4
        });

        // Navigation
        msNavigationService.saveItem('admin.department', {
          title: 'Microssistemas',
          icon: 'icon-checkbox-marked',
          state: 'app.admintools.department',
          weight: 4
        });

        // Navigation
        msNavigationService.saveItem('admin.userdepartments', {
          title: 'Usuários e Microssistemas',
          icon: 'icon-checkbox-marked',
          state: 'app.admintools.usersdepartments',
          weight: 4
        });
      }
    }
  }
}());

(function(){
    'use strict';
    
    angular
        .module('app.admintools')
        .controller('AdminToolsController', AdminToolsController);
    
    /** @ngInject */
    function AdminToolsController(fuseTheming, $state, $stateParams, AdminTools, APP_CFG)
    {
        var vm = this;
        vm.tools = null;
        vm.selectedTool = {name: 'Carregando...'};
        
        vm.showToolSelector = true;
        
        vm.themes = fuseTheming.themes;
        
        // Métodos
        vm.selectTool = selectTool;
        
        vm.tools = [
            {name: 'Associação de cadastros', stateRef: 'dbassociation'},
            {name: 'Planos de ação sem departamento', stateRef: 'acwithoutdept'}
        ]
        
        selectTool(vm.tools[0]);
        
        // Seleciona o departamento
        function selectTool(tool)
        {
            vm.selectedTool = tool;
            if (vm.tools.length > 0)
                $state.go('app.admintools.' + vm.selectedTool.stateRef);
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.activiti')
        .service('ActivitiService', ActivitiService);

    /** @ngInject */
    function ActivitiService($q, $document, msUtils, $mdDialog, ProcessDefinition, StateFactory, msNavigationService, User, FormData, ActivitiDataHandlerService, ACTIVITI_APP_URL, PENTAHO_APP_URL, APP_CFG, $rootScope, $state) {
        var vm = this;
        var FEATURE_FLAGS = APP_CFG['FEATURE_FLAGS'] || {};

        vm.navItemPosition = 0;
        vm.initSideNav = initSideNav;

        // Cria o menu lateral dos processos
        function initSideNav() {
            var deferred = $q.defer();

            ProcessDefinition.get(function (res) {
                var processes = res.data,
                    name = '';

                // Cria o grupo do menu
                msNavigationService.saveItem('processos', {
                    title: 'PROCESSOS',
                    group: true,
                    weight: 1
                });

                // Navigation
                if (FEATURE_FLAGS['tasks'] == true) {
                  // Aqui deveria definir uma entrada para tasks, mas não consegui
                  // fazer funcionar
                } else {
                  msNavigationService.saveItem('processos.tasks', {
                      title: 'Tarefas',
                      icon: 'icon-checkbox-marked',
                      state: 'app.tasks',
                      weight: 1
                  });
                }

                var external = APP_CFG['EXTERNAL_APPS'];

                if (external) {

                    if (external.sghq.active) {
                        if (external.sghq.items.minutes) {
                            msNavigationService.saveItem('minutes', {
                                title: 'Atas de Reuniões',
                                icon: 'icon-document',
                                state: 'app.minutes',
                                weight: 2
                            });
                        }

                        if (external.sghq.items.nonCompliances) {
                            msNavigationService.saveItem('non-compliances', {
                                title: 'Notificações',
                                icon: 'icon-document',
                                state: 'app.non-compliances',
                                weight: 2
                            });
                        }

                        if ($rootScope.userContext.isAdmin || $rootScope.userContext.isQualityManager) {
                            msNavigationService.saveItem('administracao', {
                                title: 'Administração',
                                icon: 'icon-tile-four',
                                weight: 1
                            });

                            if (external.sghq.items.eventTypes) {
                                msNavigationService.saveItem('administracao.tipoEvento', {
                                    title: 'Tipos de Eventos',
                                    state: 'app.event-types'
                                });
                            }

                            if (external.sghq.items.nonCompliancesTypes) {
                                msNavigationService.saveItem('administracao.tiposNaoConformidades', {
                                    title: 'Tipos de Notificações',
                                    state: 'app.non-compliances.types'
                                });
                            }

                            if (external.sghq.items.patternsNonCompliances) {
                                msNavigationService.saveItem('administracao.patterns', {
                                    title: 'Padrões de Não Conformidade',
                                    state: 'app.non-compliances.patterns'
                                });
                            }
                        }
                    }
                }

                var path_prefix = ''; //Caso seja necessário um dia criar um prefixo para os estados, basta setá-lo aqui
                var pdList = {};

                angular.forEach(processes, function (value, key) {
                    //if (!re.test(value.name)) {
                    name = value.name || ActivitiDataHandlerService.getNameFromResource(value.resource);

                    if (!pdList[value.key]) {
                        pdList[value.key] = {};
                        pdList[value.key].version = value.version;
                        pdList[value.key].name = name;
                        pdList[value.key].id = value.id;
                    } else {
                        if (pdList[value.key].version < value.version) {
                            pdList[value.key].version = value.version;
                            pdList[value.key].name = name;
                            pdList[value.key].id = value.id;
                        }
                    }
                    //}
                });

                angular.forEach(pdList, function (value, key) {
                    // Verifica se o estado já está criado, para não tentar criá-lo novamente
                    if (!$state.get('app.tasks.' + path_prefix + value.id)) {
                        defineMenuItem(value.id, value.name, path_prefix);
                    }
                });

                $rootScope.$broadcast('loadnavpentaho');

                deferred.resolve();
            }, function (e) {
                console.log('Falha ao obter os dados do Activiti!');
                deferred.reject();
            });

            return deferred.promise;
        }

        // Cria o menu lateral
        function defineMenuItem(id, name, path_prefix) {
            var path = path_prefix,
                newState = {
                    name: 'app.tasks.' + path + id,
                    title: name,
                    options: {
                        parent: 'app.tasks',
                        resolve: {
                            Process: getProcesses
                        },
                        authenticate: true
                    }
                };
            StateFactory(newState);

            var re = new RegExp('^[-._]');
            if (!re.test(name)) {
                // Cria o item de menu
                msNavigationService.saveItem(path + id, {
                    title: name,
                    icon: 'icon-stackoverflow',
                    state: 'app.tasks.' + path + id,
                    weight: 2
                });
            }

            getProcesses.$inject = ['ProcessDefinition'];

            function getProcesses(ProcessDefinition) {
                var data = ProcessDefinition.get({
                    "activiti_url_base": ACTIVITI_APP_URL,
                    "processDefinitionId": id,
                    "size": 1000
                });
                return data
                    .$promise
                    .then(function (res) {
                        loadProcessDefinition(res);
                        return res;
                    }, function (err) {
                        console.log('ERRO: ', err);
                        return null;
                    });
            }
        }

        // Exibe o modal de um processo
        function loadProcessDefinition(process) {
            FormData
                .get({
                    "processDefinitionId": process.id
                }, function (res) {
                    ActivitiDataHandlerService.extractForm(process, res);
                    openProcessDialog(null, process);
                }, function (err) {
                    if (err.status === 404) {
                        console.log('Recurso não encontrado!');
                        openProcessDialog(null, process);
                    }
                });
        };

        /**
         * Open new process dialog
         *
         * @param ev
         * @param process
         */
        function openProcessDialog(ev, process) {
            $mdDialog.show({
                    controller: 'ProcessDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/home/apps/activiti/dialogs/process/process-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        Process: process,
                        event: ev
                    }
                })
                .then(function (e) {
                    //startProcess(process, ev);
                    console.log(e);
                });
        }


    }
}());

(function ()
{
    'use strict';

    angular
        .module('app.activiti')
        .controller('TasksController', TasksController);

    /** @ngInject */
    function TasksController($document, $mdDialog, $mdSidenav, TasksList, msNavigationService, AuthService, $rootScope, ActivitiConnectorService, ActivitiDataHandlerService, Tasks, HistoricTasks, FormData, ProcessDefinition, User, $location, StateFactory, $state, $ocLazyLoad, $http, KpiDepartments)
    {
        var vm = this;
        
        /*****************************************************/
        /***** ENGINE *****/
        /*****************************************************/
        vm.tasks;
        vm.processes;
        vm.users;
        vm.refreshing = false;
        vm.history = false;
        vm.tasksType = 'involved';
        vm.user = AuthService.authSessions.activitiSession.username;
        vm.loadTasksType = loadTasksType; // Carrega as tarefas pelo tipo
        vm.loadTasks = loadTasks; // Carrega as tarefas
        vm.loadUsers = loadUsers; // Carrega os usuários
        vm.loadTask = loadTask; // Exibe o modal de uma tarefa
        vm.loadTaskWithFormKey = loadTaskWithFormKey; // Exibe o modal de uma tarefa com form key
        vm.toTrustedHTML = toTrustedHTML;

        // Data
        vm.tasks = TasksList.data;
        
        // Recarrega as tarefas quando $rootScope for atualizado
        $rootScope.$on('refreshtasks', function (event, data) {
            vm.loadTasks();
        });
        
        vm.loadUsers();

        // Define os parâmetros da query
        function getTasksQuery()
        {
            switch (vm.tasksType){
                case 'involved':
                    return {
                        "size": 1000, 
                        "involvedUser": AuthService.authSessions.activitiSession.username,
                        "includeProcessVariables": true
                    }
                    break;
                case 'owned':
                    return {
                        "size": 1000, 
                        "owner": AuthService.authSessions.activitiSession.username,
                        "includeProcessVariables": true
                    }
                    break;
                case 'unassigned':
                    return {
                        "size": 1000, 
                        "unassigned": true,
                        "includeProcessVariables": true
                    }
                    break;
                case 'assignee':
                    return {
                        "size": 1000, 
                        "assignee": AuthService.authSessions.activitiSession.username,
                        "includeProcessVariables": true
                    }
                    break;
                defaul:
                    return {
                        "size": 1000, 
                        "candidateUser": AuthService.authSessions.activitiSession.username,
                        "includeProcessVariables": true
                    }
            }
            return obj;
        }

        // Carrega as tarefas pelo tipo
        function loadTasksType(tasksType) 
        {
            vm.tasksType = tasksType;
            vm.loadTasks();
        }

        // Carrega as tarefas
        function loadTasks(completed) 
        {
            vm.refreshing = true;
            $rootScope.loadingProgress = true;
            if (completed) {
                vm.history = true;
                vm.tasks = null;
                HistoricTasks.get(getTasksQuery(), function(res){
                    vm.tasks = res.data;
                    prepareTasksDateFormat();
                    prepareTasksLinks();
                    vm.refreshing = false;
                    $rootScope.loadingProgress = false;
                });
            } else {
                vm.history = false;
                Tasks.get(getTasksQuery(), function(res){
                    vm.tasks = res.data;
                    prepareTasksDateFormat();
                    prepareTasksLinks();
                    vm.refreshing = false;
                    $rootScope.loadingProgress = false;
                });
            }
        }
        
        // Carrega os usuários
        function loadUsers()
        {
            User.get(function(res){
                vm.users = res.data;
            });
        }

        // Exibe o modal de uma tarefa
        function loadTask(task) 
        {
            FormData.get({"taskId": task.id}, function (res) {
                ActivitiDataHandlerService.extractForm(task, res);
                openTaskDialog(null, task);
            }, function (err) {
                if (err.status === 404) {
                    openTaskDialog(null, task);
                } else {
                    console.log(err);
                }
            });
        };

        // Exibe o modal de uma tarefa com form key
        /*
          As formKey's deverão seguir o modelo:
            state-name|external-app-name:var1:var2:var3...varN
            
            ex: non-compliance-action-plan|sghq:
        */
        function loadTaskWithFormKey(task)
        {
            var 
                destination = task.formKey,
                destPath, mod_index;
            
            if (destination === '/non-compliance/:nonComplianceId/action-plan') {
                mod_index = [];
                mod_index[0] = 'non-compliance-action-plan';
            } else {
                destPath = destination.split(':'), 
                mod_index = destPath[0].split('|');
            }
            
            var formProperties = task.variables;
            var params = {
                taskId: task.id
            };

            for(var i in formProperties) {
                params[formProperties[i].name] = formProperties[i].value
            }

            $state.go('app.' + mod_index[0], params);

            /*FormData.get(
                {"taskId": task.id}, 
                function (formData) {
                    var formProperties = formData.formProperties;
                    var params = {
                        taskId: task.id
                    };
                    
                    for(var i in formProperties) {
                        params[formProperties[i].name] = formProperties[i].value
                    }

                    $state.go('app.' + mod_index[0], params);
                }, 
                function (data) {
                    if (data.data.statusCode == 404) {
                        alert("O caminho não pode ser encontrado!");
                    }
                }
            );*/
            
            
        };

        // HTML seguro
        function toTrustedHTML(html)
        {
            return $sce.trustAsHtml(html);
        }
        
        vm.loadTasks();
        
        /*****************************************************/
        /***** UI ******/
        /*****************************************************/
        
        // Navigation
        msNavigationService.saveItem('tasks', {
            badge : {
                content: vm.tasks.length,
                color  : '#4CAF50'
            }
        });
        
        vm.completed = [];
        vm.projects = {
            'main'    : 'Principal'
        };
        vm.selectedFilter = {
            filter : 'Start Date',
            dueDate: '',
            delegationState: ''
        };
        vm.selectedProject = 'main';

        // Tasks will be filtered against these models
        vm.taskFilters = {
            search    : '',
            createTime: '',
            dueDate   : '',
            completed : '',
            delegationState : ''
        };
        vm.taskFiltersDefaults = angular.copy(vm.taskFilters);
        vm.showAllTasks = true;

        vm.taskOrder = '';
        vm.taskOrderDescending = true;

        vm.sortableOptions = {
            handle        : '.handle',
            forceFallback : true,
            ghostClass    : 'todo-item-placeholder',
            fallbackClass : 'todo-item-ghost',
            fallbackOnBody: true,
            sort          : true
        };
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.preventDefault = preventDefault;
        vm.openTaskDialog = openTaskDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleFilter = toggleFilter;
        vm.toggleFilterWithEmpty = toggleFilterWithEmpty;
        vm.filterByCreateTime = filterByCreateTime;
        vm.filterByDueDate = filterByDueDate;
        vm.filterByDelegationState = filterByDelegationState;
        vm.filterNyUser = filterNyUser;
        vm.resetFilters = resetFilters;
        vm.filterByPrefixes = filterByPrefixes;
        vm.openTaskOrigin = openTaskOrigin;

        init();

        //////////

        /**
         * Initialize the controller
         */
        function init()
        {
            prepareTasksDateFormat();
        }
        
        function prepareTasksDateFormat()
        {
            angular.forEach(vm.tasks, function (task)
            {
                if ( task.createTime )
                {
                    task.createTime = new Date(task.createTime);
                    task.createTimeTimestamp = task.createTime.getTime();
                }

                if ( task.dueDate )
                {
                    task.dueDate = new Date(task.dueDate);
                    task.dueDateTmp = new Date(task.dueDate);
                    task.dueDateTimestamp = task.dueDate.getTime();
                }
            });
        }
        
        function prepareTasksLinks()
        {
            angular.forEach(vm.tasks, function (task){
                if (task.taskDefinitionKey == 'actionPlanTask'){
                    angular.forEach(task.variables, function (v){
                        if (v.name == 'nonComplianceId'){
                            task.nonComplianceId = v.value;
                        } else if (v.name == 'departmentId'){
                            task.departmentId = v.value;
                        } else if (v.name == 'userTask1Name'){
                            task.nonComplianceName = v.value;
                        }
                    });
                }
            });
        }

        /**
         * Prevent default
         *
         * @param e
         */
        function preventDefault(e)
        {
            e.preventDefault();
            e.stopPropagation();
        }

        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openTaskDialog(ev, task)
        {
            $mdDialog.show({
                controller         : 'TaskDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/home/apps/activiti/dialogs/task/task-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Task : task,
                    history: vm.history,
                    action: null,
                    TasksList: vm.tasks,
                    UsersList: vm.users,
                    event: ev
                }
            })
            .then(function(action){
                if (action === 'complete')
                    completeTask(task, ev);
            });
        }
        
        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         */
        function completeTask(task)
        {
            task.completed = true;
        }
        
        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         */
        function completeProcess(task)
        {
            // Remover processo do menu ao finalizar
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggles filter with true or false
         *
         * @param filter
         */
        function toggleFilter(filter)
        {
            //vm.taskFilters[filter] = !vm.taskFilters[filter];
            vm.taskFilters[filter] = false;
            checkFilters();
        }

        /**
         * Toggles filter with true or empty string
         * @param filter
         */
        function toggleFilterWithEmpty(filter)
        {
            if ( vm.taskFilters[filter] === '' )
            {
                vm.taskFilters[filter] = true;
            }
            else
            {
                vm.taskFilters[filter] = '';
            }

            checkFilters();
        }

        /**
         * Reset filters
         */
        function resetFilters()
        {
            vm.showAllTasks = true;
            vm.taskFilters = angular.copy(vm.taskFiltersDefaults);
            vm.loadTasks();
        }

        /**
         * Check filters and mark showAllTasks
         * as true if no filters selected
         */
        function checkFilters()
        {
            vm.showAllTasks = !!angular.equals(vm.taskFiltersDefaults, vm.taskFilters);
        }

        /**
         * Filter by createTime
         *
         * @param item
         * @returns {boolean}
         */
        function filterByCreateTime(item)
        {
            if ( vm.taskFilters.createTime === true )
            {
                if (item.createTime)
                    return item.createTime.getDate() === new Date().getDate();
                else
                    return false;
            }

            return true;
        }

        /**
         * Filter Due Date
         *
         * @param item
         * @returns {boolean}
         */
        function filterByDueDate(item)
        {
            if ( vm.taskFilters.dueDate === true )
            {
                if (vm.selectedFilter.dueDate){
                    var 
                        d = new Date();
                    d.setDate(d.getDate() + parseInt(vm.selectedFilter.dueDate));
                    return (!(item.dueDate === null || item.dueDate.length === 0) && (d < item.dueDate));
                }
                return !(item.dueDate === null || item.dueDate.length === 0);
            }
            return true;
        }
        
        /**
         * Filter Delegated
         *
         * @param item
         * @returns {boolean}
         */
        function filterByDelegationState(item)
        {
            if (!vm.history) {
                if (vm.taskFilters.delegationState === true) {
                    return (!(item.delegationState === null || item.delegationState === ''));
                } else {
                    return (item.assignee === AuthService.authSessions.activitiSession.username);
                }
            } else {
                return true;
            }
        }
        
        function filterNyUser(item)
        {
            if (vm.taskFilters.delegationState === true) {
                return (item.owner === AuthService.authSessions.activitiSession.username);
            } else {
                return (item.assignee === AuthService.authSessions.activitiSession.username);
            }
        }
        
        function filterByPrefixes(item)
        {
            return (! ((item.name.substr(0, 3) === '#ap') || 
                       (item.name.substr(0, 6) === '__ap__')));
        }
        
        function openTaskOrigin(event, taskInstance)
        {
            event.preventDefault();
            event.stopPropagation();
            if (taskInstance.nonComplianceId && taskInstance.departmentId){
                $state.go('app.non-compliance-action-plan', {
                    nonComplianceId: taskInstance.nonComplianceId,
                    departmentId: taskInstance.departmentId
                })
            }
        }
        
        /**************************************************************/
        /*vm.eaStarterTest = eaStarterTest;
        function eaStarterTest(eaName)
        {
            var 
                destination = 'sghq|sghq',
                destPath = destination.split(':'),
                mod_index = destPath[0].split('|'),
                eapp_files = '';
            
            $http.get('/external-apps/' + mod_index[1] + '/lazy-load.json')
            .success(function(data){
                eapp_files = data.data;
                                
                // Carrega o módulo e os demais arquivos
                var mod = $ocLazyLoad.load(eapp_files);
                
                mod.then(function(res){
                    // Cria rota dinamicamente, para o destino do formKey
                    if (!$state.get('app.home.ea-module')) {
                        var newState = {
                            name: 'app.home.ea-module',
                            options: {
                                parent   : 'app.home',
                                url      : '/' + mod_index[1] + '/index',
                                views    : {
                                    'app.ea@app.home': {
                                        templateUrl: '/external-apps/' + mod_index[1] + '/' + mod_index[1] + '.html',
                                        controller: function(controllerParams){
                                            var ctrl = this;
                                            ctrl.params = controllerParams;
                                        },
                                        controllerAs: 'ctrl'
                                    }
                                },
                                resolve: {
                                    controllerParams: function ()
                                    {
                                        return null;
                                    }
                                },
                                params: {
                                    starterState: null,
                                    stateId: null,
                                    departmentId: null,
                                    indicatorId: null
                                },
                                authenticate: true
                            }
                        }
                        StateFactory(newState);
                    }
                    $rootScope.activeContextApp = 'ea';
                    $state.go('app.home.ea-module', {
                        starterState: 'app.home.ea-module',
                        stateId: 'app.home',
                        departmentId: '',
                        indicatorId: ''
                    });
                }, function(e){
                    console.log(e);
                });
            })
            .error(function(data, status, error, config){
               console.log(status + ':' + error);
            });
        };*/
        
        vm.newDepartment = newDepartment;
        function newDepartment()
        {
            KpiDepartments.add({
                email: 'rodrigo.almeida@veltio.com',
                initials: 'DEV',
                manager: "admin",
                name: 'DEVELOPMENT'
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.home', [
            'app.pentaho',
            'app.activiti',
            'app.kpi',
            'app.admintools',
            'cb.x2js'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.home', {
                url: '/home',
                parent: 'app',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/home/home.html',
                        controller: 'HomeController as vm'
                    }
                },
                resolve: {
                    Context: function ($rootScope) {
                        return $rootScope.getContext
                    }
                },
                authenticate: true
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.home')
        .controller('ProfileController', ProfileController);

    /** @ngInject **/
    function ProfileController()
    {
        var vm = this;
        console.log('PROFILE!')
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.home')
        .controller('InboxController', InboxController);

    /** @ngInject **/
    function InboxController()
    {
        var vm = this;
        console.log('INBOX!')
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.home')
        .controller('AboutContainerController', AboutContainerController);

    /** @ngInject **/
    function AboutContainerController($http)
    {
        var vm = this;
		var url = 'version';
		
		$http.get(url).success(function(data) {
			var version = null;
			version = data;

			vm.version = version;
			return true;
		}, function(e){
			console.log('ERROR: ', e);
			return false;
		});
    }
})();
(function(){
    'use strict';

    angular.module('app.pentaho-connector.pentaho-viewer')
    .service('PentahoViewerService', PentahoViewerService);

    /** @ngInject **/
    function PentahoViewerService($rootScope)
    {
        var vm = this;

        // Controla as abas abertas pelo usuário
        vm.tabs = {
            data: [],
            count: -1,
            active: -1
        };
        vm.openTab = openTab; // Abre uma nova aba ou localiza a aba já aberta
        vm.locateTab = locateTab; // Verifica se uma determinada aba já está aberta
        vm.closeTab = closeTab; // Fecha uma aba aberta
        vm.clearTabs = clearTabs;

        /*
          Verifica se uma aba já está aberta e retorna seu INDEX, ou abre uma nova caso não encontre-a
        */
        function openTab(tabData) {
            var index = -1;
            // Descomente esta linha para não permitir abrir a mesma aba mais de uma vez
            //index = vm.locateTab(tabData.id);

            // Caso não tenho encontrado a aba correspondente, cria uma nova
            if (index === -1) {
                var newTab = {
                    title: tabData.title,
                    id: tabData.id + (Math.random() * 1000).toString(),
                    index: vm.tabs.count + 1,
                    url: tabData.url
                };

                // Define o Pentaho como app do contexto
                $rootScope.activeContextApp = 'pentaho';

                if (vm.tabs.count <= 0) {
                    newTab.title = newTab.title.substring(0,15);
                }
                vm.tabs.count++;
                vm.tabs.data.push(newTab);

                index = newTab.index;
            }

            vm.tabs.active = index;
            return index;
        }

        /*
          Busca uma aba pelo seu ID e retorna seu INDEX ou -1 se não localizá-la
        */
        function locateTab(id)
        {
            var res = -1;
            angular.forEach(vm.tabs.data, function(value, key){
                if (value.id === id) {
                    res = value.index;
                }
            });
         
            return res;
        }
        
        /*
          Fecha (remove do vetor de objetos) uma aba identificada pelo seu ID
        */
        function closeTab(id)
        {
            vm.tabs.data = vm.tabs.data.filter(function(t){
                return t.id !== id;
            });
        }
		
		/*
			Limpa absas
		*/
		function clearTabs()
		{
			vm.tabs = {
				data: [],
				count: -1,
				active: -1
			};
		}
    }
}());

(function(){
    'use strict';
    
    angular.module('app.pentaho-connector.pentaho-data-handler', []);
}());
(function() {
  'use strict';

  angular.module('app.pentaho-connector.pentaho-data-handler')
  .service('PentahoDataHandlerService', PentahoDataHandlerService);

  /** @ngInject **/
  function PentahoDataHandlerService($http, PENTAHO_APP_URL, $cookies, $rootScope, APP_CFG) {
    var vm = this;

    vm.getDirStructure = getDirStructure;
    vm.getUserContext = getUserContext;
    vm.hasRole = hasRole;

    // Faz uma requisição da estrutura do diretório raiz informado
    function getDirStructure(root) {
      const prefix = function(e){return '*'+e}
      const exts = ['saiku', 'xcdf', 'wcdf', 'prpt', 'htm', 'vdd'].map(prefix).join('|');
      const url = PENTAHO_APP_URL + 
        '/api/repo/files/' + root + '/tree?showHidden=false&filter=FILES|' + exts + '|';

      return $http({
        method: 'GET',
        url: url + '?' + new Date().getTime(),
        headers: {
          "Content-Type": 'application/json',
          "Accept": 'application/json',
          "Authorization": 'Basic ' + getAuth(),
          "Cache-Control": 'no-cache',
          "Pragma": 'no-cache',
          "If-Modified-Since": 0
        }
      });
    }

    // Localiza o cookie que armazena a chave de autenticação
    function getAuth() {
      var auth = $cookies.getObject('ppaui-pentaho-auth');
      if (auth)
        return auth.authKey;
      else
        return '';
    }

    function getUserContext(userName) {
        // Recebe uma promise da requisição
        var url = PENTAHO_APP_URL + '/plugin/ppa/api/myRoles';

        var res = $http({
          method: 'GET',
          url: url,
          headers: {
            "Content-Type": 'application/json',
            "Accept": 'application/json',
            "Authorization": 'Basic ' + getAuth()
          }
        });

        res.then(function(res) {
          var rs = res.data.resultset;

          $rootScope.userContext = {
            roles: null,
            isAdmin: false,
            isQualityManager: false
          };

          $rootScope.userContext.userRoles = rs;

          $rootScope.userContext.isAdmin = hasRole('Admin', $rootScope.userContext.userRoles) ||
          hasRole('Administrator', $rootScope.userContext.userRoles) ||
          APP_CFG['DEV_USR_ADM'];

          $rootScope.userContext.isQualityManager = hasRole('quality_manager', $rootScope.userContext.userRoles);

          $rootScope.userContext.isDataAdministrator = hasRole('data_administrator', $rootScope.userContext.userRoles);

          if (!APP_CFG['DEV_USR']) {
            console.log(
              'Admin: ' + hasRole('Admin', $rootScope.userContext.userRoles),
              'Administrator: ' + hasRole('Administrator', $rootScope.userContext.userRoles),
              'QM: ' + hasRole('quality_manager', $rootScope.userContext.userRoles),
              'DA: ' + hasRole('data_administrator', $rootScope.userContext.userRoles));
          }
        }, function() {

        });
      };

      function hasRole(role, roles) {
        var r = false;
        angular.forEach(roles, function(value, key) {
          if (value.indexOf(role) !== -1) {
            r = true;
            return;
          }
        });
        return r;
      }

      function filterRole(v) {
        return v == role;
      }

      function xmlToJson(xml) {
        // Create the return object
        var obj = {};

        if (xml.nodeType == 1) { // element
            // do attributes
            if (xml.attributes.length > 0) {
              obj["@attributes"] = {};
              for (var j = 0; j < xml.attributes.length; j++) {
                var attribute = xml.attributes.item(j);
                obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
              }
            }
        } else if (xml.nodeType == 3) { // text
          obj = xml.nodeValue;
        }

        // do children
        if (xml.hasChildNodes()) {
          for (var i = 0; i < xml.childNodes.length; i++) {
            var item = xml.childNodes.item(i);
            var nodeName = item.nodeName;
            if (typeof(obj[nodeName]) == "undefined") {
              obj[nodeName] = xmlToJson(item);
            } else {
              if (typeof(obj[nodeName].push) == "undefined") {
                var old = obj[nodeName];
                obj[nodeName] = [];
                obj[nodeName].push(old);
              }
              obj[nodeName].push(xmlToJson(item));
            }
          }
        }
        return obj;
      };
    };
  }());
(function(){
    'use strict';
    
    angular.module('app.pentaho-connector.pentaho-authentication', []);
}());
(function(){
    'use strict';
    
    angular.module('app.pentaho-connector.pentaho-authentication')
    .service('PentahoAuthenticationService', PentahoAuthenticationService);
    
    /** @ngInject **/
    function PentahoAuthenticationService($q, $http, $base64, PENTAHO_APP_URL, APP_CFG, $cookies, $location, PentahoViewerService, $rootScope)
    {   
        var vm = this;
        
        // Objeto para armazenar as informações de sessão do Pentaho
        vm.session = {
            loggedIn: false,
            authKey: '',
            username: '',
            lastAttemptError: false
        }
        vm.logIn = logIn;
        vm.logOut = logOut;
        
        // Executa a tentativa de autenticação no Pentaho
        function logIn(loginData) {
			var deferred = $q.defer();
            var authData = {
                j_username: loginData.username,
                j_password: loginData.password,
                locale: 'pt_br'
            }
            // Recebe uma promise da requisição
            // Comecei a analisar uma forma de fazer o login q não envolva o uso dessa chamada ao spring
            // pois ela provoca um redirect q está impactando a capacidade de ativar o SSL
            // de forma externa (no proxy Caddy) ao Tomcat, veja mais detalhes na nota do Obsidian: 'Sobre Usar HTTPS'
            const useNewLoginStrategy = APP_CFG['USE_NEW_LOGIN'];
            const authUrl = useNewLoginStrategy ? '/plugin/pentaho-cdf/api/ping' : '/j_spring_security_check';
            const authCred = useNewLoginStrategy ? 'Basic '+btoa(authData.j_username + ':' + authData.j_password) : undefined;
            $http({
                method: 'post',
                url: PENTAHO_APP_URL + authUrl,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': authCred
                },
                transformRequest: function(obj) {
                    var str = [];
                    for(var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: authData
            }).then(function(res){
                if ((useNewLoginStrategy && res.status === 200)
                    || (!useNewLoginStrategy && res.data.indexOf('login?err=true') == -1)) {
					vm.session.loggedIn = true;
					vm.session.username = loginData.username;
					vm.session.authKey = $base64.encode(loginData.username + ':' + loginData.password);
					vm.session.lastAttemptError = false;
					$rootScope.$lastUse = new Date();
					deferred.resolve();
				} else {
                    deferred.reject();
                }
            });
            // Retorna a promise
            //return res;
			return deferred.promise;
        };
        
        // Executa logout do Pentaho
        function logOut(noRequest)
        {
			//history.pushState(null, null, '/pentaho/Home');
			// if (!noRequest) {
				var res = $http({
					method: 'post',
					url: PENTAHO_APP_URL + '/Logout',
					headers: {
						'X-Requested-With': 'XMLHttpRequest',
						'Authorization': undefined
					}
				})
				.success(function(data, status){
				    console.log('Logged out from BISERVER')
				})
				.error(function(data, status){
					console.log('ERRO: ' + status)
				});
			// }
			
			PentahoViewerService.clearTabs();
            
            vm.session.loggedIn = false;
            vm.session.username = '';
            vm.session.authKey = '';
			$rootScope.$lastUse = null;
        }
    };
}());

(function () {
    'use strict';

    angular.module('app.activiti-connector.activiti-data-handler')
        .service('ActivitiDataHandlerService', ActivitiDataHandlerService);

    /** @ngInject **/
    function ActivitiDataHandlerService($http, $cookies, $rootScope, User, ActivitiUserRoles) {
        var vm = this;

        vm.enumFields = {};

        vm.extractForm = extractForm;
        vm.extractDataFromForm = extractDataFromForm;
        vm.getNameFromResource = getNameFromResource;
        vm.getUserContext = getUserContext;

        // Localiza o cookie que armazena a chave de autenticação
        function getAuth() {
            var auth = $cookies.getObject('ppaui-activiti-auth');
            return auth.authKey || '';
        }

        function extractForm(objectOfReference, data) {
            var propertyForSaving = {};

            for (var i = 0; i < data.formProperties.length; i++) {
                var elem = data.formProperties[i];

                propertyForSaving[elem.id] = {
                    "value": getValueForFormFromRootScope(elem.id, elem.value),
                    "id": elem.id,
                    "writable": elem.writable
                };

                if (elem.datePattern != null) {
                    propertyForSaving[elem.id].opened = false;
                    propertyForSaving[elem.id].datePattern = elem.datePattern;
                }

                if (elem.required == true && elem.type == "boolean") {
                    if (elem.value == null) {
                        propertyForSaving[elem.id].value = false;
                    }
                }

                if (elem.type == "user") {
                    elem.enumValues = User.get();
                }
            }

            objectOfReference.form = data;
            objectOfReference.propertyForSaving = propertyForSaving;
        }

        function extractDataFromForm(objectOfReference, type) {

            if (type === 'task') {
                var objectToSave = {
                    "taskId": objectOfReference.id,
                    properties: []
                }
            } else {
                var objectToSave = {
                    "processDefinitionId": objectOfReference.id,
                    properties: []
                }
            }

            for (var key in objectOfReference.propertyForSaving) {
                var forObject = objectOfReference.propertyForSaving[key];

                if (!forObject.writable) { // Se não for uma propriedade editável, não a usa
                    continue;
                }

                if (forObject.value != null) {
                    var elem = {
                        "id": forObject.id,
                        "value": forObject.value
                    };

                    if (typeof forObject.datePattern != 'undefined') { //format
                        var date = new Date(forObject.value);
                    }
                    objectToSave.properties.push(elem);
                }
            }

            return objectToSave;
        }

        function getValueForFormFromRootScope(id, v) {
            return (id == 'kpiCode' && $rootScope.kpiCode != 'undefined') ? $rootScope.kpiCode : v;
        }

        // Obtem o nome do processo pela URL do resource
        function getNameFromResource(resourceStr) {
            var
                path, file, name;
            path = resourceStr.split('/');
            file = path[path.length - 1];
            name = file.split('.');
            name = name[0];

            return name;
        }

        function getUserContext(userName) {

            $rootScope.getContext = ActivitiUserRoles.get({
                member: userName
            }).$promise;

            $rootScope.getContext.then(function (response) {
                $rootScope.userContext = {
                    roles: [],
                    isAdmin: false,
                    isQualityManager: false
                };

                angular.forEach(response.data, function (value) {
                    $rootScope.userContext.roles.push(value.id);

                    if (value.id === 'admin')
                        $rootScope.userContext.isAdmin = true;

                    if (value.id === 'quality_manager')
                        $rootScope.userContext.isQualityManager = true;

                    if (value.id === 'data_administrator')
                        $rootScope.userContext.isDataAdministrator = true;
                });
            }, function (e) {
                console.log(e.message);
            });
        };
    }
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-authentication', []);
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector.activiti-authentication')
    .service('ActivitiAuthenticationService', ActivitiAuthenticationService);
    
    /** @ngInject **/
    function ActivitiAuthenticationService($http, $base64, ACTIVITI_APP_URL, sha1, APP_CFG)
    {   
        var vm = this;
        
        // Objeto para armazenar as informações de sessão do Activiti
        vm.session = {
            loggedIn: false,
            authKey: '',
            username: '',
            lastAttemptError: false
        }
        vm.logIn = logIn;
        vm.logOut = logOut;
        
        // Executa a tentativa de autenticação no Activiti
        function logIn(loginData)
        {
            const pw = !APP_CFG['USE_SAME_PW']
              ? 'abc123!@#'
              : loginData.password

            // Applies SHA-1 encrypt to the password, and then Base64 over login and password
            if (APP_CFG['USE_SHA1_ENCRYPT'])
                var tmpKey = $base64.encode(loginData.username + ':' + sha1.hash(pw));
            else
                var tmpKey = $base64.encode(loginData.username + ':' + pw);
            
            // Recebe uma promise da requisição
            var obj = {
                method: 'get',
                url: ACTIVITI_APP_URL + '/service/identity/users/' + loginData.username,
                headers: {
                    'Content-Type': 'aplication/json',
                    'Authorization': 'Basic ' + tmpKey
                }
            }
            var res = $http(obj);
            
            res.then(function(res){
                vm.session.loggedIn = true;
                vm.session.username = res.data.id;
                vm.session.authKey = tmpKey; 
                vm.session.lastAttemptError = false;
              // will set cookie `actak` to enable auto login to Activiti from CLJS pages
              const actak = $base64.encode('Basic ' + tmpKey);
              document.cookie = "actak=" + actak + "; path=/"
            }, function(e){
                vm.logOut();
                vm.session.lastAttemptError = true;
                console.log(e);
            });
            
            // Retorna a promise
            return res;
        };
        
        // Executa logout do Activiti
        function logOut()
        {
            vm.session.loggedIn = false;
            vm.session.username = '';
            vm.session.authKey = '';
        }
    };
}());

(function(){
    'use strict';
    
    angular
        .module('app.admintools-data-handler')
        .factory('AdminTools', AdminTools);
    
    function AdminTools()
    {   
        var obj = {
            
        }
        
        return obj;
    }
}());
(function(){
    'use strict';
    
    angular.module('app.kpi-data-handler', [
        'firebase'
    ]);
}());
(function () {
    'use strict';

    angular
        .module('app.kpi-data-handler')
        .service('UserDepartmentsService', UserDepartmentsService)

    function UserDepartmentsService(KpiDataHandlerService, $q, $firebaseArray, AuthService, $rootScope, $cookies, PENTAHO_APP_URL, $http, $filter, $httpParamSerializerJQLike) {
        var
            vm = this,
            db = KpiDataHandlerService.database,
            allDepartments,
            departmentList,
            departmentObj;

        var _data = {
            "parammethod": "GET",
            "paramtype": "user-departments"
        };

        var _headers = {
            "Content-Type": 'application/x-www-form-urlencoded; charset=UTF-8',
            "Authorization": 'Basic ' + _getAuth()
        };

        var _url = PENTAHO_APP_URL + '/plugin/ppa/api/docstore';

        function _getAuth() {
            var auth = $cookies.getObject('ppaui-pentaho-auth');
            if (auth)
                return auth.authKey;
            else
                return '';
        }

        function excludeId(item) {

            var _temp = angular.copy(item);

            if (_temp.hasOwnProperty('id'))
                delete _temp.id;

            return _temp;
        };

        var obj = {
            //Novos métodos
            get: function () {
                return $http({
                    method: 'GET',
                    url: _url,
                    headers: _headers,
                    params: _data
                });
            },

            format: function (result) {
                var arr = [];
                if (result) {
                    for (var property in result) {
                        var obj = result[property];
                        obj.id = property;
                        arr.push(obj);
                    }
                }
                return arr;
            },

            save: function (obj, edicao) {

                var tempData = angular.copy(_data);
                if (edicao) {
                    tempData.parammethod = 'PUT';
                    tempData.paramid = obj.id;
                    obj = excludeId(obj);
                } else {
                    tempData.parammethod = 'POST';
                }

                tempData.paramdoc = JSON.stringify(obj);

                return $http({
                    method: 'POST',
                    url: _url,
                    data: $httpParamSerializerJQLike(tempData),
                    headers: _headers
                })
            },

            delete: function (obj) {

                var tempData = angular.copy(_data);
                tempData.parammethod = 'DELETE';
                tempData.paramid = obj.id;
                obj = excludeId(obj);

                tempData.paramdoc = JSON.stringify(obj);

                return $http({
                    method: 'POST',
                    url: _url,
                    data: $httpParamSerializerJQLike(tempData),
                    headers: _headers
                })
            },

            getUserDepartmentsByUser: function (user) {
                var tempData = angular.copy(_data);
                tempData.paramfilter = JSON.stringify({
                    user: user
                });

                return $http({
                    method: 'GET',
                    url: _url,
                    headers: _headers,
                    params: tempData
                });
            }
        }

        return obj;
    }
}());
(function (module) {
    'use strict';

    module.service('SubEventTypes', function ($cookies, PENTAHO_APP_URL, $http, $filter, $httpParamSerializerJQLike) {

        var _data = {
            "parammethod": "GET",
            "paramtype": "event-subtype"
        };

        var _headers = {
            "Content-Type": 'application/x-www-form-urlencoded; charset=UTF-8',
            "Authorization": 'Basic ' + _getAuth()
        };

        var _url = PENTAHO_APP_URL + '/plugin/ppa/api/docstore';

        function _getAuth() {
            var auth = $cookies.getObject('ppaui-pentaho-auth');
            if (auth)
                return auth.authKey;
            else
                return '';
        }

        function excluirId(item) {

            var _temp = angular.copy(item);

            if (_temp.hasOwnProperty('id'))
                delete _temp.id;

            return _temp;
        }

        var services = {
            getSubTiposEventos: function () {
                return $http({
                    method: 'GET',
                    url: _url,
                    headers: _headers,
                    params: _data
                });
            },

            format: function (result) {
                var tiposEventos = [];
                if (result) {
                    for (var property in result) {
                        var tipo = result[property];
                        tipo.id = property;
                        tiposEventos.push(tipo);
                    }
                }

                return tiposEventos;
            },

            salvar: function (subType, edicao) {

                var tempData = angular.copy(_data);
                if (edicao) {
                    tempData.parammethod = 'PUT';
                    tempData.paramid = subType.id;
                    subType = excluirId(subType);
                } else {
                    tempData.parammethod = 'POST';
                }

                tempData.paramdoc = JSON.stringify(subType);

                return $http({
                    method: 'POST',
                    url: _url,
                    data: $httpParamSerializerJQLike(tempData),
                    headers: _headers
                })
            }
        };

        return services;
    });

}(angular.module('app.kpi-data-handler')));
(function(){
    'use strict';
    
    angular
        .module('app.kpi-data-handler')
        .factory('KpiNonCompliances', KpiNonCompliancesService);
    
    function KpiNonCompliancesService($q, KpiDataHandlerService, $firebaseArray, $firebaseObject)
    {
        var 
            nonComplianceList,
            db = KpiDataHandlerService.database;
        
        var obj = {
            getAll: function(departmentKey){
				if (departmentKey) {
					// Traz a lista de indicadores do departamento
                	var nonCompliancesRef = db.ref('nonCompliances/' + departmentKey);
				} else {
					// Traz todas as NCs
					var nonCompliancesRef = db.ref('nonCompliances/');
				}   
				
                nonComplianceList = $firebaseArray(nonCompliancesRef);
                
                return nonComplianceList;
            },
            getByKey: function(departmentKey, nonComplianceKey){
                var path = 'nonCompliances/' + departmentKey + '/' + nonComplianceKey;
                var nonComplianceRef = db.ref(path);
                var obj = new $firebaseObject(nonComplianceRef);
                return obj;
            },
            genInsert: function(){
                var departmentsRef = db.ref('departments/');
                
                 departmentsRef.once('value', function(snapshot) {
                    snapshot.forEach(function(child) {
                        var deptKey = child.getKey();
                        
                        var nonComplianceRef = db.ref('nonCompliances/' + deptKey);
                        var v = {};
                        nonComplianceRef.once('value', function(snapshot) {
                            snapshot.forEach(function(child) {
                                var ncKey = child.getKey();
                                
                                console.log("insert into NON_COMPLIANCES (ID_, DEPT_ID_) values ('" + deptKey  + "','" + ncKey + "');");
                            });
                        });
                    });
                });
                return null;
            }/*,
            fixActiveNC: function(){
                var departmentsRef = db.ref('departments/');
                
                departmentsRef.once('value', function(snapshot) {
                    snapshot.forEach(function(child) {
                        var deptKey = child.getKey();
                        
                        var nonComplianceRef = db.ref('nonCompliances/' + deptKey);
                        var v = {};
                        nonComplianceRef.once('value', function(snapshot) {
                            snapshot.forEach(function(child) {
                                var values = child.val();
                                var d = null;
                                if (values.active !== false) {
                                    v[child.getKey() + '/active'] = true;
                                }
                            });
                            nonComplianceRef.update(v);
                        });
                    });
                });
                return null;
            }
            ,
            fixModelNonCompliancesItems: function(){
                var departmentsRef = db.ref('departments/');
                
                //Para cada departamento...
                departmentsRef.once('value', function(snapshot){
                    var depts = snapshot.val(),
                        deptsByManager = {};
                    // Criar um objeto com os usuarios e seu departamento primeiro departamento
                    angular.forEach(depts, function(value, key){
                        deptsByManager[value.manager] = {id: key, name: value.name};
                    });
                    //console.log(deptsByManager)
                    snapshot.forEach(function(child){
                        var dptKey = child.getKey();
                        //if (dptKey === '-Jf8E4KxrpBHLb2zW5j6') {
                            var nonComplianceRef = db.ref('nonCompliances/' + dptKey);

                            //Para cada não conformidade...
                            nonComplianceRef.once('value', function(snapshot) {
                                snapshot.forEach(function(child) {
                                    var v = {};
                                    var 
                                        values = child.val(),
                                        key = child.getKey();
                                    //if (key === '-KCaGSSCtTicg9PZcO4o') {
                                        console.log(deptsByManager[values.owner]);
                                        v[key + '/occurrenceDeptName'] = depts[values.occurrenceDepartment].name;
                                        v[key + '/closed'] = true;
                                    
                                        if (values.status) {
                                            if (values.status.key)
                                                v[key + '/status'] = values.status.key;
                                        }

                                        if (values.type) {
                                            if (values.type.key)
                                                v[key + '/type'] = values.type.key;
                                        }

                                        if ((!values.title) && (values.description)) {
                                            var title = values.description.substring(0, 29) + '...';
                                            v[key + '/title'] = title;
                                        }
                                        
                                        if (deptsByManager[values.owner]) {
                                            v[key + '/claimant'] = deptsByManager[values.owner].id;
                                            v[key + '/claimantDeptName'] = deptsByManager[values.owner].name;
                                        }
                                    //}//<-
                                    if (Object.keys(v).length !== 0)
                                        nonComplianceRef.update(v);
                                        //console.log(v)
                                });
                            });
                        //} //<-
                    });
                });
                return null;
            },
            fixModelNonCompliancesDepartments: function(){
                var departmentsRef = db.ref('departments');
                var nonComplianceBkpRef = db.ref('nonCompliancesBkp');
                var nonComplianceRef = db.ref('nonCompliances/');
                var v = {};
                
                nonComplianceBkpRef.set(null);
                
                departmentsRef.once('value', function(snapshot) {
                    snapshot.forEach(function(child) {
                        var deptKey = child.getKey();
                        var ncList = [];
                        
                        var nonCompliancesRef = 
                            db.ref('nonCompliances')
                            .orderByChild('occurrenceDepartment')
                            .equalTo(deptKey);
                        
                        //ncList = $firebaseArray(nonCompliancesRef);
                        nonCompliancesRef.once('value', function(snapshot){
                            v[deptKey] = snapshot.val();
                            console.log(deptKey);
                            nonComplianceBkpRef.set(v);
                        });
                    });
                });
                return null;
            },
            fixModelNonCompliancesDepartmentsSent: function(){
                var departmentsRef = db.ref('departments/');
                var nonComplianceBkpRef = db.ref('nonCompliancesSent');
                var nonComplianceRef = db.ref('nonCompliances/');
                
                nonComplianceBkpRef.set(null);
                
                departmentsRef.once('value', function(snapshot) {
                    snapshot.forEach(function(child) {
                        var deptKey = child.getKey();
                        var ncList = [];
                        
                        //if (deptKey === '-Jf-SsTuOKX0iOT88YxC') {
                            var nonCompliancesRef = 
                                db.ref('nonCompliances/' + deptKey);

                            nonCompliancesRef.once('value', function(snapshot){
                                snapshot.forEach(function(child){
                                    var v = {};
                                    var value = child.val();
                                    var key = child.getKey();
                                    if (value.claimant){
                                        if (!v[value.claimant])
                                            v[value.claimant] = {};
                                        v[value.claimant][key] = value;
                                        console.log(v);
                                        if (Object.keys(v).length !== 0)
                                            nonComplianceBkpRef.set(v);
                                    }
                                });
                            });
                        //}//<-
                    });
                });
                return null;
            },
            fixModelSurvey: function(){
                var departmentsRef = db.ref('departments/');
                
                departmentsRef.once('value', function(snapshot) {
                    snapshot.forEach(function(child) {
                        var deptKey = child.getKey();
                        
                        //if (deptKey === '-Jf-SsTuOKX0iOT88YxC') {
                            var kpiRef = 
                                db.ref('departments/' + deptKey + '/kpi');

                            kpiRef.once('value', function(snapshot){
                                snapshot.forEach(function(child){
                                    var v = child.val();
                                    v.survey = false;
                                    kpiRef.set(v);
                                });
                            });
                        //}//<-
                    });
                });
                return null;
            },
            fixDateFormat: function(){
                var nonComplianceRef = db.ref('nonCompliances');
                var v = {};
                nonComplianceRef.once('value', function(snapshot) {
                    snapshot.forEach(function(child) {
                        var values = child.val();
                        console.log(values.occurrenceDate);
                        var d;
                        if (values.occurrenceDate) {
                            var ds = values.occurrenceDate.split('/');
                            if (ds.length === 3) {
                                if (ds[2].length === 2)
                                    ds[2] = '20' + ds[2];

                                if (ds[1].length === 1)
                                    ds[1] = '0' + ds[1];

                                if (ds[0].length === 1)
                                    ds[0] = '0' + ds[0];
                                d = new Date(ds[2] + '-' + ds[1] + '-' + ds[0]);
                                d = d.getTime() + d.getTimezoneOffset() * 60000;
                                v[child.getKey() + '/occurrenceDate'] = d;
                            }
                        }
                    });
                    nonComplianceRef.update(v);
                });
                return null;
            },
            refixDateFormat: function(){
                var departmentsRef = db.ref('departments/');
                
                departmentsRef.once('value', function(snapshot) {
                    snapshot.forEach(function(child) {
                        var deptKey = child.getKey();
                        
                        if ((deptKey === '-Jf8EtJQbnRRnqHO91ZO') || (deptKey === '-JguvXcDmbbKQ-yrekGM') || (deptKey === '-Jf8LsE4qkAlsdeZnPIT')){
                            var nonComplianceRef = db.ref('nonCompliances/' + deptKey);
                            var v = {};
                            nonComplianceRef.once('value', function(snapshot) {
                                snapshot.forEach(function(child) {
                                    var values = child.val();
                                    var d = null;
                                    if (values.occurrenceDate) {
                                        if (values.occurrenceDate.toString().indexOf('/') === -1) {
                                            var ds = values.occurrenceDate;
                                            d = new Date(ds.valueOf());
                                            d = new Date(d.getTime() + d.getTimezoneOffset() * 60000);
                                            console.log(d);
                                            d = d.toISOString();
                                            console.log(d);
                                            if (d)
                                                v[child.getKey() + '/occurrenceDate'] = d;
                                        } else {
                                            var ds = values.occurrenceDate.split('/');
                                            if (ds.length === 3) {
                                                if (ds[2].length === 2)
                                                    ds[2] = '20' + ds[2];

                                                if (ds[1].length === 1)
                                                    ds[1] = '0' + ds[1];

                                                if (ds[0].length === 1)
                                                    ds[0] = '0' + ds[0];
                                                d = new Date(ds[2] + '-' + ds[1] + '-' + ds[0]);
                                                d = new Date(d.getTime() + d.getTimezoneOffset() * 60000);
                                                console.log(d);
                                                d = d.toISOString();
                                                console.log(d);
                                                if (d)
                                                    v[child.getKey() + '/occurrenceDate'] = d;
                                            }
                                        }
                                    }
                                });
                                nonComplianceRef.update(v);
                            });
                        }
                    });
                });
                return null;
            },
            debug_refixDateFormat: function(){
                var departmentsRef = db.ref('departments/');
                
                departmentsRef.once('value', function(snapshot) {
                    snapshot.forEach(function(child) {
                        var deptKey = child.getKey();
                        
                        if ((deptKey === '-Jf8EtJQbnRRnqHO91ZO') || (deptKey === '-JguvXcDmbbKQ-yrekGM') || (deptKey === '-Jf8LsE4qkAlsdeZnPIT')){
                            var nonComplianceRef = db.ref('nonCompliances/' + deptKey);
                            var v = {};
                            nonComplianceRef.once('value', function(snapshot) {
                                snapshot.forEach(function(child) {
                                    var values = child.val();
                                    var d = null;
                                    if (values.occurrenceDate) {
                                        console.log(values.occurrenceDate, deptKey)
                                        if (values.occurrenceDate.toString().indexOf('/') === -1) {
                                            var ds = values.occurrenceDate;
                                            d = new Date(ds.valueOf());
                                            d = new Date(d.getTime() + d.getTimezoneOffset() * 60000);
                                            //console.log(d);
                                            d = d.toISOString();
                                            //console.log(d);
                                            if (d)
                                                v[child.getKey() + '/occurrenceDate'] = d;
                                        } else {
                                            var ds = values.occurrenceDate.split('/');
                                            if (ds.length === 3) {
                                                if (ds[2].length === 2)
                                                    ds[2] = '20' + ds[2];

                                                if (ds[1].length === 1)
                                                    ds[1] = '0' + ds[1];

                                                if (ds[0].length === 1)
                                                    ds[0] = '0' + ds[0];
                                                d = new Date(ds[2] + '-' + ds[1] + '-' + ds[0]);
                                                d = new Date(d.getTime() + d.getTimezoneOffset() * 60000);

                                                d = d.toISOString();

                                                if (d)
                                                    v[child.getKey() + '/occurrenceDate'] = d;
                                            }
                                        }
                                    }
                                });
                                //console.log(v);
                            });
                        //}
                    });
                });
                return null;
            }*/
        }
        
        return obj;
    }
}());
(function () {
    'use strict';

    angular
        .module('app.kpi-data-handler')
        .factory('KpiIndicators', KpiIndicatorsService);

    function KpiIndicatorsService(KpiDataHandlerService, $q, $firebaseArray, $firebaseObject, $cookies, PENTAHO_APP_URL, $http, $filter, $httpParamSerializerJQLike) {
        var
            indicatorList,
            commomList,
            surveyList,
            indicatorObj,
            db = KpiDataHandlerService.database;

        var _data = {
            "parammethod": "GET",
            "paramtype": "kpi"
        };

        var _headers = {
            "Content-Type": 'application/x-www-form-urlencoded;charset=utf-8',
            "Authorization": 'Basic ' + _getAuth()
        };

        var _url = PENTAHO_APP_URL + '/plugin/ppa/api/docstore';

        function _getAuth() {
            var auth = $cookies.getObject('ppaui-pentaho-auth');
            if (auth)
                return auth.authKey;
            else
                return '';
        }

        function excluirId(item) {

            var _temp = angular.copy(item);

            if (_temp.hasOwnProperty('id'))
                delete _temp.id;

            return _temp;
        };

        var obj = {
            getAll: function (departmentKey) {
                // Traz a lista de indicadores do departamento
                var indicatorsRef = db.ref('departments/' + departmentKey).child('kpi');
                indicatorList = $firebaseArray(indicatorsRef);
                return indicatorList;
            },

            getByKey: function (departmentKey, indicatorKey) {
                var path = 'departments/' + departmentKey + '/kpi/' + indicatorKey;
                var indicatorRef = db.ref(path);
                var obj = new $firebaseObject(indicatorRef);
                return obj;
            },

            save: function (indicator, isObj) {
                if (!isObj) {
                    if (indicator.$id)
                        return indicatorList.$save(indicator)
                    else
                        return indicatorList.$add(indicator)
                } else {
                    return indicator.$save(indicator);
                }
            },

            add: function (departmentKey, obj) {
                var path = 'departments/' + departmentKey + '/kpi';
                var departmentRef = db.ref(path);
                return departmentRef.push(obj);
            },

            delete: function (indicatorObj) {

            },

            //Novos métodos
            getIndicadores: function (idDepartamento) {

                var tempData = angular.copy(_data);
                tempData.paramfilter = JSON.stringify({
                    departmentId: idDepartamento
                });

                return $http({
                    method: 'GET',
                    url: _url,
                    headers: _headers,
                    params: tempData
                });
            },

            format: function (result) {
                var indicadores = [];
                if (result) {
                    for (var property in result) {
                        var dep = result[property];
                        dep.id = property;
                        indicadores.push(dep);
                    }
                }

                return indicadores;
            },

            salvar: function (indicador, edicao) {

                var tempData = angular.copy(_data);
                if (edicao) {
                    tempData.parammethod = 'PUT';
                    tempData.paramid = indicador.id;
                    indicador = excluirId(indicador);
                } else {
                    tempData.parammethod = 'POST';
                }

                tempData.paramdoc = JSON.stringify(indicador);

                return $http({
                    method: 'POST',
                    url: _url,
                    data: $httpParamSerializerJQLike(tempData),
                    headers: _headers
                })
            }
        }

        return obj;
    }
}());
(function (module) {
    'use strict';

    module.service('EventTypesService', function ($cookies, PENTAHO_APP_URL, $http, $filter, $httpParamSerializerJQLike) {

        var _data = {
            "parammethod": "GET",
            "paramtype": "event-type"
        };

        var _headers = {
            "Content-Type": 'application/x-www-form-urlencoded; charset=UTF-8',
            "Authorization": 'Basic ' + _getAuth()
        };

        var _url = PENTAHO_APP_URL + '/plugin/ppa/api/docstore';

        function _getAuth() {
            var auth = $cookies.getObject('ppaui-pentaho-auth');
            if (auth)
                return auth.authKey;
            else
                return '';
        }

        function excluirId(item) {

            var _temp = angular.copy(item);

            if (_temp.hasOwnProperty('id'))
                delete _temp.id;

            return _temp;
        };

        var services = {
            getTiposEventos: function () {
                return $http({
                    method: 'GET',
                    url: _url,
                    headers: _headers,
                    params: _data
                });
            },

            format: function (result) {
                var tiposEventos = [];
                if (result) {
                    for (var property in result) {
                        var tipo = result[property];
                        tipo.id = property;
                        tiposEventos.push(tipo);
                    }
                }

                return tiposEventos;
            },

            salvar: function (type, edicao) {

                var tempData = angular.copy(_data);
                if (edicao) {
                    tempData.parammethod = 'PUT';
                    tempData.paramid = type.id;
                    type = excluirId(type);
                } else {
                    tempData.parammethod = 'POST';
                }

                tempData.paramdoc = JSON.stringify(type);

                return $http({
                    method: 'POST',
                    url: _url,
                    data: $httpParamSerializerJQLike(tempData),
                    headers: _headers
                })
            },

            delete: function (type) {

                var tempData = angular.copy(_data);
                tempData.parammethod = 'DELETE';
                tempData.paramid = type.id;
                type = excluirId(type);

                tempData.paramdoc = JSON.stringify(type);

                return $http({
                    method: 'POST',
                    url: _url,
                    data: $httpParamSerializerJQLike(tempData),
                    headers: _headers
                })
            }
        };

        return services;
    });

}(angular.module('app.kpi-data-handler')));
(function () {
    'use strict';

    angular
        .module('app.kpi-data-handler')
        .service('KpiDepartments', KpiDepartmentsService)

    function KpiDepartmentsService(KpiDataHandlerService, $q, $firebaseArray, AuthService, $rootScope, $cookies, PENTAHO_APP_URL, $http, $filter, $httpParamSerializerJQLike) {
        var
            vm = this,
            db = KpiDataHandlerService.database,
            allDepartments,
            departmentList,
            departmentObj;

        var _data = {
            "parammethod": "GET",
            "paramtype": "department"
        };

        var _headers = {
            "Content-Type": 'application/x-www-form-urlencoded; charset=UTF-8',
            "Authorization": 'Basic ' + _getAuth()
        };

        var _url = PENTAHO_APP_URL + '/plugin/ppa/api/docstore';

        function _getAuth() {
            var auth = $cookies.getObject('ppaui-pentaho-auth');
            if (auth)
                return auth.authKey;
            else
                return '';
        }

        function excluirId(item) {

            var _temp = angular.copy(item);

            if (_temp.hasOwnProperty('id'))
                delete _temp.id;

            return _temp;
        };

        var obj = {
            getDepartments: function (user) {
                // Traz a lista de departamentos
                var departmentsRef = db.ref('departments')
                    .orderByChild('manager')
                    .equalTo(user);

                if ($rootScope.userContext &&
                    (user === AuthService.authSessions.pentahoSession.username)) {
                    if ($rootScope.userContext.isAdmin ||
                        $rootScope.userContext.isQualityManager) {
                        departmentsRef = db.ref('departments');
                    }
                }

                departmentList = $firebaseArray(departmentsRef);
                return departmentList;
            },

            getAllDepartments: function () {
                // Traz a lista de departamentos
                var departmentsRef = db.ref('departments');
                allDepartments = $firebaseArray(departmentsRef);
                return allDepartments;
            },

            getByKey: function (departmentKey) {
                var path = 'departments/' + departmentKey;
                var departmentRef = db.ref(path);
                var obj = new $firebaseObject(departmentRef);
                return obj;
            },

            add: function (obj) {
                var path = 'departments/';
                var departmentRef = db.ref(path);
                return departmentRef.push(obj);
            },

            //Novos métodos
            getDepartamentos: function () {
                return $http({
                    method: 'GET',
                    url: _url,
                    headers: _headers,
                    params: _data
                });
            },

            format: function (result) {
                var departamentos = [];
                if (result) {
                    for (var property in result) {
                        var dep = result[property];

                        if (($rootScope.userContext.isAdmin || $rootScope.userContext.isQualityManager) || (AuthService.authSessions.pentahoSession.username === dep.responsible)) {
                            dep.id = property;
                            departamentos.push(dep);
                        }
                    }
                }

                return $filter('orderBy')(departamentos, 'name');
            },

            formatWithoutRules: function (result) {
                var departamentos = [];
                if (result) {
                    for (var property in result) {
                        var dep = result[property];
                        dep.id = property;
                        departamentos.push(dep);
                    }
                }

                return $filter('orderBy')(departamentos, 'name');
            },

            salvar: function (departamento, edicao) {

                var tempData = angular.copy(_data);
                if (edicao) {
                    tempData.parammethod = 'PUT';
                    tempData.paramid = departamento.id;
                    departamento = excluirId(departamento);
                } else {
                    tempData.parammethod = 'POST';
                }

                tempData.paramdoc = JSON.stringify(departamento);

                return $http({
                    method: 'POST',
                    url: _url,
                    data: $httpParamSerializerJQLike(tempData),
                    headers: _headers
                })
            },

            delete: function (departamento) {

                var tempData = angular.copy(_data);
                tempData.parammethod = 'DELETE';
                tempData.paramid = departamento.id;
                departamento = excluirId(departamento);

                tempData.paramdoc = JSON.stringify(departamento);

                return $http({
                    method: 'POST',
                    url: _url,
                    data: $httpParamSerializerJQLike(tempData),
                    headers: _headers
                })
            }
        }

        return obj;
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        /*msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
        msApiProvider.register('quickPanel.recent-analytics', ['app/data/quick-panel/recent-analytics.json']);*/
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('RecentAnalyticsController', RecentAnalyticsController);

    /** @ngInject */
    function RecentAnalyticsController(msApi, localStorageService, $scope, $state, $rootScope)
    {
        var vm = this;

        $rootScope.$on('restorestate', function(event, data){
            getData();
        });
        getData();
        
        // Data
        vm.analytic = {};

        // Methods
        vm.gotoState = gotoState;
        vm.clearRecentAnalytics = clearRecentAnalytics;
        vm.getData = getData;

        //////////
        
        function getData()
        {
            /*var lsData = localStorageService.get('recent-analytics');
            if (lsData)
                vm.recentAnalytics = JSON.parse(lsData).data;
            else
                vm.recentAnalytics = null;*/
        }
        
        function clearRecentAnalytics(){
            /*localStorageService.set('recent-analytics', '');
            $rootScope.$broadcast('restorestate');*/
        }

        function gotoState(state)
        {
            //$state.go(state);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider() {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var states = [];

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;
        service.getStates = getStates;

        function getStates() {
            return states;
        }

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for (var i = 0; i < parent.length; i++) {
                if (parent[i]._id === id) {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if (updateItem) {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
                states.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for (var p = 0; p < parts.length; p++) {
                var id = parts[p];

                for (var i = 0; i < item.length; i++) {
                    if (item[i]._id === id) {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if (item[i]._path === path) {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent) {
            // If parent not provided, sort the root items
            if (!parent) {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for (var i = 0; i < parent.length; i++) {
                var children = parent[i].children;

                if (children.length > 1) {
                    children.sort(_byWeight);
                }

                if (children.length > 0) {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts) {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if (parts.length === 1) {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for (var i = 0; i < parts.length; i++) {
                var _id = parts[i],
                    createParent = true;

                for (var p = 0; p < parent.length; p++) {
                    if (parent[p]._id === _id) {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if (createParent) {
                    var item = {
                        _id: _id,
                        _path: parts.join('.'),
                        title: _id,
                        weight: 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y) {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item) {
            var uisref = '';

            if (angular.isDefined(item.state)) {
                uisref = item.state;

                if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function () {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem: saveItem,
                getStates: getStates,
                deleteItem: deleteItem,
                sort: sortByWeight,
                clearNavigation: clearNavigation,
                setActiveItem: setActiveItem,
                getActiveItem: getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope: setNavigationScope,
                setFolded: setFolded,
                getFolded: getFolded,
                setFoldedOpen: setFoldedOpen,
                getFoldedOpen: getFoldedOpen,
                toggleFolded: toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation() {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if (navigationScope) {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope) {
                activeItem = {
                    node: node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem() {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root) {
                if (root) {
                    for (var i = 0; i < navigation.length; i++) {
                        if (navigation[i]._id === root) {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope) {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status) {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded() {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status) {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen() {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded() {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService) {
        var vm = this;

        // Data
        if ($scope.root) {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        } else {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                folded: '=',
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement) {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if (msNavigationService.getFolded() === null) {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if (msNavigationService.getFolded()) {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function () {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function () {
                        return sidenav.isLockedOpen();
                    }, function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if (folded) {
                            if (current) {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            } else {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if (activeItem) {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded) {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if (folded) {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        } else {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if (activeItem) {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander() {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function () {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser() {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser() {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if (activeItem) {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function () {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function () {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if (msNavigationService.getFolded()) {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function () {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;
        vm.checkItemState = checkItemState;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if (!vm.hasChildren || vm.group) {
                vm.collapsable = false;
            } else {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if (!vm.collapsable) {
                vm.collapsed = false;
            } else {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Expand if the current scope is collapsable and is collapsed
                if (vm.collapsable && vm.collapsed) {
                    $scope.$evalAsync(function () {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path) {
                if (vm.collapsed || !vm.collapsable) {
                    return;
                }

                // If there is no path defined, collapse
                if (angular.isUndefined(path)) {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if (activeItem) {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if (givenPathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    // Test for active path
                    if (activePathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                if (vm.node.state === $state.current.name) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed() {
            if (vm.collapsed) {
                vm.expand();
            } else {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl, {
                        'display': 'block',
                        'height': height + 'px'
                    }, {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function () {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height': ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand() {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position': 'absolute',
                'visibility': 'hidden',
                'display': 'block',
                'height': 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position': '',
                'visibility': '',
                'display': '',
                'height': ''
            });

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl, {
                        'display': 'block',
                        'height': '0px'
                    }, {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function () {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden() {
            if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
                return vm.node.hidden();
            }

            return false;
        }

        /**
         * Verifica se o estado pode ser recarregado, caso possa, faz o reload()
         *
         * @returns {boolean}
         */
        function checkItemState(state) {
            if ((state.substr(0, 14) == 'app.analytics-') && (state == $state.current.name))
                $state.reload(state);
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller: 'MsNavigationNodeController as vm',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective() {
        return {
            restrict: 'A',
            require: '^msNavigationNode',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // If the item is collapsable...
                    if (MsNavigationNodeCtrl.collapsable) {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope) {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Mark as active if has children
                if (vm.hasChildren) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function () {
                if (!vm.hasChildren) {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if (activePathParts.indexOf(vm.node._id) > -1) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                } else {
                    $scope.$evalAsync(function () {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                if (vm.node.state === $state.current.name) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller: 'MsNavigationHorizontalNodeController as vm',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationHorizontalNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia) {
        return {
            restrict: 'A',
            require: '^msNavigationHorizontalNode',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    iElement.on('click', onClick);

                    function onClick() {
                        if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('searchBar', searchBarDirective);

    /** @ngInject */
    function searchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            controller : 'SearchBarController as ctrl',
            templateUrl: 'app/toolbar/search-bar/search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#search-bar-expander');
                        collapserEl = iElement.find('#search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }
					
					scope.ctrl.close = collapse;

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');
						
						var inputEl = iElement.find('input');
						inputEl.focus()

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function () {
  'use strict';
  angular
      .module('app.core')
      .controller('SearchBarController', SearchBarController);
    function SearchBarController($q, $rootScope, $state) {

        var vm = this;

        vm.isDisabled = false;
        vm.states = null;

        vm.reload = reload;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        // methods
        function querySearch(query) {
            var results, deferred;

            if (vm.states) {
                results = vm.states.filter(createFilterFor(query));
                deferred = $q.defer();
                deferred.resolve(results);
                return deferred.promise;
            }
        }

        function searchTextChange(text) {
            vm.reload();
        }

        function selectedItemChange(item) {
            if (item) {
                vm.item = null;
                vm.searchText = null;
                vm.close();
                // hack usado para impedir q a div relacionada a pesquisa fique 'travada' sobre a tela
                // impedindo o uso
                setTimeout(function(){ $('.md-scroll-mask').remove(); }, 1000);
                $state.go(item.ref);
            }
        }

        function reload()
        {
            vm.states = loadAll();
        }

        function loadAll() 
        {
            var allStates = $rootScope.statesTitles;
            return allStates;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query)
        {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(state){
                return (state.title.toLowerCase().indexOf(lowercaseQuery) >= 0);
            };
        }
    }
})();

(function(){
    'use strict';
    
    angular
        .module('app.core')
        .directive('contextBar', ContextBarDirective);
    
    function ContextBarDirective(){
        return {
            restrict   : 'E',
            scope      : {
                update: '='
            },
            controller : 'ContextBarController as ctrl',
            templateUrl: 'app/toolbar/context-bar/context-bar.html',
            compile    : function (tElement, $rootScope)
            {
                // Add class
                tElement.addClass('context-bar');
                
                return function postLink(scope, iElement)
                {
                    var activeEl;
                
                    // Initialize
                    init();
                    
                    scope.$on('changeContext',function(event, data){
                        update(data);
                    });
                    
                    function update(data)
                    {
                        // Informa o contexto ativo
                        activate(null, 'icn-' + data.ctx);
                    }

                    function init()
                    {
                        activeEl = iElement.find('.icon-ctx');

                        activeEl.on('click', activate);
                    }

                    /**
                     * Activate
                     */
                    function activate(e, id)
                    {
                        deactivate()
                        activeEl = angular.element('#' + (id || e.target.id));
                        activeEl.addClass('md-accent');
                        activeEl.addClass('icon-ctx-active');
                    }

                    /**
                     * Collapse
                     */
                    function deactivate()
                    {
                        activeEl = iElement.find('.icon-ctx-active');
                        activeEl.removeClass('md-accent');
                        activeEl.removeClass('icon-ctx-active');
                    }
                }
            }
        };
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('ContextBarController', ContextBarController);

    function ContextBarController(fuseTheming, $rootScope, $state, $scope, PentahoService, StateFactoryClear) {
        var vm = this;

        vm.selectContext = selectContext;
        vm.refreshMenu = refreshMenu;

        vm.themes = fuseTheming.themes;

        function selectContext(ctx, state) {
            $rootScope.activeContextApp = ctx;
            if (state)
                $state.go(state);
        }

        $rootScope.$on('finishReload', function () {
            vm.refreshingMenu = 0;
        });

        function refreshMenu() {
            vm.refreshingMenu = 1;
            StateFactoryClear();
        }
    }
}());
(function(){
    'use strict';
    
    angular.module('app.pentaho-connector', [
        
        //Autenticacao para o Pentaho BI Server
        'app.pentaho-connector.pentaho-authentication',
        
        //Manipulador de dados e requisições REST
        'app.pentaho-connector.pentaho-data-handler',
        
        //Renderizador de dados
        'app.pentaho-connector.pentaho-viewer'
    ]);
}());
(function(){
    'use strict';
    
    angular.module('app.pentaho-connector')
    .service('PentahoConnectorService', PentahoConnectorService);
    
    /** @ngInject **/
    function PentahoConnectorService(PentahoAuthenticationService, PentahoViewerService, PentahoDataHandlerService)
    {
        var vm = this;
        
        vm.auth = PentahoAuthenticationService;
        vm.viewer = PentahoViewerService;
        vm.dh = PentahoDataHandlerService;
    }
}());
(function(){
    'use strict';
    
    angular.module('app.activiti-connector')
    .service('ActivitiConnectorService', ActivitiConnectorService);
    
    /** @ngInject **/
    function ActivitiConnectorService(ActivitiAuthenticationService, ActivitiDataHandlerService)
    {
        var vm = this;
        
        vm.auth = ActivitiAuthenticationService;
        vm.dh = ActivitiDataHandlerService;
    }
}());
(function(){
    'use strict';
    
    angular
        .module('app.admintools-data-handler')
        .service('AdminToolsDataHandlerService', AdminToolsDataHandlerService)
    
    function AdminToolsDataHandlerService()
    {
        var vm = this;
    }
}());
(function(){
    'use strict';
    
    angular
        .module('app.kpi-data-handler')
        .service('KpiDataHandlerService', KpiDataHandlerService)
    
    function KpiDataHandlerService(APP_CFG)
    {
        var vm = this;
        
        /*var config = {
            apiKey: "AIzaSyBG9I0-pgpeUTD6vUczWb1yH65Pr4p_A9Y",
            authDomain: "sghq.firebaseapp.com",
            databaseURL: "https://sghq.firebaseio.com/",
            storageBucket: "project-5102354495278682660.appspot.com",
        };*/
        
        /*var config = {
            apiKey: "AIzaSyB0-yCNd2Wt9s1gQCBPpw5sR5J7bl2PtcM",
            authDomain: "sghq-s0103.firebaseapp.com",
            databaseURL: "https://sghq-s0103.firebaseapp.com",
            storageBucket: "sghq-s0103.appspot.com",
        };*/
        
        // Initialize Firebase
        var config = {
            apiKey: APP_CFG["FB_APP_KEY"],
            authDomain: APP_CFG["FB_AUTH_DOMAIN"],
            databaseURL: APP_CFG["FB_KPI_URL"],
            storageBucket: APP_CFG["FB_STRG_BKT"]
        };
        var a = firebase.initializeApp(config);
        
        vm.database = firebase.database();
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        /*$stateProvider
            .state('app.login', {
                url    : '/login',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/login/login.html',
                        controller : 'LoginController as vm'
                    }
                },
                authenticate: false
            });*/

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/login');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(AuthService, $mdToast, $scope, $rootScope, $state, APP_CFG) {
        var vm = this;
        var ACTIVE_APPS = APP_CFG['ACTIVE_APPS'];

        vm.authInProgress = false;

        vm.login = login;
        vm.submit = submit;

        // vm.user = {username: 'VLT', password: 'pwVLTone%Btt'}
        $rootScope.$broadcast('hideSplash');

        // Chama o serviço de autenticação
        function login() {
            vm.authInProgress = true;

            AuthService.chainedLogin(vm.user)
                .then(function () {
                    AuthService.authSessions.loggedIn = true;

                    AuthService.updateAuthInformation();

                    $rootScope.$broadcast('createnavigation');
                    vm.authInProgress = false;
                    AuthService.loginRedirect('app.home', true);
                }, function (err) {
                    // /*REMOVER ISTO (DEIXAR APENAS O ELSE) APÓS RESOLVER O PROBLEMA DO HTTPS AO EFETUAR O POST EM J_SPRING_SECURITY_CHECK*/
                    // /*------*/
                    // if (APP_CFG['DEV_USR']) {
                    //     // Simula o login no pentaho

                    //     AuthService.authSessions.loggedIn = true;
                    //     vm.authInProgress = false;
                    //     AuthService.loginRedirect('app.home', true);
                    // } else {
                    //     AuthService.authSessions.loggedIn = false;
                    //     vm.authInProgress = false;
                    //     toast('Falha ao efetuar login.');
                    // }
                    // /*------*/
                    AuthService.authSessions.loggedIn = false;
                    vm.authInProgress = false;
                    toast('Falha ao efetuar login.');
                });
        }

        // Exibe mensagem ao usuário
        function toast(msg) {
            $mdToast.show(
                $mdToast.simple()
                .textContent(msg)
                .position('bottom right')
                .hideDelay(3000)
            );
        };

        function submit(field, event) {
            if (vm.user.username && vm.user.password) {
                var keycode;
                if (window.event)
                    keycode = window.event.keyCode;
                else if (event)
                    keycode = event.which;
                else return true;

                if (keycode == 13)
                    vm.login();
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.home')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController($rootScope, $injector, $state, PENTAHO_APP_URL, $http, APP_CFG, Settings, $timeout, AuthService, Docstore) {
        var vm = this;

      // this snippet just inoke an endpoint to set username on the session
      // and have no relation with other things in this controller
      $http({
        method: 'GET',
        url: PENTAHO_APP_URL + '/plugin/ppa/api/init_session',
        headers: {
          'Accept': 'text/plain',
          'Content-Type': 'text/plain'
        }
      });


      // Deixei comentado pq não está tendo o efeito esperado, uma vez que
      // está sendo executado depois que o menu já foi iniciado e a verificação
      // pelas feature flags já foi feita.
      //
      // Initialize Docstore read for feature flags
      //Docstore.read(
      //  {paramtype: '__featflag__'},
      //  function(res) {
      //    if (res.documents && res.documents.default) {
      //      const ff = res.documents.default;
      //      console.info('Reseting FEATURE_FLAGS for ' + JSON.stringify(ff))
      //      APP_CFG['FEATURE_FLAGS'] = ff
      //    }
      //    console.warn(APP_CFG);
      //  }
      //)

      // Referência do contexto ativo
        if (!$rootScope.activeContextApp)
            $rootScope.activeContextApp = 'main';

      function withRetry (f, n, fs, fe) {
        try {
          f(n)
          // call success function if provided
          fs && fs()
        } catch (e) {
          console.warn('An error ocurred inside withRetry');
          console.warn(e);
          if (n > 0) {
            console.warn('A new attempt (' + n + ') will be made in 1 sec');
            setTimeout(function(){withRetry(f,--n, fs, fe)}, 1000);
          } else {
            console.error('I will not try anymore');
            // call error function if provided
            if (fe) {
              console.info('Error function was provided to withRetry. Calling it now!');
              fe();
            }
          }
        }
      }

        function goToHome(docstoreResult) {
            var hasHome = false;
            for (var d in docstoreResult.documents) {
              $rootScope.usersPreferencesLoaded = true;
              console.info("Trying to go to user home page");
              withRetry(
                function () {
                  console.info('Setting loadingProgress');
                  if (docstoreResult.documents[d] && docstoreResult.documents[d].home) {
                    hasHome = true;
                    var home = docstoreResult.documents[d].home;
                    if (home.substr(0, 14) == 'app.analytics-') {
                      $rootScope.activeContextApp = 'pentaho';
                    }
                    $rootScope.loadingProgress = true;
                    $state.go(home);
                    $rootScope.loadingProgress = false;
                  }
                  if(!hasHome && APP_CFG['ACTIVE_APPS'].indexOf('activiti') != -1) {
                    $state.go('app.tasks');
                  }
                },
                15
              );
            }
            $rootScope.loadingProgress = false;
        };

      //Cada contexto deverá alimentar esta variável quando for chamado,
      //para que o sistema troque para a view correspondente
        $rootScope.$watchCollection('activeContextApp', function(newValue, oldValue){
            vm.context = $rootScope.activeContextApp;
            $rootScope.$broadcast('changeContext', {ctx: $rootScope.activeContextApp});
        });

      $rootScope.$on('repository-content-loaded', function() {
        $rootScope.activeContextApp = 'pentaho';
        if (!$rootScope.userPreferencesLoaded) {
          console.info('Getting user settings...');
          Docstore.read(
            {
              paramtype: 'user-settings',
              paramfilter: {user: AuthService.authSessions.pentahoSession.username}
            },
            function(res){
              console.info('Got response for user settings...');
              if(!res.documents || Object.keys(res.documents).length == 0) {
                Docstore.read(
                  {paramtype: 'user-settings', paramfilter: {user: '*'}},
                  function(res){goToHome(res);}
                );
              }
              goToHome(res);
              $rootScope.userPreferencesLoaded = true;
            }
          )
        }
      });
    }
})();

(function (module) {
    'use strict';

    module.controller('ConfigurationController', ['$scope', 'User', '$state', 'msNavigationService', '$cookies', 'PENTAHO_APP_URL', '$http', '$httpParamSerializerJQLike', '$mdToast', '$rootScope', 'AuthService', 'APP_CFG',
        function ($scope, User, $state, msNavigationService, $cookies, PENTAHO_APP_URL, $http, $httpParamSerializerJQLike, $mdToast, $rootScope, AuthService, APP_CFG) {

            var _data = {
                "parammethod": "GET",
                "paramtype": "user-settings"
            };

            var _headers = {
                "Content-Type": 'application/x-www-form-urlencoded; charset=UTF-8',
                "Authorization": 'Basic ' + _getAuth()
            };

            var _url = PENTAHO_APP_URL + '/plugin/ppa/api/docstore';

            function _getAuth() {
                var auth = $cookies.getObject('ppaui-pentaho-auth');
                if (auth)
                    return auth.authKey;
                else
                    return '';
            }

            function format() {
                var departamentos = [];
                if (result) {
                    for (var property in result) {
                        var dep = result[property];
                        dep.id = property;
                        departamentos.push(dep);
                    }
                }
            }

            function excluirId(item) {

                var _temp = angular.copy(item);

                if (_temp.hasOwnProperty('id'))
                    delete _temp.id;

                return _temp;
            };

            $scope.onSelectUser = function (user) {

                $scope.showStates = 0;
                $scope.userSettings.home = undefined;
                $scope.userSettings = excluirId($scope.userSettings);

                var tempData = angular.copy(_data);
                tempData.paramfilter = JSON.stringify({
                    user: user
                });

                $http({
                    method: 'GET',
                    url: _url,
                    headers: _headers,
                    params: tempData
                }).then(function success(response) {
                    $scope.showStates = 1;

                    var hasResult = 0;
                    if (response.data.documents)
                        for (var prop in response.data.documents) {
                            hasResult = 1;
                        }

                    if (hasResult)
                        $scope.userSettings = format(response.data.documents);
                }, function error(response) {
                    $scope.userSettings.state = undefined;
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Ocorreu um erro ao buscar as configurações!')
                        .position('bottom right')
                        .hideDelay(3000)
                    );
                });
            };

            ($scope.getUsers = function () {

                $scope.isAdmin = $rootScope.userContext ? $rootScope.userContext.isAdmin : false;
                $scope.session = AuthService.authSessions.pentahoSession;
                $scope.userSettings = {};

                if (!$scope.isAdmin) {
                    $scope.userSettings.user = $scope.session.username;
                    $scope.onSelectUser($scope.session.username);
                } else {
                    var x2js = new X2JS();

                    $http.get(PENTAHO_APP_URL + '/api/users', {
                        headers: _headers,
                        transformResponse: function (cnv) {
                            var x2js = new X2JS();
                            var aftCnv = x2js.xml_str2json(cnv);
                            return aftCnv;
                        }
                    }).then(function success(response) {
                        $scope.usuarios = response.data.users.user;
                        $scope.usuarios = $scope.usuarios.sort();

                        if (!$scope.isAdmin) {
                            $scope.userSettings.user = $scope.session.username;
                            $scope.onSelectUser();
                        }
                    }, function error(response) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent('Ocorreu um erro ao buscar os usuários!')
                            .position('bottom right')
                            .hideDelay(3000)
                        );
                    });
                }
            })();

            if (!msNavigationService.getStates() || msNavigationService.getStates().length == 0) {
                $scope.loading = 1;
                $rootScope.$on('finishReload', function () {
                    montarListaStates();
                });
            } else {
                montarListaStates();
            }

            function montarListaStates() {
                $scope.states = _.filter(msNavigationService.getStates(), function (item) {
                    return item.children.length > 0;
                });

                $scope.states = _.sortBy($scope.states, 'title');
                $scope.loading = 0;
            };

            function format(result) {
                if (result) {
                    for (var property in result) {
                        var obj = result[property];
                        obj.id = property;
                        return obj;
                    }
                }
                return null;
            };

            $scope.saveConfig = function () {
                var tempData = angular.copy(_data);
                if ($scope.userSettings.id) {
                    tempData.parammethod = 'PUT';
                    tempData.paramid = $scope.userSettings.id;
                    $scope.userSettings = excluirId($scope.userSettings);
                } else {
                    tempData.parammethod = 'POST';
                }

                tempData.paramdoc = JSON.stringify($scope.userSettings);

                $http({
                    method: 'POST',
                    url: _url,
                    data: $httpParamSerializerJQLike(tempData),
                    headers: _headers
                }).then(function success(response) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Configurações salvas com sucesso!')
                        .position('bottom right')
                        .hideDelay(3000)
                    );
                }, function error(response) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent('Ocorreu um erro ao salvar as configurações!')
                        .position('bottom right')
                        .hideDelay(3000)
                    );
                });
            };

            $scope.changePass = {};
            $scope.changePassEnabled = APP_CFG && APP_CFG['FEATURE_FLAGS'] && APP_CFG['FEATURE_FLAGS']['change-password'];
            $scope.changePassword = function() {
              $http({
                method: 'PUT',
                url: PENTAHO_APP_URL + '/api/userroledao/user',
                data: "<?xml version='1.0' encoding='UTF-8'?>" +
                      "<ChangePasswordUser>" +
                      "  <userName>" + $scope.session.username.toLowerCase() + "</userName>" +
                      "  <newPassword>" + $scope.changePass.new + "</newPassword>" +
                      "  <oldPassword>" + $scope.changePass.old + "</oldPassword>" +
                      "</ChangePasswordUser>",
                headers: {
                  "Content-Type": 'application/xml; charset=UTF-8',
                  "Authorization": 'Basic ' + _getAuth()
                }
              }).then(function success(response) {
                  $mdToast.show(
                      $mdToast.simple()
                      .textContent('Nova senha salva com sucesso.')
                      .position('bottom right')
                      .hideDelay(3000)
                  );
              }, function error(response) {
                  $mdToast.show(
                      $mdToast.simple()
                      .textContent('Ocorreu um erro na tentativa de salvar uma nova senha!')
                      .position('bottom right')
                      .hideDelay(3000)
                  );
              });
            };
        }
    ]);

}(angular.module('app.home')));

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window) {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists: exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile: isMobile,
            toggleInArray: toggleInArray,
            clearLocalStorage: clearLocalStorage,
            clearSessionStorage: clearSessionStorage
        };

        return service;

        function clearSessionStorage() {
            if (sessionStorage) {
                sessionStorage.clear();
            } else if (window.sessionStorage) {
                window.sessionStorage.clear();
            }
        }

        function clearLocalStorage() {
            if (localStorage) {
                localStorage.clear();
            } else if (window.localStorage) {
                window.localStorage.clear();
            }
        }

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser() {
            // If we already tested, do not test again
            if (browserInfo) {
                return browserInfo;
            }

            var browserData = [{
                    string: $window.navigator.userAgent,
                    subString: 'Edge',
                    versionSearch: 'Edge',
                    identity: 'Edge'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity: 'Chrome'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity: 'OmniWeb'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Apple',
                    versionSearch: 'Version',
                    identity: 'Safari'
                },
                {
                    prop: $window.opera,
                    identity: 'Opera'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'iCab',
                    identity: 'iCab'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'KDE',
                    identity: 'Konqueror'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity: 'Firefox'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Camino',
                    identity: 'Camino'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity: 'Netscape'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'MSIE',
                    identity: 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Trident/7',
                    identity: 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Gecko',
                    identity: 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Mozilla',
                    identity: 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [{
                    string: $window.navigator.platform,
                    subString: 'Win',
                    identity: 'Windows'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Mac',
                    identity: 'Mac'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Linux',
                    identity: 'Linux'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPhone',
                    identity: 'iPhone'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPod',
                    identity: 'iPod'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPad',
                    identity: 'iPad'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Android',
                    identity: 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) !== -1) {
                            return data[i].identity;

                        }
                    } else if (dataProp) {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString) {
                var index = dataString.indexOf(versionSearchString);

                if (index === -1) {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os: os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator() {
            var S4 = function () {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile() {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array) {
            if (array.indexOf(item) === -1) {
                array.push(item);
            } else {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('modalState', modalState);

    /** @ngInject */
    function modalState($stateProvider)
    {
        var provider = this;
        var modalResult;
        
        this.$get = function() {
            return provider;
        };
        
        
        this.state = function(stateName, options) {
            var modalInstance;
            
            $stateProvider.state(stateName, {
                url: options.url,
                onEnter: ['$mdDialog', '$state', function($mdDialog, $state) {
                    $mdDialog.show({
                        controller  : options.controller,
                        templateUrl: options.templateUrl,
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: true
                    })
                    .then(function(result) {
                        modalResult = result;
                    }).finally(function() { // modal closes
                        modalResult = null;
                        if ($state.$current.name === stateName) {
                            $state.go('^'); // go to parent state
                        }
                    });
                }],
                onExit: function() {
                    console.log('FECHOU!');
                }
            });
            
            return provider;
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'veltio'     : {
            primary   : {
                name: 'veltio-blue-grey',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'veltio-accent-green', //5461
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'veltio-background',
                hues: {
                    'default': '50',
                    'hue-1'  : '200',
                    'hue-2'  : '100',
                    'hue-3'  : '50'
                }
            }
        },
        'spdata'     : {
            primary   : {
                name: 'spdata-blue',
                hues: {
                    'default': '900', //9 6 4 1
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'spdata-accent-blue', //8 4 6 1
                hues: {
                    'default': '800',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'spdata-red'},
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '200'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'veltio-green',
            options: {
                '50': '#1eacaf',
                '100': '#1eacaf',
                '200': '#1eacaf',
                '300': '#04868f',
                '400': '#04868f',
                '500': '#04868f',
                '600': '#05686b',
                '700': '#05686b',
                '800': '#05686b',
                '900': '#034749',
                'A100': '#1eacaf',
                'A200': '#04868f',
                'A400': '#05686b',
                'A700': '#034749',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'veltio-accent-green',
            options: {
                '50': '#1eacaf',
                '100': '#1eacaf',
                '200': '#1eacaf',
                '300': '#04868f',
                '400': '#04868f',
                '500': '#04868f',
                '600': '#05686b',
                '700': '#05686b',
                '800': '#05686b',
                '900': '#034749',
                'A100': '#1eacaf',
                'A200': '#04868f',
                'A400': '#05686b',
                'A700': '#034749',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'veltio-blue-grey',
            options: {
                '50': '#ffffff',
                '100': '#8ea5af',
                '200': '#cddbdb',
                '300': '#748a96',
                '400': '#748a96',
                '500': '#748a96',
                '600': '#526770',
                '700': '#526770',
                '800': '#526770',
                '900': '#3d4d54',
                'A100': '#8ea5af',
                'A200': '#748a96',
                'A400': '#526770',
                'A700': '#3d4d54',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'veltio-background',
            options: {
                '50': '#ffffff',
                '100': '#cddbdb',
                '200': '#f4f4f4',
                '300': '#bac3c3',
                '400': '#96a9a8',
                '500': '#bac3c3',
                '600': '#57706f',
                '700': '#495e5d',
                '800': '#223331',
                '900': '#223331',
                'A100': '#ededed',
                'A200': '#cddbdb',
                'A400': '#96a9a8',
                'A700': '#495e5d',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'spdata-blue',
            options: {
                '50': '#56bee9',
                '100': '#56bee9',
                '200': '#56bee9',
                '300': '#00a0cd',
                '400': '#00a0cd',
                '500': '#00a0cd',
                '600': '#006d8e',
                '700': '#006d8e',
                '800': '#006d8e',
                '900': '#004259',
                'A100': '#56bee9',
                'A200': '#00a0cd',
                'A400': '#006d8e',
                'A700': '#004259',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'spdata-accent-blue',
            options: {
                '50': '#56bee9',
                '100': '#56bee9',
                '200': '#56bee9',
                '300': '#00a0cd',
                '400': '#00a0cd',
                '500': '#00a0cd',
                '600': '#006d8e',
                '700': '#006d8e',
                '800': '#006d8e',
                '900': '#004259',
                'A100': '#56bee9',
                'A200': '#00a0cd',
                'A400': '#006d8e',
                'A700': '#004259',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'spdata-red',
            options: {
                '50': '#e30614',
                '100': '#e30614',
                '200': '#e30614',
                '300': '#c6140e',
                '400': '#c6140e',
                '500': '#c6140e',
                '600': '#ae0e09',
                '700': '#ae0e09',
                '800': '#ae0e09',
                '900': '#800e0b',
                'A100': '#e30614',
                'A200': '#c6140e',
                'A400': '#ae0e09',
                'A700': '#800e0b',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($http, $rootScope, $mdSidenav, $translate, $mdToast, $state, AuthService, msUtils, msNavigationService, PENTAHO_APP_URL) {
        var vm = this;

        vm.visible = AuthService.authSessions.loggedIn;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.session = AuthService.authSessions.pentahoSession;
        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [{
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title': 'Portugês',
                'code': 'pt-br',
                'flag': 'br'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            tr: {
                'title': 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code': 'tr',
                'flag': 'tr'
            }
        };
      // Initilize as `false` so that a later call will change to true if docs/index.html exists
      vm.hasDocs = false;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.containerStateProfile = containerStateProfile;
        vm.containerStateAbout = containerStateAbout;
        vm.config = config;
        vm.containerStateInbox = containerStateInbox;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.openBiServer = openBiServer;
        vm.openDocs = openDocs;
        //\

        function config() {
            $state.go('app.home.configuration');
        }

        function openBiServer() {
          window.open('/pentaho/Home', '_blank');
        }

        init();
      touchDocPage()

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }

      /**
       * Checks if a ...docs/index.html page exists then set vm.hasDocs
       */
      function touchDocPage () {
        const sf = function(r) { vm.hasDocs = true };
        $http.head(PENTAHO_APP_URL + '/api/repos/ppa/static/docs/index.html').then(sf)
      }

      function openDocs () {
        const u = PENTAHO_APP_URL + '/api/repos/ppa/static/docs/index.html';
        if (window.$P && window.$P.openTab)
          window.$P.openTab({id: 'docs', title: 'DOCS', url: u});
      }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            // msUtils.clearLocalStorage();

            msNavigationService.clearNavigation();

            AuthService.chainedLogout();
            AuthService.loginRedirect('app.login');
        }

        /**
         * Profile (state)
         */
        function containerStateProfile() {
            $state.go('app.home.profile');
        }

        /**
         * About (state)
         */
        function containerStateAbout() {
            console.log('ABOUT!')
            $state.go('app.home.about');
        }

        /**
         * Inbox (state)
         */
        function containerStateInbox() {
            $state.go('app.home.inbox');
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

})();

(function(){
    'use strict';

    angular.module('state-manager', [])
    .config(function($stateProvider) {

        //O segredo para resolver o problema das rotas é criar uma referência para 
        //o provider [routeProvider], permitindo que ele seja acessado posteriormente.
        angular.module('state-manager')._stateProvider = $stateProvider;
    });
}());
(function () {
    'use strict';

    angular.module('state-manager')
        .factory('StateFactory', function ($rootScope) {
            return function (newState) {
                angular.module('state-manager')._stateProvider
                    .state(newState.name, newState.options);
                $rootScope.statesTitles.push({
                    title: newState.title,
                    ref: newState.name
                });
            }
        })

        .factory('StateFactoryClear', function (PentahoService, AuthService, $cookies) {
            return function () {
                PentahoService.refreshMenu();
            }
        });
}());
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        /*msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );*/

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function () {
  'use strict';

  angular
    .module('app.navigation')
    .controller('NavigationController', NavigationController);

  /** @ngInject */
  function NavigationController($scope, PentahoService, PentahoConnectorService, ActivitiService, KpiService, APP_CFG, msNavigationService, $rootScope, AuthService, AdminToolsService) {
    var vm = this;
    var ACTIVE_APPS = APP_CFG['ACTIVE_APPS'];
    var FEATURE_FLAGS = APP_CFG['FEATURE_FLAGS'];

    // Data
    vm.bodyEl = angular.element('body');
    vm.folded = false;
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.openTab = openTab;

    /**
     * Allows for opening new tabs in PPA-UI given this three parameters.
     * This should be bound to a shared object in window (see `window.$P` bellow).
     * Para usar a funç˜o abaixo, basta add ao navigation.html uma chamada como `ng-click="vm.openTab()"`
     */
    function openTab(tabOpts) {
      PentahoConnectorService.viewer.openTab({id: tabOpts.id, title: tabOpts.title, url: tabOpts.url})
    }

    // TODO: move this to a better location
    window.$P = {
      openTab: openTab
    }

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    $scope.$on('$stateChangeStart', function () {
      vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
    });

    // Close the mobile menu on $stateChangeSuccess
    $scope.$on('$stateChangeSuccess', function () {
      vm.folded = true;
    });

    // Verifica se o Activiti está habilitado
    $rootScope.$on('createnavigation', function (event, data) {

      if (AuthService.authSessions.loggedIn) {
        if (!$rootScope.userPreferencesLoaded) {
          if (ACTIVE_APPS.indexOf('activiti') != -1) {
            // Listagem de menu do Activiti
            ActivitiService.initSideNav()
              .then(function () {
                // Verifica se o Pentaho está habilitado
                if (ACTIVE_APPS.indexOf('pentaho') != -1) {
                  // Listagem de menu do KPI
                  KpiService.initSideNav();

                  msNavigationService.sort();

                  setTimeout(pentahoLoginDelay, 2000);
                  // Listagem de menu do Pentaho
                  function pentahoLoginDelay() {
                    PentahoService.initSideNav()
                      .then(function () {
                        //-- terminou a listagem de menu do Pentaho
                        AdminToolsService.initSideNav();
                      }, function (e) {
                        //-- falha na listagem de menu do Pentaho
                        console.log('Falha ao obter a listagem de itens do Pentaho');
                      });
                  }
                }

              }, function (e) {
                // Falha na listagem de menu do Activiti
                console.log('Falha ao obter a listagem de itens do Activiti!');
              });
          } else { // Quando Activiti não estiver habilitado
            // Verifica se o Pentaho está habilitado
            if (ACTIVE_APPS.indexOf('pentaho') != -1) {
              // Listagem de menu do KPI
              //KpiService.initSideNav();

              // Listagem de menu do Pentaho
              console.log('initSideNav will be delayed by 3s')
              setTimeout(function(){
                PentahoService.initSideNav()
                  .then(function () {
                    //-- terminou a listagem de menu do Pentaho
                    AdminToolsService.initSideNav();
                  }, function (e) {
                      console.log('Falha ao obter a listagem de itens do Pentaho');
                    });

              }, 3000)
            }
          }
        } else {
          msNavigationService.sort();
        }
      }
    });

    function sortNavbar(a, b) {
      /*if (a.level != b.level) {
        console.log(a.level, a.title)
        return a.level < b.level ? -1 : 1;
      }
      if (!(a.dnf && b.dnf) && a.title != b.title) {
        return a.title < b.title ? -1 : 1;
      }*/
      return 0;
    }

    $rootScope.$broadcast('createnavigation');
  }

})();

(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Firebase
            'firebase',

            // SHA-1
            'angular-sha1',

            // OC Lazy Load
            'oc.lazyLoad',

            // State Manager
            'state-manager',

            // Pentaho Connector
            'app.pentaho-connector',

            // Activiti Connector
            'app.activiti-connector',

            // Admin Tools
            'app.admintools-data-handler',

            // Authentication
            'app.auth',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',

            // Base64 Enconder/Decoder
            'base64',

            // Web Storage
            'LocalStorageModule',

            // Login
            'app.login',

            // Home
            'app.home',

            // KPI
            'app.kpi-data-handler'
        ]);

    angular.module('template', []);
    angular.module('sghq', []);
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, APP_CFG) {
        // Data
        var vm = this;
        var ACTIVE_APPS = APP_CFG['ACTIVE_APPS'];

        $rootScope.$broadcast('showSplash');

        if (ACTIVE_APPS.indexOf('pentaho') != -1) {
            $rootScope.$on('finishReload', function () {
                $rootScope.$broadcast('hideSplash');
            });
        } else {
            // Remove the splash screen
            $scope.$on('$viewContentAnimationEnded', function (event) {
                if (event.targetScope.$id === $scope.$id) {
                    $rootScope.$broadcast('hideSplash');
                }
            });
        }

        $rootScope.$watch('activeContextApp', function (newValue) {
            vm.activeContextApp = newValue;
        });
    }
})();
(function(){
    'use strict';
    
    angular.module('fuse')
    .factory('InterceptorRequestService', InterceptorRequestService);
    
    /** @ngInject **/
    function InterceptorRequestService($q, $cookies)
    {
        var requestInterceptor = {
			request: function(config) {
				if (config.url.indexOf('pentaho') != -1) {
					var currentTime = new Date();
					
					$cookies.putObject('ppaui-session', currentTime);
				}
				
				return config;
			}
		};

		return requestInterceptor;
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toArray', toArray);

    /** @ngInject */
    function toArray()
    {   
        return function(obj) {
            if (obj instanceof Object) {
                return _.map(obj, function(value, key) {
                    if (value instanceof Object)
                        Object.defineProperty(value, '$id', {__proto__: null, value: key});
                    return value;
                });
            } else {
                return false;
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('textCutter', textCutter);

    /** @ngInject */
    function textCutter()
    {   
        return function(text, wordwise, max, tail) {
            if (!text) return '';
            
            max = parseInt(max, 10);
            if (!max) return text;
            
            if (text.length <= max) return text;
            
            text = text.substr(0, max);
            if (wordwise){
                var lastspace = text.lastIndexOf(' ');
                if (lastspace != -1) {
                  if (text.charAt(lastspace - 1) == '.' || text.charAt(lastspace - 1) == ','){
                    lastspace = lastspace - 1;
                  }
                    
                  text = text.substr(0, lastspace);
                }
            }
            
            return text + (tail || '…');
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('monthFilter', monthFilter);

    /** @ngInject */
    function monthFilter(MONTHS)
    {   
        return function(monthNumber) {
            if (MONTHS[parseInt(monthNumber)])
                return MONTHS[parseInt(monthNumber)].name;
            else
                return monthNumber;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {       
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        } 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function(window, angular){
    'use strict';

    function sha1(){
        // Private variables

        // Private methods

        /**
         * Generates SHA-1 hash of string.
         *
         * @param   {string} msg - (Unicode) string to be hashed.
         * @returns {string} Hash of msg as hex character string.
         */
        function hash(msg) {
            // convert string to UTF-8, as SHA only deals with byte-streams
            msg = msg.utf8Encode();

            // constants [§4.2.1]
            var K = [ 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6 ];

            // PREPROCESSING

            msg += String.fromCharCode(0x80);  // add trailing '1' bit (+ 0's padding) to string [§5.1.1]

            // convert string msg into 512-bit/16-integer blocks arrays of ints [§5.2.1]
            var l = msg.length/4 + 2; // length (in 32-bit integers) of msg + ‘1’ + appended length
            var N = Math.ceil(l/16);  // number of 16-integer-blocks required to hold 'l' ints
            var M = new Array(N);

            for (var i=0; i<N; i++) {
                M[i] = new Array(16);
                for (var j=0; j<16; j++) {  // encode 4 chars per integer, big-endian encoding
                    M[i][j] = (msg.charCodeAt(i*64+j*4)<<24) | (msg.charCodeAt(i*64+j*4+1)<<16) |
                        (msg.charCodeAt(i*64+j*4+2)<<8) | (msg.charCodeAt(i*64+j*4+3));
                } // note running off the end of msg is ok 'cos bitwise ops on NaN return 0
            }
            // add length (in bits) into final pair of 32-bit integers (big-endian) [§5.1.1]
            // note: most significant word would be (len-1)*8 >>> 32, but since JS converts
            // bitwise-op args to 32 bits, we need to simulate this by arithmetic operators
            M[N-1][14] = ((msg.length-1)*8) / Math.pow(2, 32); M[N-1][14] = Math.floor(M[N-1][14]);
            M[N-1][15] = ((msg.length-1)*8) & 0xffffffff;

            // set initial hash value [§5.3.1]
            var H0 = 0x67452301;
            var H1 = 0xefcdab89;
            var H2 = 0x98badcfe;
            var H3 = 0x10325476;
            var H4 = 0xc3d2e1f0;

            // HASH COMPUTATION [§6.1.2]

            var W = new Array(80); var a, b, c, d, e;
            for (var i=0; i<N; i++) {

                // 1 - prepare message schedule 'W'
                for (var t=0;  t<16; t++) W[t] = M[i][t];
                for (var t=16; t<80; t++) W[t] = this.ROTL(W[t-3] ^ W[t-8] ^ W[t-14] ^ W[t-16], 1);

                // 2 - initialise five working variables a, b, c, d, e with previous hash value
                a = H0; b = H1; c = H2; d = H3; e = H4;

                // 3 - main loop
                for (var t=0; t<80; t++) {
                    var s = Math.floor(t/20); // seq for blocks of 'f' functions and 'K' constants
                    var T = (this.ROTL(a,5) + this.f(s,b,c,d) + e + K[s] + W[t]) & 0xffffffff;
                    e = d;
                    d = c;
                    c = this.ROTL(b, 30);
                    b = a;
                    a = T;
                }

                // 4 - compute the new intermediate hash value (note 'addition modulo 2^32')
                H0 = (H0+a) & 0xffffffff;
                H1 = (H1+b) & 0xffffffff;
                H2 = (H2+c) & 0xffffffff;
                H3 = (H3+d) & 0xffffffff;
                H4 = (H4+e) & 0xffffffff;
            }

            return this.toHexStr(H0) + this.toHexStr(H1) + this.toHexStr(H2) +
                   this.toHexStr(H3) + this.toHexStr(H4);
        };


        /**
         * Function 'f' [§4.1.1].
         * @private
         */
        function f(s, x, y, z)  {
            switch (s) {
                case 0: return (x & y) ^ (~x & z);           // Ch()
                case 1: return  x ^ y  ^  z;                 // Parity()
                case 2: return (x & y) ^ (x & z) ^ (y & z);  // Maj()
                case 3: return  x ^ y  ^  z;                 // Parity()
            }
        };

        /**
         * Rotates left (circular left shift) value x by n positions [§3.2.5].
         * @private
         */
        function ROTL(x, n) {
            return (x<<n) | (x>>>(32-n));
        };


        /**
         * Hexadecimal representation of a number.
         * @private
         */
        function toHexStr(n) {
            // note can't use toString(16) as it is implementation-dependant,
            // and in IE returns signed numbers when used on full words
            var s="", v;
            for (var i=7; i>=0; i--) { v = (n>>>(i*4)) & 0xf; s += v.toString(16); }
            return s;
        };


        /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */


        /** Extend String object with method to encode multi-byte string to utf8
         *  - monsur.hossa.in/2012/07/20/utf-8-in-javascript.html */
        if (typeof String.prototype.utf8Encode == 'undefined') {
            String.prototype.utf8Encode = function() {
                return unescape( encodeURIComponent( this ) );
            };
        }

        /** Extend String object with method to decode utf8 string to multi-byte */
        if (typeof String.prototype.utf8Decode == 'undefined') {
            String.prototype.utf8Decode = function() {
                try {
                    return decodeURIComponent( escape( this ) );
                } catch (e) {
                    return this; // invalid UTF-8? return as-is
                }
            };
        }

        // Public
        return {
            hash: hash,
            f: f,
            ROTL: ROTL,
            toHexStr: toHexStr
        };
    }

    angular.module('angular-sha1', []).factory('sha1', sha1);
})(window, window.angular);
(function(){
    'use strict';
    
    angular.module('app.auth', []);
}());
/*
  Este módulo foi criado para servir de centralizador de rotinas de autenticação
  Todos os módulos que possuirem autenticações próprias, deverão ter suas funções chamadas e tratadas neste módulo
*/

(function () {
    'use strict';

    angular.module('app.auth')
        .service('AuthService', AuthService);

    /** @ngInject **/
    function AuthService(PentahoConnectorService, ActivitiConnectorService, $cookies, $state, $q, $http, $window, APP_CFG, $rootScope) {
        var vm = this;

        // Objeto para armazenar dados de sessões
        vm.authSessions = {
            loggedIn: false,
            pentahoSession: PentahoConnectorService.auth.session,
            activitiSession: ActivitiConnectorService.auth.session
            //outras sessoes vão aqui
        }

        vm.updateAuthInformation = updateAuthInformation;
        vm.loginRedirect = loginRedirect;

        vm.chainedLogin = chainedLogin;
        vm.chainedLogout = chainedLogout;

        // Pentaho
        vm.logInPentaho = logInPentaho;
        vm.logOutPentaho = logOutPentaho;

        // Activiti
        vm.logInActiviti = logInActiviti;
        vm.logOutActiviti = logOutActiviti;

        /*
          Atualiza as informações de todas as sessões com base nos dados salvos em cookies
          Adicionar outras autenticações aqui...
        */
        function updateAuthInformation() {
            // Adiciona cada cookie em um nó do vetor de objetos
            var
                sid = {},
                apps = APP_CFG['ACTIVE_APPS'],
                allowed = true;

            for (var i = 0; i < apps.length; i++) {
                sid[apps[i]] = $cookies.getObject('ppaui-' + apps[i] + '-auth');
                if (!sid[apps[i]]) {
                    allowed = false;
                    break;
                }
            }
 
            if (allowed) {
                var timeout = APP_CFG['SESSION_TIMEOUT'] || 100,
                    currentDate = new Date(),
                    diffMs = 0,
                    interval = 0, //Os minutos desde a última interação
                    lastUse = $cookies.getObject('ppaui-session');

                lastUse = new Date(lastUse);
                diffMs = (currentDate - lastUse);
                interval = parseInt(diffMs / 1000 / 60);

                if (interval >= timeout) {
                    vm.chainedLogout();
                    allowed = false;
                }
            }

            // Se estiver permitido, atualiza as informações em memória
            if (allowed) {
                var activitiIsOn = false;

                for (var i = 0; i < apps.length; i++) {
                    vm.authSessions[apps[i] + 'Session'] = sid[apps[i]];

                    if (apps[i] === 'activiti')
                        activitiIsOn = true;
                }

                vm.authSessions.loggedIn = true;

                if (activitiIsOn) {
                    $http.defaults.headers.common.Authorization = 'Basic ' + vm.authSessions['activitiSession'].authKey;
                    ActivitiConnectorService.dh.getUserContext(
                        vm.authSessions['activitiSession'].username
                    );
                } else {
                    $http.defaults.headers.common.Authorization = 'Basic ' + vm.authSessions['pentahoSession'].authKey;
                    PentahoConnectorService.dh.getUserContext(
                        vm.authSessions['pentahoSession'].username
                    );
                }
            } else {
                $cookies.remove('JSESSIONID', {
                    'path': '/pentaho'
                });
                //vm.chainedLogout(apps);
                vm.authSessions.loggedIn = false;
                $rootScope.userContext = {
                    roles: null,
                    isAdmin: false,
                    isQualityManager: false
                };
            }
        }

        /*
          Invoca função de login de todos os apps informados por parâmetro
        */
        function chainedLogin(loginData) {
            var
                promises = [],
                apps = APP_CFG['ACTIVE_APPS'];

            if (!APP_CFG['USE_FREE_CASE_AUTH']) {
                loginData.username = loginData.username.toUpperCase();
            } else {
                console.log('O mecanismo de autenticação livre está habilitado!');
            }

            if (apps.indexOf('pentaho') !== -1) {
                promises.push(vm.logInPentaho(loginData));
            }

            if (apps.indexOf('activiti') !== -1) {
                promises.push(vm.logInActiviti(loginData));
            }

            // Retorna uma promise com base no resultado das demais promises
            return $q.all(promises);
        }

        /*
          Invoca função de logout de todos os apps informados por parâmetro
        */
        function chainedLogout() {
            var apps = APP_CFG['ACTIVE_APPS'];

            if (apps.indexOf('pentaho') !== -1) {
                vm.logOutPentaho();
            }

            if (apps.indexOf('activiti') !== -1) {
                vm.logOutActiviti();
            }

            $rootScope.userPreferencesLoaded = false;
        }

      function removeAuthCookies() {
        $cookies.remove('ppaui-session');
        $cookies.remove('ppaui-pentaho-auth');
        $cookies.remove('JSESSIONID');
        $cookies.remove('JSESSIONID', {'path': '/pentaho'});
      }

        /* 
          Efe o login - PENTAHO
          Essa função serve de frente para o login do Pentaho
        */
        function logInPentaho(loginData) {
          removeAuthCookies();
            var res = PentahoConnectorService.auth.logIn(loginData);

            res.then(function (r) {
                if (PentahoConnectorService.auth.session.loggedIn) {
                    vm.authSessions.pentahoSession = PentahoConnectorService.auth.session;
                    $cookies.putObject('ppaui-pentaho-auth', vm.authSessions.pentahoSession);
                }
            }, function (e) {
                if (PentahoConnectorService.auth.session.loggedIn) {
                    vm.authSessions.pentahoSession = PentahoConnectorService.auth.session;
                    $cookies.putObject('ppaui-pentaho-auth', vm.authSessions.pentahoSession);
                }
            });
            return res; // Promise
        }

      /* 
          Efetua o logout - PENTAHO
          Essa função serve de frente para o logout do Pentaho
          */
      function logOutPentaho() {
        PentahoConnectorService.auth.logOut(true);
        vm.authSessions.pentahoSession = PentahoConnectorService.auth.session;
        removeAuthCookies();
      }

        /* 
          Efetua o login - ACTIVITI
          Essa função serve de frente para o login do Activiti
        */
        function logInActiviti(loginData) {
            var res = ActivitiConnectorService.auth.logIn(loginData);

            res.then(function (r) {
                if (ActivitiConnectorService.auth.session.loggedIn) {
                    vm.authSessions.activitiSession = ActivitiConnectorService.auth.session;
                    $cookies.putObject('ppaui-activiti-auth', vm.authSessions.activitiSession);
                }
            }, function (e) {
                if (ActivitiConnectorService.auth.session.loggedIn) {
                    vm.authSessions.activitiSession = ActivitiConnectorService.auth.session;
                    $cookies.putObject('ppaui-activiti-auth', vm.authSessions.activitiSession);
                }
            });
            return res; // Promise
        }

        /* 
          Efetua o logout - ACTIVITI
          Essa função serve de frente para o logout do Activiti
        */
        function logOutActiviti() {
            ActivitiConnectorService.auth.logOut();
            vm.authSessions.activitiSession = ActivitiConnectorService.auth.session;
            $cookies.remove('ppaui-activiti-auth');
        }

        /*
          Redireciona o usuário após autenticação
        */
        function loginRedirect(url, forceReload) {
            $state.go(url, null, {
                reload: forceReload
            });
        }
    }
}());

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock(fuseTheming, $rootScope, $timeout, $http, $state, $ocLazyLoad, AuthService, StateFactory, APP_CFG, ExternalAppsService)
    {   
        var regex = /external-app/g
		
		$rootScope.userPreferencesLoaded = false;
        
        // Carrega as aplicações externas    
        ExternalAppsService.loadExternalApps();
		
        fuseTheming.setActiveTheme(APP_CFG['COMPANY_BRAND']);

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams)
        {
            $rootScope.loadingProgress = true;
        });

        // Atualiza informações de logon com base nos cookies
        AuthService.updateAuthInformation();

        // Verifica se o usuário está logado em todos os estados que precisarem de autenticação
        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){
            AuthService.updateAuthInformation();
            
			if (toState.authenticate && !AuthService.authSessions.loggedIn) {
				///
			}
			
            if (toState.authenticate && !AuthService.authSessions.loggedIn){
                $state.transitionTo('app.login');
                event.preventDefault();
            }

            if (toState.isAdmin && !$rootScope.userContext.isAdmin){
                $state.transitionTo('app.home');
                event.preventDefault();
            }

            if (toState.isDataAdministrator && !($rootScope.userContext.isDataAdministrator)){
                $state.transitionTo('app.home');
                event.preventDefault();
            }
        });
        
        $rootScope.$on('$stateNotFound', function(event, unfoundState, fromState, fromParams){
            if (regex.test(unfoundState.to)){
                ExternalAppsService.loadExternalApps()
                .then(function(){
                    $state.transitionTo(unfoundState.to);
                }, function(){
                    console.log('Falha ao carregar aplicação externa!');
                });
                event.preventDefault();
            }
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams)
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, modalStateProvider) {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise(function ($injector, $location) {
            return '/home'
        });

        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies',
            function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: layouts[layoutStyle].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller: 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller: 'QuickPanelController as vm'
                    }
                }
            });

        $stateProvider
            .state('app.login', {
                url: '/login',
                views: {
                    'main@': {
                        templateUrl: 'app/main/login/login.html',
                        controller: 'LoginController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: '',
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: '',
                        controller: 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: '',
                        controller: 'QuickPanelController as vm'
                    }
                }
            });

        modalStateProvider.state('app.home.about', {
            parent: 'app',
            url: '/sobre',
            templateUrl: 'app/main/container/views/about/about.html',
            controller: 'AboutContainerController as vm',
            autenticate: true
        });

        $stateProvider.state('app.home.configuration', {
            parent: 'app.home',
            url: '/configuracao',
            views: {
                'content@app': {
                    templateUrl: 'app/main/configuration/configuration.html',
                    controller: 'ConfigurationController as vm'
                }
            },
            resolve: {
                DepartmentsList: function ($rootScope) {
                    $rootScope.activeContextApp = 'main';
                    return {};
                },
                Context: function ($rootScope) {
                    return $rootScope.getContext
                }
            },
            authenticate: true
        });

        /*modalStateProvider.state('app.home.inbox', {
            parent : 'app',
            url: '/inbox',
            templateUrl: 'app/main/container/views/inbox/inbox.html',
            controller : 'InboxController as vm',
            autenticate: true
        });*/
    }

})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, $rootScope, PentahoViewerService) {
        var
            vm = this;

        // Tema
        vm.themes = fuseTheming.themes;

        vm.clearScope = clearScope;

        function clearScope() {
            PentahoViewerService.clearTabs();
        }

        // Cria o objeto que armazenará os títulos dos estados
        // para serem utilizados na barra de pesquisas
        $rootScope.statesTitles = [];

        $rootScope.$on('hideSplash', function () {
            $rootScope.loadingMenu = 0;
        });

        $rootScope.$on('showSplash', function () {
            $rootScope.loadingMenu = 1;
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .constant('PENTAHO_APP_URL', '/pentaho')
        .constant('ACTIVITI_APP_URL', '/activiti-rest')
        .constant('APPS', {
            pentaho: {
                directive: 'pentaho-placeholder',
                appName: 'Pentaho'
            },
            activiti: {
                directive: 'activiti-placeholder',
                appName: 'Activiti'
            }
        })
        .constant('MONTHS', {
            1: {
                name: 'Janeiro',
                value: '01'
            },
            2: {
                name: 'Fevereiro',
                value: '02'
            },
            3: {
                name: 'Março',
                value: '03'
            },
            4: {
                name: 'Abril',
                value: '04'
            },
            5: {
                name: 'Maio',
                value: '05'
            },
            6: {
                name: 'Junho',
                value: '06'
            },
            7: {
                name: 'Julho',
                value: '07'
            },
            8: {
                name: 'Agosto',
                value: '08'
            },
            9: {
                name: 'Setembro',
                value: '09'
            },
            10: {
                name: 'Outubro',
                value: '10'
            },
            11: {
                name: 'Novembro',
                value: '11'
            },
            12: {
                name: 'Dezembro',
                value: '12'
            }
        })
        .constant('DT_LANGUAGE', {
            "sEmptyTable": "Não há informações",
            "sInfo": "Visualizando _START_ até _END_ de _TOTAL_",
            "sInfoEmpty": "Sem registros",
            "sInfoFiltered": "(filtrado de _MAX_ registros)",
            "sInfoPostFix": "",
            "sInfoThousands": ",",
            "sLengthMenu": "Mostrando _MENU_ registros",
            "sLoadingRecords": "Carregando...",
            "sProcessing": "Processando...",
            "sSearch": "Pesquisar:",
            "sZeroRecords": "Sem resultado da pesquisa",
            "oPaginate": {
                "sFirst": "Primeira",
                "sLast": "Última",
                "sNext": "Próxima",
                "sPrevious": "Anterior"
            },
            "oAria": {
                "sSortAscending": ": clique para ordenar de forma ascendente",
                "sSortDescending": ": clique para ordenar de forma descendente"
            }
        });
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($httpProvider, $mdThemingProvider, localStorageServiceProvider)
    {   
		$httpProvider.interceptors.push('InterceptorRequestService');
		
        // Put your custom configurations here
        localStorageServiceProvider.setPrefix('ppa-ls');
        
        $mdThemingProvider.theme('veltio');
        
        //Functions prototype
        String.prototype.toCamel = function(){
            return this.replace(/(\-[a-z])/g, function($1){return $1.toUpperCase().replace('-','');});
        };   
        
        if (![].contains) {
          Object.defineProperty(Array.prototype, 'contains', {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function(searchElement/*, fromIndex*/) {
              if (this === undefined || this === null) {
                throw new TypeError('Cannot convert this value to object');
              }
              var O = Object(this);
              var len = parseInt(O.length) || 0;
              if (len === 0) { return false; }
              var n = parseInt(arguments[1]) || 0;
              if (n >= len) { return false; }
              var k;
              if (n >= 0) {
                k = n;
              } else {
                k = len + n;
                if (k < 0) k = 0;
              }
              while (k < len) {
                var currentElement = O[k];
                if (searchElement === currentElement ||
                    searchElement !== searchElement && currentElement !== currentElement
                ) {
                  return true;
                }
                k++;
              }
              return false;
            }
          });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function () {
    'use strict';

    angular.module('fuse')
        .service('ExternalAppsService', ExternalAppsService);

    /** @ngInject **/
    function ExternalAppsService($http, $ocLazyLoad, APP_CFG, $q) {
        var vm = this;

        vm.loadExternalApps = loadExternalApps;

        function loadExternalApps() {
            var promises = [];

            var eaList = APP_CFG['EXTERNAL_APPS'];
            if (eaList) {
                angular.forEach(eaList, function (value, key) {
                    if (value.active === true) {
                        var p = $q.defer();

                        $http.get('external-apps/' + key + '/lazy-load.json')
                            .success(function (data) {
                                var eapp_files = data.data;

                                // Carrega o módulo e os demais arquivos
                                $ocLazyLoad.load(eapp_files, {
                                    cache: false,
                                    reconfig: true
                                }).then(function () {
                                    p.resolve();
                                }, function () {
                                    //p.reject();
                                });
                            });

                        promises.push(p.promise);
                    }
                });
            }

            return $q.all(promises);
        }
    }
}());
angular.module('angularSlideables', [])
.directive('slideable', function () {
    return {
        restrict:'C',
        compile: function (element, attr) {
            // wrap tag
            var contents = element.html();
            element.html('<div class="slideable_content" style="margin:0 !important; padding:0 !important" >' + contents + '</div>');

            return function postLink(scope, element, attrs) {
                // default properties
                attrs.duration = (!attrs.duration) ? '1s' : attrs.duration;
                attrs.easing = (!attrs.easing) ? 'ease-in-out' : attrs.easing;
                element.css({
                    'overflow': 'hidden',
                    'height': '0px',
                    'transitionProperty': 'height',
                    'transitionDuration': attrs.duration,
                    'transitionTimingFunction': attrs.easing
                });
            };
        }
    };
})
.directive('slideToggle', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var target, content;
            
            attrs.expanded = false;
            
            element.bind('click', function() {
                if (!target) target = document.querySelector(attrs.slideToggle);
                if (!content) content = target.querySelector('.slideable_content');
                
                if(!attrs.expanded) {
                    content.style.border = '1px solid rgba(0,0,0,0)';
                    var y = content.clientHeight;
                    content.style.border = 0;
                    target.style.height = y + 'px';
                } else {
                    target.style.height = '0px';
                }
                attrs.expanded = !attrs.expanded;
            });
        }
    }
})
.directive('slideUp', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var target, content;
            
            attrs.expanded = false;
            
            element.bind('click', function() {
                if (!target) target = document.querySelector(attrs.slideUp);
                if (!content) content = target.querySelector('.slideable_content');
                
                content.style.border = '1px solid rgba(0,0,0,0)';
                var y = content.clientHeight;
                content.style.border = 0;
                target.style.height = y + 'px';
            });
        }
    }
})
.directive('slideDown', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var target, content;
            
            attrs.expanded = true;
            
            element.bind('click', function() {
                if (!target) target = document.querySelector(attrs.slideDown);
                if (!content) content = target.querySelector('.slideable_content');
                
                target.style.height = '0px';
            });
        }
    }
});
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content \nng-hide=\"vm.activeContextApp === \'pentaho\'\" id=\"content\" class=\"animate-slide-up md-background md-hue-1\" \nui-view=\"content\" flex></md-content><md-content ng-show=\"vm.activeContextApp === \'pentaho\'\" id=\"content-analytics\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content-analytics\" flex><pentaho-placeholder>\n</pentaho-placeholder></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content \nng-hide=\"vm.activeContextApp === \'pentaho\'\" id=\"content\" class=\"animate-slide-up md-background md-hue-1\" \nui-view=\"content\" flex></md-content><md-content ng-show=\"vm.activeContextApp === \'pentaho\'\" id=\"content-analytics\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content-analytics\" flex><pentaho-placeholder>\n</pentaho-placeholder></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content \nng-hide=\"vm.activeContextApp === \'pentaho\'\" id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll \nui-view=\"content\" flex></md-content><md-content ng-show=\"vm.activeContextApp === \'pentaho\'\" id=\"content-analytics\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content-analytics\" flex><pentaho-placeholder>\n</pentaho-placeholder></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content \nng-hide=\"vm.activeContextApp === \'pentaho\'\" id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll \nui-view=\"content\" flex></md-content><md-content ng-show=\"vm.activeContextApp === \'pentaho\'\" id=\"content-analytics\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content-analytics\" flex><pentaho-placeholder>\n</pentaho-placeholder></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button \nvalue=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">\nLayout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" \nng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">\nWide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div \nclass=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\">\n<md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/configuration/configuration.html","<div id=\"dashboard-sghq-minutes\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex \nms-scroll><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Configurações</span></div></div></div><div\n class=\"content\"><md-content flex layout-padding><form name=\"form\"><div layout=\"row\" layout-sm=\"row\" flex \nng-if=\"isAdmin\"><div flex-gt-sm=\"50\" flex=\"80\"><md-input-container class=\"md-block\" flex-gt-xs><label>Usuário</label>\n<md-select ng-model=\"userSettings.user\" aria-label=\"Usuário\" required name=\"form.user\"><md-option \nng-repeat=\"user in usuarios\" ng-value=\"user\" ng-click=\"onSelectUser(user)\">{{user}}</md-option></md-select>\n</md-input-container></div></div><md-tabs md-dynamic-height md-border-bottom ng-if=\"showStates\"><md-tab \nlabel=\"Preferências do Usuário\"><md-content class=\"md-padding\"><p><label>Página Inicial</label><md-select \nng-model=\"userSettings.home\" required name=\"form.state\" ng-show=\"!loading\"><md-optgroup label=\"{{g.title}}\" \nng-repeat=\"g in states\"><md-option ng-value=\"s.state\" ng-repeat=\"s in g.children\" ng-if=\"s.title && s.state\">\n{{s.title}}</md-option></md-optgroup></md-select></p><div style=\"float: left\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><p></p></md-content><div layout=\"row\" layout-sm=\"row\" flex><div class=\"add-task-button\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"saveConfig()\" aria-label=\"Salvar Configuração\" ng-disabled=\"!form.$valid\">Salvar\n</md-button></div></div></md-tab><md-tab label=\"Alterar Senha\" ng-disabled=\"changePassEnabled == false\"><md-content \nclass=\"md-padding\"><md-input-container class=\"md-block\" flex-gt-xs><label>Senha Atual</label><input type=\"password\" \nng-model=\"changePass.old\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Nova Senha\n</label><input type=\"password\" ng-model=\"changePass.new\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs><label>Repetir Nova Senha</label><input type=\"password\" ng-model=\"changePass.rep\"></md-input-container>\n</md-content><div layout=\"row\" layout-sm=\"row\" flex><div class=\"add-task-button\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"changePassword()\" aria-label=\"Alterar senha\" \nng-disabled=\"changePass.new == null || changePass.new != changePass.rep\">Alterar</md-button></div></div></md-tab>\n</md-tabs></form></md-content></div></div></div>");
$templateCache.put("app/main/login/login.html","<md-content class=\"md-hue-2\" layout=\"column\" flex layout-fill \nstyle=\"background-image: url(\'assets/images/logos/logo-back.png\')\"><div layout=\"vertical\" flex id=\"content\" \nlayout-fill><div layout=\"row\" layout-align=\"center center\" layout-fill><md-whiteframe class=\"md-whiteframe-4dp\" \nlayout=\"column\" flex-sm=\"80\" flex-gt-sm=\"45\" flex-gt-md=\"30\"><md-content layout-padding><div layout=\"column\"><img \nsrc=\"assets/images/logos/logo-line.png\"><div layout=\"row\"><br><br></div><md-input-container><label>Usuário</label>\n<input ng-model=\"vm.user.username\" required></md-input-container><md-input-container><label>Senha</label><input \nng-model=\"vm.user.password\" type=\"password\" ng-keypress=\"vm.submit(this, event)\" required></md-input-container>\n<md-input-container flex><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" flex><md-progress-circular \nng-show=\"vm.authInProgress\" md-mode=\"indeterminate\" md-diameter=\"40\"></md-progress-circular><md-button \nclass=\"md-raised\" ng-show=\"!vm.authInProgress\" ng-click=\"vm.login()\" \nng-disabled=\"!(vm.user.username && vm.user.password)\" flex>Login</md-button></div></md-input-container></div>\n</md-content></md-whiteframe></div></div></md-content>");
$templateCache.put("app/main/home/home.html","<div id=\"cljs\"></div>");
$templateCache.put("app/toolbar/context-bar/context-bar.html","<div layout=\"row\" class=\"context-bar\" md-theme=\"{{ctrl.themes.active.name}}\" md-theme-watch flex><div flex=\"50\"><a \nclass=\"md-icon-button md-button md-ink-ripple md-default-theme context-bar-icon\" aria-label=\"Recarregar menu\"><md-icon \nng-if=\"!ctrl.refreshingMenu\" id=\"icn-refresh\" md-font-icon=\"icon-refresh\" ng-click=\"ctrl.refreshMenu()\" \nclass=\"icon s24 ng-scope md-font icon-refresh material-icons icon-ctx icon-ctx-active md-accent\"></md-icon><div \nng-if=\"ctrl.refreshingMenu\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nclass=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular></div></a></div><div flex=\"50\"><a \nclass=\"md-icon-button md-button md-ink-ripple md-default-theme context-bar-icon\" aria-label=\"Atividades\"><md-icon \nid=\"icn-main\" md-font-icon=\"icon-checkbox-multiple-marked-outline\" ng-click=\"ctrl.selectContext(\'main\', \'app.home\')\" \nclass=\"icon s24 ng-scope md-font icon-checkbox-multiple-marked-outline material-icons icon-ctx icon-ctx-active md-accent\">\n</md-icon></a></div><div flex=\"50\"><a class=\"md-icon-button icon-ctx md-button md-ink-ripple md-default-theme\" \naria-label=\"Analytics\"><md-icon id=\"icn-pentaho\" md-font-icon=\"icon-trending-up\" \nng-click=\"ctrl.selectContext(\'pentaho\')\" \nclass=\"icon s24 ng-scope md-font icon-icon-trending-up material-icons icon-ctx\"></md-icon></a></div></div>");
$templateCache.put("app/toolbar/search-bar/search-bar.html","<div layout=\"row\" layout-align=\"start center\"><label for=\"search-bar-input\"><md-icon id=\"search-bar-expander\" \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon id=\"search-bar-collapser\" md-font-icon=\"icon-close\" \nclass=\"icon s24\"></md-icon></label><md-autocomplete id=\"search-bar-input\" md-selected-item=\"ctrl.selectedItem\" \nmd-search-text-change=\"ctrl.searchTextChange(ctrl.searchText)\" md-search-text=\"ctrl.searchText\" \nmd-selected-item-change=\"ctrl.selectedItemChange(item)\" md-items=\"item in ctrl.querySearch(ctrl.searchText)\" \nmd-item-text=\"item.title\" md-min-length=\"0\" placeholder=\"Pesquisar\"><md-item-template><span \nmd-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.title}}</span></md-item-template><md-not-found>\nNão foram encontradas opções para <b>\"{{ctrl.searchText}}\"</b>.</md-not-found></md-autocomplete></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Pesquisar\" flex></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><img class=\"logo-image\" src=\"assets/images/logos/logo.png\" \nng-hide=\"vm.folded\"> <img class=\"logo-image-sm\" src=\"assets/images/logos/logo-min.png\" ng-show=\"vm.folded\"></div>\n<md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/ppa-ui-core/pentaho-connector/pentaho-viewer/pentaho-viewer.html","<div layout=\"column\" ng-cloak><pentaho-placeholder></pentaho-placeholder></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\" ng-show=\"vm.visible\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">V\n</span> <span class=\"logo-text\">PPA</span></div><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div>\n<div layout=\"row\" layout-align=\"start center\"><div class=\"toolbar-separator\"></div><search-bar></search-bar><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-xs>{{vm.session.username}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Sair</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\" ng-show=\"vm.visible\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\">\n</md-icon></md-button></div><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">V\n</span> <span class=\"logo-text\">PPA</span></div><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div>\n<div layout=\"row\" layout-align=\"start center\"><search-bar></search-bar><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-xs>{{vm.session.username}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"icon\"></md-icon><md-button ng-click=\"vm.about()\">Sobre\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.config()\">Configurações</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-multiple\" class=\"icon\"></md-icon><md-button ng-click=\"vm.openBiServer()\">Arquivos e Usuários\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Sair</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\" ng-show=\"vm.visible\"><div layout=\"row\" layout-align=\"start center\" flex>\n<md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><context-bar></context-bar><div class=\"toolbar-separator\">\n</div><search-bar></search-bar><div class=\"toolbar-separator\"></div><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div>\n<div layout=\"row\" layout-align=\"start center\"><div flex=\"50\" ng-if=\"vm.hasDocs\"><a \nclass=\"md-icon-button md-button md-ink-ripple md-default-theme context-bar-icon\" aria-label=\"Atividades\"><md-tooltip \nmd-direction=\"left\">Documentação</md-tooltip><md-icon id=\"icn-main\" md-font-icon=\"icon-help-circle\" \nng-click=\"vm.openDocs()\" class=\"icon s24 ng-scope md-font icon-checkbox-multiple-marked-outline material-icons\">\n</md-icon></a></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\n{{vm.session.username}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"icon\"></md-icon><md-button ng-click=\"vm.containerStateAbout()\">Sobre\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.config()\">Configurações</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-multiple\" class=\"icon\"></md-icon><md-button ng-click=\"vm.openBiServer()\">Arquivos e Usuários\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Sair</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/quick-panel/tabs/recent-analytics/recent-analytics-tab.html","<div layout=\"column\" layout-align=\"center right\" flex><md-button aria-label=\"Limpar recentes\" \nng-click=\"vm.clearRecentAnalytics()\" ng-show=\"vm.recentAnalytics\">Limpar</md-button></div><div \nng-repeat=\"item in vm.recentAnalytics\"><md-list class=\"recents\"><md-list-item class=\"recent md-3-line\" \nng-click=\"vm.gotoState(item.state)\" aria-label=\"Item recente\"><div class=\"md-list-item-text\"><h3>{{item.title}}</h3><p>\n{{item.datetime | date:\"dd/MM/yyyy - h:mm\"}}h</p></div></md-list-item></md-list><md-divider></md-divider></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\" ng-click=\"vm.checkItemState(node.uisref)\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/container/views/about/about.html","<md-dialog aria-label=\"{{variavel.nome}}\" ng-cloak flex><div layout=\"column\"><section layout=\"row\" flex><md-content \nlex layout-padding><div layout=\"column\" layout-fill layout-align=\"top center\"><div class=\"row\" \nlayout-align=\"center center\"><h1>Veltio PPA-UI</h1></div><div class=\"row\" layout-align=\"center center\">\nVersão: {{vm.version}}</div><div><div class=\"change-log\"></div></div></div></md-content></section></div></md-dialog>");
$templateCache.put("app/main/container/views/inbox/inbox.html","<md-dialog aria-label=\"{{variavel.nome}}\" ng-cloak flex><div layout=\"column\"><section layout=\"row\" flex><md-sidenav \nclass=\"md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" md-is-locked-open=\"$mdMedia(\'gt-md\')\"><md-toolbar \nclass=\"md-theme-indigo\"><h1 class=\"md-toolbar-tools\">Inbox</h1></md-toolbar><md-content layout-padding><p hide-md \nshow-gt-md>Menu lateral</p><md-button ng-click=\"\" class=\"md-primary\" aria-label=\"Button\">Button</md-button>\n</md-content></md-sidenav><md-content flex layout-padding><div layout=\"column\" layout-fill layout-align=\"top center\">\n<p>Other stuffs</p><div><md-button ng-click=\"\" class=\"md-primary\" hide-gt-md>Apply</md-button></div></div><div flex>\n</div></md-content></section></div></md-dialog>");
$templateCache.put("app/main/container/views/profile/profile.html","<md-dialog aria-label=\"{{variavel.nome}}\" ng-cloak flex><div layout=\"column\"><section layout=\"row\" flex><md-sidenav \nclass=\"md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" md-is-locked-open=\"$mdMedia(\'gt-md\')\"><md-toolbar \nclass=\"md-theme-indigo\"><h1 class=\"md-toolbar-tools\">Perfil</h1></md-toolbar><md-content layout-padding><p hide-md \nshow-gt-md>Menu lateral</p><md-button ng-click=\"\" class=\"md-primary\" aria-label=\"Button\">Preferências</md-button>\n</md-content></md-sidenav><md-content flex layout-padding><div layout=\"column\" layout-fill layout-align=\"top center\">\n<p>Minhas preferências</p><div><md-button ng-click=\"\" class=\"md-primary\" hide-gt-md>Aplicar</md-button></div></div><div\n flex></div></md-content></section></div></md-dialog>");
$templateCache.put("app/main/home/apps/activiti/tasks.html","<div id=\"todo\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/home/apps/activiti/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" flex layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md aria-label=\"Menu lateral\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.taskFilters.search\" type=\"text\" placeholder=\"Pesquise pela tarefa\"></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\">\n<md-select class=\"simplified\" ng-model=\"vm.selectedFilter.dueDate\" placeholder=\"Data programada\" \nng-show=\"vm.taskFilters.dueDate\"><md-option value=\"1\">A partir de amanhã</md-option><md-option value=\"3\">\nDepois de 3 dias</md-option><md-option value=\"7\">Depois de 7 dias</md-option><md-option value=\"15\">Depois de 2 semanas\n</md-option></md-select><div ng-hide=\"vm.taskFilters.dueDate\" flex></div><div layout=\"row\" layout-align=\"start center\">\n<md-select class=\"simplified\" ng-model=\"vm.taskOrder\" placeholder=\"Order\" \nng-change=\"vm.taskOrderDescending = vm.taskOrder === \'\' ? false : vm.taskOrderDescending\"><md-option \nvalue=\"createTimeTimestamp\">Data de criação</md-option><md-option value=\"dueDateTimestamp\">Data programada</md-option>\n<md-option value=\"\">Manual</md-option><md-option value=\"name\">Título</md-option></md-select><md-button \nclass=\"md-icon-button\" ng-disabled=\"vm.taskOrder === \'\'\" ng-click=\"vm.taskOrderDescending = !vm.taskOrderDescending\" \naria-label=\"Ordenação\"><md-icon md-font-icon=\"icon-sort-ascending\" ng-if=\"vm.taskOrderDescending === false\"></md-icon>\n<md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"vm.taskOrderDescending === true\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.loadTasks()\" ng-disabled=\"vm.refreshing === true\" aria-label=\"Atualizar\"><md-icon \nclass=\"refresh-icon-running\" md-svg-src=\"/assets/icons/fonts/av-timer.svg\" aria-label=\"Atualizar\" \nng-if=\"vm.refreshing === true\"></md-icon><md-icon class=\"refresh-icon-stopped\" \nmd-svg-src=\"/assets/icons/fonts/loop.svg\" aria-label=\"Atualizar\" ng-if=\"vm.refreshing === false\"></md-icon></md-button>\n</div></div><div class=\"content\" layout=\"row\" flex><md-content class=\"todo-list-pane\" flex \nng-include=\"\'app/main/home/apps/activiti/views/list/list-view.html\'\" ms-scroll=\"vm.msScrollOptions\"></md-content></div>\n</div></div></div>");
$templateCache.put("app/ppa-ui-core/pentaho-connector/pentaho-viewer/placeholder/placeholder.tmpl.html","<md-tabs md-dynamic-height md-selected=\"vm.indexCurrentTab\"><md-tab ng-repeat=\"tab in vm.tabs.data\" \nng-click=\"vm.setCurrent($index);\"><md-tab-label>{{tab.title.toUpperCase()}}<md-icon md-font-icon=\"icon-launch\" \nclass=\"icon\" ng-click=\"vm.openNewTab(tab.url);\" style=\"font-size: 18px\" ng-if=\"vm.current === $index\"></md-icon>\n<md-icon class=\"md-warn md-raised\" ng-click=\"vm.closeTab(tab.id)\" style=\"margin-right: 0\">x</md-icon></md-tab-label>\n<md-tab-body><pentaho-tab src=\"{{tab.url}}\"></pentaho-tab></md-tab-body></md-tab></md-tabs>");
$templateCache.put("app/ppa-ui-core/pentaho-connector/pentaho-viewer/tab/tab.tmpl.html","<iframe src=\"{{vm.src}}\" width=\"100%\" style=\"height: {{vm.iframeHeight}}\"></iframe>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/main/home/apps/admin/admin-tools.html","<div id=\"admintools\" class=\"page-layout simple right-sidenav\" md-theme=\"{{vm.themes.active.name}}\" md-theme-watch \nlayout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between\"><div><span \nclass=\"md-display-1 font-weight-300\">Ferramentas Administrativas</span></div></div><div layout=\"row\" \nng-show=\"vm.showToolSelector === true\"><div class=\"selected-tool\">{{vm.selectedTool.name}}</div><md-menu \nid=\"project-menu\" md-offset=\"0 48\"><md-button class=\"md-icon-button tool-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Ferramenta\" md-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"tool in vm.tools\"><md-button \nng-click=\"vm.selectTool(tool)\" aria-label=\"Selecionado {{tool.name}}\"><span \nng-class=\"{\'secondary-text\': vm.selectedTool == tool}\">{{tool.name}}</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div class=\"content admin-tools\" ui-view=\"tools\"></div></div></div>");
$templateCache.put("app/main/home/apps/kpi/kpi.html","<div id=\"dashboard-kpi\" class=\"page-layout simple right-sidenav\" md-theme=\"{{vm.themes.active.name}}\" md-theme-watch \nlayout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between\"><div><span \nclass=\"md-display-1 font-weight-300\">Indicadores de desempenho</span></div></div><div layout=\"row\"><div \nclass=\"selected-department\">{{vm.selectedDepartment.name}}</div><md-menu id=\"project-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button department-selector\" ng-hide=\"!vm.canSelectDepartment\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Departamento\" md-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"department in vm.departments\">\n<md-button ng-click=\"vm.selectDepartment(department)\" aria-label=\"Selecionado {{department.name}}\"><span \nng-class=\"{\'secondary-text\': vm.selectedDepartment == department}\">{{department.name}}</span></md-button>\n</md-menu-item></md-menu-content></md-menu><div class=\"selected-department\">{{vm.selectedActiveFilter.name}}</div>\n<md-menu id=\"project-menu\" md-offset=\"0 48\"><md-button class=\"md-icon-button department-selector\" \nng-hide=\"!vm.canSelectDepartment\" ng-click=\"$mdOpenMenu()\" aria-label=\"Situação\" md-menu-origin md-menu-align-target>\n<md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-repeat=\"status in vm.statusFilters\"><md-button ng-click=\"vm.selectActiveFilter(status)\" \naria-label=\"Selecionado {{status.name}}\"><span \nng-class=\"{\'secondary-text\': vm.selectedActiveFilter.value == status.value}\">{{status.name}}</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"content\" ui-view=\"indicators\"><div layout=\"row\" \nlayout-wrap><div flex-gt-sm=\"90\" flex=\"100\"><div layout=\"row\" layout-wrap layout-align=\"start start\" layout-margin \nlayout-padding><md-card flex-gt-sm=\"30\" flex=\"100\" class=\"card-selector\" ng-click=\"vm.openIndicatorResults(k)\" \nng-repeat=\"k in vm.indicators | filter:vm.filterActive\" id=\"{{k.code}}\" flex-offset=\"2\" style=\"height: 100%\"><div \nlayout=\"row\"><div flex=\"95\"><md-card-title style=\"padding-top: 0px\"><md-card-title-text><span class=\"md-headline\">\n{{ k.name | textCutter:true:35}}</span> <span class=\"\">{{ k.code }}</span><br><span class=\"\">\n{{ k.description | textCutter:true:100}}</span></md-card-title-text></md-card-title></div><div flex=\"5\"><div \nlayout=\"row\" layout-align=\"end start\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item ng-show=\"!(k.active === false)\"><md-button ng-click=\"vm.openIndicatorDialog(null, k, false)\" \naria-label=\"Editar indicador\">Editar indicador</md-button></md-menu-item><md-menu-item ng-show=\"!(k.active === false)\">\n<md-button ng-click=\"vm.openManualResultDialog(null, k)\" \nng-disabled=\"k.automatedExtractionQuery && k.automatedExtractionQuery.query\" aria-label=\"Novo resultado\">\nAdicionar resultado</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.showConfirm($event, k);\" \naria-label=\"Ativar/Reativar indicador\"><span ng-show=\"!(k.active === false)\">Inativar indicador</span> <span \nng-show=\"k.active === false\">Reativar indicador</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n</div></div><div layout=\"row\"><kpi-chart code=\"{{k.code}}\" indicator=\"k\" config=\"vm.chart.config\" \noptions=\"vm.chart.options\" update=\"vm.lastUpdate[k.$id]\" period=\"6\" flex></kpi-chart></div></md-card></div></div><div \nflex-gt-sm=\"10\" flex=\"100\"><section layout=\"column\" layout-sm=\"column\" layout-align=\"start center\" layout-padding>\n<md-button md-no-ink class=\"md-accent md-fab\" aria-label=\"Novo Indicador\" ng-click=\"vm.newIndicator();\"><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_add_white_48px.svg\"></md-icon></md-button></section></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/main/home/apps/admin/ation-plan-without-department/ac-without-dept.html","<div class=\"page-layout simple\" id=\"acwithoutdept-view\" layout=\"row\" layout-padding \nmd-theme=\"{{vm.themes.active.name}}\"><md-content flex=\"100\" layout=\"row\"><div flex=\"50\" layout-fill><div layout=\"row\" \nflex><div flex=\"100\"><div flex ng-cloak><h2 class=\"md-no-sticky\">CASOS ENCONTRADOS</h2><div \nclass=\"list-panel-outside scrollable\" ms-scroll><md-list class=\"list-panel\"><md-list-item class=\"target-item\" \nng-class=\"{\'item-selected\':vm.selectedCase === fap.NCId}\" ng-repeat=\"fap in vm.foundActionPlans\" \nng-click=\"vm.loadNC(fap)\" aria-label=\"fap\"><div layout=\"row\" flex><div flex=\"initial\"><span class=\"left-align\"><b>\nProcesso:</b> {{fap.PId}}</span></div><div flex flex-offset=\"10\"><span class=\"left-align\"><b>Não conformidade:</b>\n {{fap.NCId}}</span></div></div></md-list-item></md-list></div></div></div></div></div><div flex=\"40\" \nstyle=\"padding: 0px\" flex-offset=\"10\"><div layout=\"column\" flex ng-hide=\"$rootScope.loadingProgress\"><div flex=\"100\">\n<div flex ng-cloak><h2 class=\"md-no-sticky\">NÃO CONFORMIDADE</h2><div class=\"list-panel-outside\" \nlayout-align=\"center center\"><div layout=\"column\"><span><b>ID:</b> <span ng-bind=\"vm.nonCompliance.$id\"></span></span> \n<span><b>Título:</b> <span ng-bind=\"vm.nonCompliance.title\"></span></span><hr><span><b>Setor de ocorrência:</b> <span \nng-bind=\"vm.nonCompliance.occurrenceDeptName\"></span></span> <span><b>ID:</b> <span \nng-bind=\"vm.nonCompliance.occurrenceDepartment\"></span></span><hr><span><b>Setor reclamante:</b> <span \nng-bind=\"vm.nonCompliance.claimantDeptName\"></span></span> <span><b>ID:</b> <span ng-bind=\"vm.nonCompliance.claimant\">\n</span></span><hr><div layout=\"row\" layout-align=\"end end\" flex><md-button class=\"md-accent\" aria-label=\"Corrigir\" \nng-click=\"vm.fix()\" ng-disabled=\"!vm.canFix\">Corrigir</md-button></div></div></div></div></div><div flex=\"100\" \nng-show=\"vm.newProcess\"><div flex ng-cloak><h2 class=\"md-no-sticky\">Novo PId: {{vm.newProcess}}</h2></div></div></div>\n</div></md-content></div>");
$templateCache.put("app/main/home/apps/admin/db-association/db-association.html","<div class=\"page-layout simple\" id=\"db-association-view\" layout=\"row\" layout-padding \nmd-theme=\"{{vm.themes.active.name}}\"><md-content flex=\"100\" layout=\"row\"><div flex=\"20\"><md-tabs layout-fill \nmd-selected=\"vm.currentTabIndex\"><md-tab><md-tab-label>Tabela</md-tab-label><md-tab-body><md-list><md-list>\n<md-list-item ng-class=\"{\'item-selected\':se[0] === vm.selectedMasterEntity[0]}\" \nng-repeat=\"se in vm.entities.resultset\" ng-click=\"vm.selectMasterEntity(se)\" aria-label=\"se.name\"><p>{{se[1]}}</p>\n</md-list-item></md-list></md-list></md-tab-body></md-tab><md-tab><md-tab-label>Origem</md-tab-label><md-tab-body>\n<md-list><md-list-item ng-class=\"{\'item-selected\':s[1] === vm.selectedSource[1]}\" \nng-repeat=\"s in vm.sources.resultset\" ng-click=\"vm.selectSource(s)\" aria-label=\"s.name\"><p>{{s[1]}}</p></md-list-item>\n</md-list></md-tab-body></md-tab></md-tabs></div><div flex=\"80\" style=\"padding: 0px\"><div layout=\"row\" flex><div \nflex=\"100\"><div flex ng-cloak><h2 class=\"md-no-sticky\">Tabela: <b>{{vm.selectedMasterEntity[1]}}</b></h2><div \nclass=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon><input flex ng-model=\"vm.searchMaster\" type=\"text\" placeholder=\"Pesquise pelo item\"></div><div \nclass=\"list-panel-outside scrollable\" ms-scroll><md-list class=\"list-panel\"><md-list-item class=\"target-item\" \nng-repeat=\"mi in vm.masterItems.resultset |\n                                                         filter:vm.searchMaster |\n                                                         orderBy:\'1\'\" \nng-click=\"vm.linkItem(mi)\" ng-disabled=\"vm.sourceItensSelected < 1\" aria-label=\"mi.name\"><p class=\"left-align\">\n{{mi[0] + \' - \' + mi[1]}}</p></md-list-item></md-list></div></div></div><div flex=\"100\" flex-offset=\"5\"><div flex \nng-cloak><h2 class=\"md-no-sticky\">Origem: <b>{{vm.selectedSource[1]}}</b></h2><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.searchSource\" type=\"text\" placeholder=\"Pesquise pelo item\"></div><div \nclass=\"list-panel-outside scrollable\" ms-scroll><md-list class=\"list-panel\"><md-list-item class=\"source-item\" \nng-repeat=\"si in vm.sourceItems.resultset |\n                                                         filter:vm.searchSource |\n                                                         filter:vm.onlyCheckedFilter |\n                                                         filter:vm.notLinkedFilter | \n                                                         orderBy:\'1\'\" \naria-label=\"si.name\"><div flex=\"95\"><p class=\"left-align\">{{si[0] + \' - \' + si[1]}}</p></div><div flex=\"5\"><md-checkbox\n class=\"md-secondary\" ng-model=\"si.selected\" ng-change=\"vm.countSourceItemsSelected(si.selected)\"></md-checkbox></div>\n</md-list-item></md-list></div><div layout=\"row\" layout-padding layout-align=\"end start\"><md-checkbox \nng-model=\"vm.showOnlyChecked\" ng-disabled=\"vm.sourceItensSelected <= 1\">Exibir somente marcados</md-checkbox></div>\n</div></div></div><div flex=\"100\" layout-padding layout=\"row\"><div flex=\"100\"><md-content flex><h2 \nclass=\"md-no-sticky\">Itens Associados</h2><div class=\"list-panel-outside scrollable\" ms-scroll><div class=\"list-panel\">\n<md-table-container class=\"association-table\"><table md-table ng-model=\"vm.selectedAssociation\"><thead md-head \nmd-order=\"ai.order\"><tr md-row><th md-column colspan=\"2\"><span>Destino</span></th><th md-column colspan=\"2\"><span>\nOrigem</span></th></tr><tr md-row><th md-column><span>Cód.</span></th><th md-column><span>Nome</span></th><th \nmd-column><span>Cód.</span></th><th md-column><span>Nome</span></th><th md-column></th></tr></thead><tbody md-body><tr \nmd-row md-select=\"ai\" md-select-id=\"masterId\" md-auto-select \nng-repeat=\"ai in vm.linkedItems.resultset | orderBy:\'targetName\'\"><td md-cell>{{ai[2]}}</td><td md-cell>\n{{ai.targetName}}</td><td md-cell>{{ai[3]}}</td><td md-cell>{{ai.sourceName}}</td><td md-cell><md-button \nclass=\"md-icon-button\" ng-click=\"vm.unlinkItem(ai)\" aria-label=\"Desassociar\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table></md-table-container></div></div></md-content></div></div></div>\n</md-content></div>");
$templateCache.put("app/main/home/apps/admin/department/department.change-responsible.modal.html","<md-dialog aria-label=\"Departamentos\" class=\"task-dialog\" aria-label=\"Departamento\" md-theme=\"{{themes.active.name}}\" \nmd-theme-watch><form ng-cloak name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nMicrossistema - Trocar Responsável</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"fechar()\"><md-icon\n md-svg-src=\"img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex-gt-xs><label>Responsável Atual</label><md-select ng-model=\"responsible\" aria-label=\"Responsável\" \nng-disabled=\"true\"><md-option ng-repeat=\"user in users\" value=\"{{user.id}}\">{{user.firstName}}</md-option></md-select>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>\nNovo Responsável</label><input ng-model=\"departamento.responsible\" list=\"dps\" aria-label=\"Responsável\" required>\n<datalist id=\"dps\"><option ng-repeat=\"user in users\" value=\"{{user.id}}\" \nng-show=\"user.id.toLowerCase() !== responsible.toLowerCase()\">{{user.firstName}} {{user.id}}</option></datalist>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"salvarDepartamento()\" ng-disabled=\"!form.$valid\">Salvar</md-button><md-button ng-click=\"fechar()\">Fechar\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/home/apps/admin/department/department.html","<div id=\"dashboard-sghq-minutes\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex \nms-scroll><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Microssistemas</span></div></div></div>\n<div class=\"content\"><section layout=\"row\" layout-sm=\"column\" layout-align=\"end end\" layout-padding><md-button \nmd-no-ink class=\"md-fab md-fab-bottom-right docs-scroll-fab md-button md-ink-ripple scrolling\" \nng-click=\"openDialog($event)\" aria-label=\"Novo departamento\"><md-tooltip md-direction=\"top\" \nmd-visible=\"tooltipVisible\">Novo microssistema</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/fonts/ic_add_white_48px.svg\"></md-icon></md-button></section><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-show=\"loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div class=\"white-bg md-whiteframe-4dp\" layout-margin layout-padding ng-show=\"!loading\">\n<table id=\"tableDepartament\" datatable=\"ng\" dt-column-defs=\"dtColumnDefs\" class=\"row-border hover\" \ndt-options=\"dtOptions\" dt-instance=\"dtInstance\"><thead><tr><th style=\"cursor: pointer\">Sigla</th><th \nstyle=\"cursor: pointer\">Nome</th><th style=\"cursor: pointer\">Responsável</th><th style=\"cursor: pointer\">E-mail</th>\n<th>Editar</th><th>Excluir</th></tr></thead><tbody><tr ng-repeat=\"d in departamentos\"><td>{{d.sigla}}</td><td>\n{{d.name}}</td><td>{{d.responsible}}</td><td>{{d.email}}</td><td><md-button class=\"md-icon-button md-primary\" \naria-label=\"Editar\" ng-click=\"openDialog($event, d)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button class=\"md-icon-button md-primary\" aria-label=\"Trocar Responsável\" ng-disabled=\"!isAdmin\" \nng-click=\"openDialogChangeResponsible($event, d)\"><md-icon md-font-icon=\"icon-account-switch\"></md-icon></md-button>\n</td><td><md-button class=\"md-icon-button md-primary\" aria-label=\"Excluir\" ng-disabled=\"!isAdmin\" \nng-click=\"excluirDepartamento(d);\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/home/apps/admin/department/department.modal.html","<md-dialog aria-label=\"Departamentos\" class=\"task-dialog\" aria-label=\"Departamento\" md-theme=\"{{themes.active.name}}\" \nmd-theme-watch><form ng-cloak name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Departamento</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"fechar()\"><md-icon md-svg-src=\"img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>Sigla</label><input \nng-model=\"departamento.sigla\" required minlength=\"2\" maxlength=\"6\" uppercase name=\"sigla\"><div \nng-messages=\"form.sigla.$error\" role=\"alert\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\']\">\nSigla é obrigatória e precisa ter entre 2 e 6 caracteres.</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>Nome</label><input \nng-model=\"departamento.name\" required ng-minlength=\"3\" ng-maxlength=\"50\" name=\"name\"><div \nng-messages=\"form.name.$error\" role=\"alert\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\']\">\nNome é obrigatório e precisa ter entre 3 e 50 caracteres.</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>Responsável</label><input \nng-model=\"departamento.responsible\" list=\"dps\" aria-label=\"Responsável\" required><datalist id=\"dps\"><option \nng-repeat=\"user in users\" value=\"{{user.id}}\">{{user.firstName}}</option></datalist></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>E-mail</label><input \nng-model=\"departamento.email\" type=\"email\" name=\"email\" ng-pattern=\"/^.+@.+\\..+$/\"><div \nng-messages=\"form.email.$error\" role=\"alert\"><div ng-message-exp=\"[\'pattern\']\">Informe um e-mail válido.</div></div>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"salvarDepartamento()\" ng-disabled=\"!form.$valid\">Salvar</md-button><md-button ng-click=\"fechar()\">Fechar\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/home/apps/admin/usersdepartments/showdepartments.modal.html","<md-dialog aria-label=\"Departamentos\" class=\"task-dialog\" aria-label=\"Departamentos\" md-theme=\"{{themes.active.name}}\" \nmd-theme-watch><form ng-cloak name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nDepartamentos associados ao usuário</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon\n md-svg-src=\"img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><div layout-gt-xs=\"row\"><h3><md-icon md-font-icon=\"icon-account\">\n</md-icon>{{userDepartments.user}}</h3></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs>\n<table id=\"tableDepartaments\" datatable=\"ng\" class=\"row-border hover\" dt-options=\"dtOptions\" dt-instance=\"dtInstance\">\n<thead><tr><th>Departamento</th></tr></thead><tbody><tr ng-repeat=\"d in departments\" \nng-if=\"userDepartments.departments.indexOf(d.id) > -1\"><td>{{d.sigla}} - {{d.name}}</td></tr></tbody></table>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"close()\">Fechar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/home/apps/admin/usersdepartments/usersdepartments.html","<div id=\"dashboard-sghq-minutes\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex \nms-scroll><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Usuários e Microssistemas</span></div>\n</div></div><div class=\"content\"><section layout=\"row\" layout-sm=\"column\" layout-align=\"end end\" layout-padding>\n<md-button md-no-ink class=\"md-fab md-fab-bottom-right docs-scroll-fab md-button md-ink-ripple scrolling\" \nng-click=\"openDialog($event)\" aria-label=\"Nova associação\"><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\nNova associação</md-tooltip><md-icon md-svg-src=\"assets/icons/fonts/ic_add_white_48px.svg\"></md-icon></md-button>\n</section><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"loading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div class=\"white-bg md-whiteframe-4dp\" layout-margin \nlayout-padding ng-show=\"!loading\"><table id=\"tableUserDepartaments\" datatable=\"ng\" dt-column-defs=\"dtColumnDefs\" \nclass=\"row-border hover\" dt-options=\"dtOptions\" dt-instance=\"dtInstance\"><thead><tr><th style=\"cursor: pointer\">Usuário\n</th><th style=\"cursor: pointer\">Microssistemas</th><th>Editar</th><th>Excluir</th></tr></thead><tbody><tr \nng-repeat=\"d in listUserDepartments\"><td>{{d.user}}</td><td>\n{{d.departments.length}} microssistema{{d.departments.length === 1 ? \'\' : \'s\'}}<md-button \nclass=\"md-icon-button md-primary\" aria-label=\"Visualizar\" ng-click=\"showDepartments($event, d);\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></td><td><md-button class=\"md-icon-button md-primary\" \naria-label=\"Editar\" ng-click=\"openDialog($event, d)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td>\n<td><md-button class=\"md-icon-button md-primary\" aria-label=\"Excluir\" ng-disabled=\"!isAdmin\" ng-click=\"delete(d);\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/home/apps/admin/usersdepartments/usersdepartments.modal.html","<md-dialog aria-label=\"Departamentos\" class=\"task-dialog\" aria-label=\"Departamento\" md-theme=\"{{themes.active.name}}\" \nmd-theme-watch><form ng-cloak name=\"form\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Usuário e Microssistemas</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon \nmd-svg-src=\"img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex-gt-xs><label>Usuário</label><md-select ng-model=\"userDepartments.user\" aria-label=\"Usuário\" required \nng-disabled=\"edicao\"><md-option ng-repeat=\"user in users\" value=\"{{user.id}}\">{{user.firstName}}</md-option>\n</md-select></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>\nMicrossistemas</label><md-select multiple=\"multiple\" ng-model=\"userDepartments.departments\" aria-label=\"Departamentos\" \nrequired><md-option ng-repeat=\"department in departments\" value=\"{{department.id}}\">\n{{department.sigla}} - {{department.name}}</md-option></md-select></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"save()\" ng-disabled=\"!form.$valid\">Salvar\n</md-button><md-button ng-click=\"close()\">Fechar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/home/apps/kpi/results/indicator-results.html","<result-analysis department=\"{{vm.departmentId}}\" indicator=\"{{vm.indicatorId}}\"></result-analysis>");
$templateCache.put("app/main/home/apps/activiti/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\">Tarefas</span></div><md-select class=\"project-selection simplified\" \nng-model=\"vm.selectedProject\" placeholder=\"Selecionar atribuição\"><md-option \nng-repeat=\"(project, title) in vm.projects\" value=\"{{project}}\">{{title}}</md-option></md-select></div><md-content \nclass=\"content\" flex ms-scroll><div class=\"add-task-button\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.openTaskDialog($event)\" aria-label=\"NOVA TAREFA\">NOVA TAREFA</md-button></div><div \nclass=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"Todas as tarefas\" \nng-class=\"{\'selected\':vm.showAllTasks}\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\">Todas as tarefas ativas</span>\n</div></md-button><div class=\"item subheader\">Filtros</div><md-button class=\"item\" aria-label=\"Concluídas\" \nng-show=\"!vm.history\" ng-click=\"vm.toggleFilterWithEmpty(\'delegationState\')\" \nng-class=\"{\'selected\':vm.taskFilters.delegationState}\"><md-icon md-font-icon=\"icon-check\" class=\"s16\"></md-icon><span \nclass=\"title\">Delegadas</span></md-button><md-button class=\"item\" aria-label=\"Programado\" \nng-click=\"vm.toggleFilterWithEmpty(\'dueDate\')\" ng-class=\"{\'selected\':vm.taskFilters.dueDate}\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"s16\"></md-icon><span class=\"title\">Programadas</span></md-button><md-button \nclass=\"item\" aria-label=\"Hoje\" ng-click=\"vm.toggleFilterWithEmpty(\'createTime\')\" \nng-class=\"{\'selected\':vm.taskFilters.createTime}\"><md-icon md-font-icon=\"icon-calendar-today\" class=\"s16\"></md-icon>\n<span class=\"title\">Criadas hoje</span></md-button><md-button class=\"item\" aria-label=\"Concluídas\" \nng-click=\"vm.loadTasks(true);\"><md-icon md-font-icon=\"icon-check\" class=\"s16\"></md-icon><span class=\"title\">Concluídas\n</span></md-button></div></md-content>");
$templateCache.put("app/main/home/apps/activiti/dialogs/process/process-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"Tarefa\" md-theme=\"{{vm.themes.active.name}}\" md-theme-watch><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nIniciar processo ({{vm.process.name + \' | Versão \' + vm.process.version}})</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Fechar\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll class=\"md-inline-form\"><div class=\"content-column\" layout=\"column\"><div \nclass=\"info-block\" layout=\"row\"><div class=\"info\" layout=\"column\" flex=\"100\"><span class=\"label\">Título</span> <span \nclass=\"value\">{{vm.title}}</span></div></div><div class=\"info-block\" layout=\"row\"><div class=\"info\" layout=\"column\" \nflex=\"100\"><span class=\"label\">Descrição</span> <span class=\"value\">\n{{vm.process.description || \'Este processo não possui uma descrição definida.\'}}</span></div></div></div><md-divider>\n</md-divider><div class=\"content-column\" layout=\"column\" ng-show=\"vm.process.form.formProperties.length > 0\"><div \nclass=\"info-block\" layout=\"row\"><div class=\"info\" layout=\"column\" flex=\"100\"><span class=\"label\">\nPreencha o formulário abaixo e inicie o processo</span></div></div></div><div class=\"row\" \nng-repeat=\"item in vm.process.form.formProperties\" ng-e><md-input-container class=\"md-block\" layout=\"column\" flex>\n<label>{{item.name}} <span ng-show=\"item.required\">* </span></label><md-select ng-if=\"item.type==\'enum\'\" \nng-model=\"vm.process.propertyForSaving[item.id].value\"><md-option ng-repeat=\"enum in item.enumValues\" \nvalue=\"{{enum.id}}\">{{enum.name}}</md-option></md-select><md-select ng-if=\"item.type==\'user\'\" \nng-model=\"vm.process.propertyForSaving[item.id].value\"><md-option ng-repeat=\"enum in item.enumValues.data\" \nvalue=\"{{enum.id}}\">{{enum.firstName}}</md-option></md-select><input ng-if=\"item.type==\'string\'\" \nng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" ng-required=\"item.required\" \nng-model=\"vm.process.propertyForSaving[item.id].value\"> <input ng-if=\"item.type==\'date\'\" ng-visible=\"item.readable\" \nng-disabled=\"{{item.writable == false}}\" ng-required=\"item.required\" \nng-model=\"vm.process.propertyForSaving[item.id].value\"> <input ng-if=\"item.type==\'long\'\" ng-visible=\"item.readable\" \nng-enabled=\"item.writable\" ng-required=\"item.required\" placeholder=\"{{item.name}}\" \nng-model=\"vm.process.propertyForSaving[item.id].value\"> <input ng-if=\"item.type==\'boolean\'\" ng-visible=\"item.readable\" \nng-enabled=\"item.writable\" type=\"checkbox\" class=\"form-control\" placeholder=\"{{item.name}}\" \nng-model=\"vm.process.propertyForSaving[item.id].value\" style=\"width:16px\"></md-input-container></div><md-dialog-actions\n layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.startProcess(vm.process.id)\" class=\"send-button md-accent md-raised\" \naria-label=\"Iniciar processo\">INICIAR PROCESSO</md-button></div><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" class=\"send-button md-primary md-raised\" ng-click=\"vm.closeDialog()\" \naria-label=\"Finalizar tarefa\">CANCELAR</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/home/apps/activiti/dialogs/process/process-dialog2.html","<md-dialog class=\"task-dialog\" aria-label=\"Processo\"><form name=\"processForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-3\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Fechar\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-block\"><label>Título</label><span ng-bind=\"vm.process.name\"></span></md-input-container>\n<div class=\"notes\" ng-show=\"vm.process.description\"><label>Descrição</label><text-angular \nng-bind=\"vm.process.description\"></text-angular></div><div class=\"row taskForm\" \nng-repeat=\"item in vm.process.form.formProperties\" ng-e><div class=\"form-group\"><md-input-container flex><label>\n{{item.name}} <span ng-show=\"item.required\">* </span></label><md-select ng-if=\"item.type == \'enum\'\" \nng-model=\"vm.process.propertyForSaving[item.id].value\"><md-option ng-repeat=\"enum in item.enumValues\" \nvalue=\"{{enum.id}}\">{{enum.name}}</md-option></md-select><md-select ng-if=\"item.type == \'user\'\" \nng-model=\"vm.process.propertyForSaving[item.id].value\"><md-option ng-repeat=\"enum in item.enumValues.data\" \nvalue=\"{{enum.id}}\">{{enum.firstName}}</md-option></md-select><input ng-if=\"item.type == \'string\'\" \nng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" class=\"form-control\" type=\"text\" \nng-required=\"item.required\" ng-model=\"vm.process.propertyForSaving[item.id].value\"> <input ng-if=\"item.type == \'date\'\" \nng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" class=\"form-control\" type=\"text\" \nng-required=\"item.required\" ng-model=\"vm.process.propertyForSaving[item.id].value\"> <input ng-if=\"item.type == \'long\'\" \nng-visible=\"item.readable\" ng-enabled=\"item.writable\" ng-required=\"item.required\" type=\"text\" class=\"form-control\" \nplaceholder=\"{{item.name}}\" ng-model=\"vm.process.propertyForSaving[item.id].value\"> <input \nng-if=\"item.type == \'boolean\'\" ng-visible=\"item.readable\" ng-enabled=\"item.writable\" type=\"checkbox\" \nclass=\"form-control\" placeholder=\"{{item.name}}\" ng-model=\"vm.process.propertyForSaving[item.id].value\" \nstyle=\"width:16px\"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.startProcess(vm.process.id)\" class=\"send-button md-accent md-hue-3 md-raised\" \naria-label=\"Iniciar processo\">INICIAR PROCESSO</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/home/apps/activiti/dialogs/task/task-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"Tarefa\" md-theme=\"{{vm.themes.active.name}}\" md-theme-watch><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \nng-show=\"!vm.newTask\">{{vm.task.name}}</span> <span class=\"title\" ng-show=\"vm.newTask\">Nova tarefa</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Fechar\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"md-inline-form\"><div ng-show=\"vm.newTask\"><div \nlayout=\"row\"><md-input-container class=\"md-block\" layout=\"column\" flex=\"70\"><label>Título</label><input name=\"title\" \nmaxlength=\"225\" md-maxlength=\"225\" ng-model=\"vm.task.name\" required><div ng-messages=\"taskForm.title.$error\" \nng-show=\"taskForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Título da tarefa é necessário</span>\n</div></div></md-input-container><div layout=\"column\" flex><div flex class=\"date-container\"><md-datepicker flex \nng-model=\"vm.task.dueDateTmp\" md-placeholder=\"Data limite\" \nng-change=\"vm.task.dueDate = vm.task.dueDateTmp.toISOString()\"></md-datepicker></div></div></div><div layout=\"row\" \nlayout-align=\"start start\"><md-input-container class=\"md-block\" layout=\"column\" aria-label=\"Prioridade\" flex=\"50\"><p>\nPrioridade</p><md-radio-group ng-model=\"vm.task.priority\"><md-radio-button value=\"0\" class=\"md-accent\">Baixa\n</md-radio-button><md-radio-button value=\"50\" class=\"md-accent\">Média</md-radio-button><md-radio-button value=\"100\" \nclass=\"md-accent\">Alta</md-radio-button></md-radio-group></md-input-container><md-input-container class=\"md-block\" \nlayout=\"column\" flex=\"50\" style=\"padding-top: 25px\"><label>Atribuir a</label><md-select ng-model=\"vm.task.assignee\" \naria-label=\"Atribuição\"><md-option ng-repeat=\"user in vm.users\" value=\"{{user.id}}\">{{user.firstName}}</md-option>\n</md-select></md-input-container></div><md-input-container class=\"md-block\"><label>Descrição</label><textarea \nname=\"description\" ng-model=\"vm.task.description\" maxlength=\"150\" md-maxlength=\"150\" rows=\"5\" md-select-on-focus>\n</textarea></md-input-container></div><div class=\"content-column\" layout=\"column\" ng-show=\"!vm.newTask\"><div \nclass=\"info-block\" layout=\"row\"><div class=\"info\" layout=\"column\" flex=\"25\"><span class=\"label\">Data limite</span> \n<span class=\"value\">{{vm.task.dueDate | date: \'dd/MM/yyyy\'}}</span> <span class=\"value\" ng-show=\"!vm.task.dueDate\">\nSem data limite</span></div><div class=\"info\" layout=\"column\" flex=\"25\"><span class=\"label\">Relevância</span> <span \nclass=\"value\">{{vm.task.priority | priority}}</span></div><div class=\"info\" layout=\"column\" flex=\"50\"><span \nclass=\"label\">Data de criação</span> <span class=\"value\">{{vm.task.createTime | date: \'dd/MM/yyyy\'}}</span></div></div>\n</div><md-divider></md-divider><div class=\"content-column\" layout=\"column\" ng-show=\"!vm.newTask\"><div \nclass=\"info-block\" layout=\"row\"><div class=\"info\" layout=\"column\" flex=\"70\"><span class=\"label\">Descrição</span> <span \nclass=\"value\">{{vm.task.description || \'Esta tarefa não possui uma descrição definida.\'}}</span></div><div \nclass=\"info\" layout=\"column\" flex=\"30\" ng-if=\"vm.task.processInstanceId\"><span class=\"label\">Parte do processo</span> \n<span class=\"value\">{{vm.task.processInstanceId}}</span></div></div></div><md-divider></md-divider><div \nclass=\"content-column\" layout=\"column\" ng-show=\"vm.task.form.formProperties.length > 0\"><div class=\"info-block\" \nlayout=\"row\"><div class=\"info\" layout=\"column\" flex=\"100\"><span class=\"label\">\nPreencha o formulário abaixo e complete a tarefa</span></div></div></div><div class=\"row\" \nng-repeat=\"item in vm.task.form.formProperties\" ng-e ng-show=\"!vm.task.formKey\"><md-input-container class=\"md-block\" \nlayout=\"column\" flex><label>{{item.name}} <span ng-show=\"item.required\">* </span></label><md-select \nng-if=\"item.type==\'enum\'\" ng-model=\"vm.task.propertyForSaving[item.id].value\"><md-option \nng-repeat=\"enum in item.enumValues\" value=\"{{enum.id}}\">{{enum.name}}</md-option></md-select><md-select \nng-if=\"item.type==\'user\'\" ng-model=\"vm.task.propertyForSaving[item.id].value\"><md-option \nng-repeat=\"enum in item.enumValues.data\" value=\"{{enum.id}}\">{{enum.firstName}}</md-option></md-select><input \nng-if=\"item.type==\'string\'\" ng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" \nng-required=\"item.required\" ng-model=\"vm.task.propertyForSaving[item.id].value\"> <input ng-if=\"item.type==\'date\'\" \nng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" ng-required=\"item.required\" \nng-model=\"vm.task.propertyForSaving[item.id].value\"> <input ng-if=\"item.type==\'long\'\" ng-visible=\"item.readable\" \nng-enabled=\"item.writable\" ng-required=\"item.required\" placeholder=\"{{item.name}}\" \nng-model=\"vm.task.propertyForSaving[item.id].value\"> <input ng-if=\"item.type==\'boolean\'\" ng-visible=\"item.readable\" \nng-enabled=\"item.writable\" type=\"checkbox\" class=\"form-control\" placeholder=\"{{item.name}}\" \nng-model=\"vm.task.propertyForSaving[item.id].value\" style=\"width:16px\"></md-input-container></div><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\" ng-show=\"!vm.history\"><div layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.newTask\"><md-button type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.createTask()\" \naria-label=\"Criar tarefa\">CRIAR TAREFA</md-button></div><div layout=\"row\" layout-align=\"start center\" \nng-show=\"!vm.newTask && !vm.task.formKey && vm.task.assignee\"><md-button type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.finishTask(vm.task.id)\" aria-label=\"Finalizar tarefa\">\n{{vm.task.delegationState === \'pending\' ? \'RESOLVER TAREFA\' : \'FINALIZAR TAREFA\'}}</md-button></div><div layout=\"row\" \nlayout-align=\"start center\" ng-show=\"!vm.newTask\" flex><md-button type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.delegateTask(vm.task.id)\" aria-label=\"Delegar tarefa\" \nng-disabled=\"!vm.task.assigneeTmp\">DELEGAR TAREFA</md-button><md-input-container class=\"md-block\" layout=\"column\" \nflex=\"50\"><md-select ng-model=\"vm.task.assigneeTmp\" aria-label=\"Delegar\" placeholder=\"Usuário\"><md-option \nng-repeat=\"user in vm.users\" value=\"{{user.id}}\">{{user.firstName}}</md-option></md-select></md-input-container></div>\n<div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" class=\"send-button md-primary md-raised\" \nng-click=\"vm.closeDialog()\" aria-label=\"Finalizar tarefa\">CANCELAR</md-button></div></md-dialog-actions>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/home/apps/activiti/views/list/list-view.html","<div class=\"tasks-item\" md-ink-ripple layout=\"row\" layout-align=\"start center\" \nng-click=\"t.formKey ? vm.loadTaskWithFormKey(t) : vm.loadTask(t) \" \nng-repeat=\"t in vm.tasks \n                | orderBy:vm.taskOrder:vm.taskOrderDescending \n                | filter:vm.filterNyUser\n                | filter:global.search \n                | filter:vm.taskFilters.search \n                | filter:vm.filterByCreateTime \n                | filter:vm.filterByDelegationState\n                | filter:vm.filterByPrefixes\n                | filter:vm.filterByDueDate track by $index\" \nng-class=\"{\'completed\': t.completed}\"><div class=\"handle\" ng-click=\"vm.preventDefault($event)\"><md-icon \nmd-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div><md-checkbox class=\"no-label\" \nng-checked=\"$mdOpenMenu($event)\" aria-label=\"Concluir tarefa\"></md-checkbox><div layout=\"row\" \nlayout-align=\"start center\" flex><md-tooltip md-delay=\"2000\"><div layout=\"column\"><span>ID da Tarefa: {{t.id}}</span>\n</div></md-tooltip><div class=\"info\" flex><div layout=\"row\"><div class=\"title\" flex-gt-md=\"80\" flex=\"50\">{{t.name}}\n</div><div class=\"title\" flex-gt-md=\"10\" flex=\"25\"><div ng-show=\"vm.taskFilters.delegationState === true\">Responsável\n</div></div><div class=\"title\" flex-gt-md=\"10\" flex=\"25\">Data</div></div><div class=\"notes\" layout=\"row\"><div \nflex-gt-md=\"80\" flex=\"50\"><div ng-if=\"t.description\">{{t.description}}<br></div><div ng-if=\"t.nonComplianceId\">\nIntegra o plano de ação da não conformidade <a ng-click=\"vm.openTaskOrigin($event, t)\">\n{{t.nonComplianceName.substr(t.nonComplianceName.indexOf(\':\') + 1, t.nonComplianceName.length - 1)}}</a></div></div>\n<div flex-gt-md=\"10\" flex=\"25\"><div ng-show=\"vm.taskFilters.delegationState === true\">{{t.assignee}}</div></div><div \nflex-gt-md=\"10\" flex=\"25\">{{t.dueDate | date:\'dd/MM/yyyy\'}}</div></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"is-important red-600-fg\" \nng-if=\"task.important\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"is-starred amber-600-fg\" \nng-if=\"task.starred\"></md-icon><md-menu><md-button class=\"md-icon-button\" aria-label=\"Mais\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"\" aria-label=\"Editar tarefa\"><md-icon \nng-class=\"t.suspended === false ? \'grey-fg\' : \'blue-fg\'\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"s18\">\n</md-icon><span ng-hide=\"t.formKey\" ng-click=\"vm.loadTask(t)\">Editar tarefa</span> <span ng-show=\"t.formKey\" \nng-click=\"vm.loadTask(t)\">Delegar tarefa</span></md-button></md-menu-item></md-menu-content></md-menu></div></div>\n</div>");
$templateCache.put("app/main/home/apps/kpi/dialogs/indicators/indicator-dialog.html","<md-dialog class=\"indicator-dialog\" aria-label=\"Indicador\" md-theme=\"{{vm.themes.active.name}}\" md-theme-watch>\n<md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" ng-show=\"!vm.newIndicator\">{{vm.indicator.name}}</span> <span class=\"title\" ng-show=\"vm.newIndicator\">\nNovo indicador de desempenho</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Fechar\"></md-icon></md-button></div></md-toolbar><form name=\"formKpi\">\n<md-dialog-content ms-scroll class=\"md-inline-form\"><div layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"md-block\" layout=\"column\" flex=\"30\"><label>C&oacute;digo</label><input type=\"text\" placeholder=\"C&oacute;digo\" \nng-disabled=\"!vm.newIndicator\" ng-model=\"vm.indicator.code\" \nonchange=\"this.value = this.value.replace(/^\\s+|\\s|\\s+$/gm,\'\').toUpperCase()\" required name=\"formKpi.code\">\n</md-input-container><md-input-container class=\"md-block\" layout=\"column\" flex=\"70\"><label>Nome</label><input \ntype=\"text\" placeholder=\"Nome do Indicador\" ng-model=\"vm.indicator.name\" required name=\"formKpi.name\">\n</md-input-container></div><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Cadastro\"><div layout=\"column\">\n<md-input-container class=\"md-block\" layout=\"column\" flex=\"100\"><label>Descri&ccedil;&atilde;o</label><input \ntype=\"text\" placeholder=\"Descri&ccedil;&atilde;o do indicador\" ng-model=\"vm.indicator.description\" required \nname=\"formKpi.description\"></md-input-container><md-input-container class=\"md-block\" layout=\"column\" flex=\"100\"><label>\nDescri&ccedil;&atilde;o da F&oacute;rmula de Medida</label><textarea type=\"text\" \nplaceholder=\"Descreva como &eacute; calculado este indicador\" ng-model=\"vm.indicator.descriptionOfMeasureFormula\" \nrequired name=\"formKpi.formulaMedida\"></textarea></md-input-container><md-input-container class=\"md-block\" \nlayout=\"column\" flex=\"100\"><label>Fonte de Refer&ecirc;ncia do Resultado do Indicador</label><input type=\"text\" \nng-model=\"vm.indicator.resultReferenceSource\" required name=\"formKpi.referencia\"></md-input-container></div><div \nlayout layout-sm=\"column\"><md-input-container class=\"md-block\" layout=\"column\" flex=\"100\"><label>Categoria</label>\n<md-select ng-model=\"vm.indicator.category\"><md-option ng-repeat=\"c in vm.kpiCategories\" value=\"{{c}}\">{{c}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" layout=\"column\" flex=\"100\"><label>\nSubcategoria</label><md-select ng-model=\"vm.indicator.subcategory\"><md-option ng-repeat=\"c in vm.kpiSubcategories\" \nvalue=\"{{c}}\">{{c}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" layout=\"column\" \nflex=\"100\"><label>Unidade de Medida</label><md-select ng-model=\"vm.indicator.measureUnit\"><md-option \nng-repeat=\"i in vm.kpiMeasureUnits\" value=\"{{i.measureUnitId}}\">{{i.measureUnitName}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" layout=\"column\" flex=\"100\"><label>\nFreq de Apura&ccedil;&atilde;o</label><md-select ng-model=\"vm.indicator.verificationFrequency\"><md-option \nng-repeat=\"i in vm.kpiVerificationFrequencies\" value=\"{{i}}\">{{i}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" layout=\"column\" flex=\"100\"><label>Orienta&ccedil;&atilde;o</label><md-select \nng-model=\"vm.indicator.orientation\"><md-option ng-repeat=\"i in vm.orientations\" value=\"{{i.orientation}}\">\n{{i.orientationDesc}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" layout=\"column\" flex=\"100\"><md-checkbox ng-model=\"vm.indicator.survey\">\nIndicador Refere-se à Satisfação do Cliente</md-checkbox></md-input-container></div></md-tab><md-tab label=\"Metas\"><div\n layout=\"row\" ng-show=\"vm.indicator.targets\"><md-table-container class=\"targets-table\" flex=\"50\"><table md-table \nng-model=\"vm.selected\"><thead md-head><tr md-row><th md-column flex=\"20\"><span>Início</span></th><th md-column \nflex=\"10\"><span>Meta</span></th><th md-column flex=\"30\">Fonte</th><th md-column flex=\"10\"></th></tr></thead><tbody \nmd-body><tr md-row md-select=\"target\" md-select-id=\"month\" md-auto-select ng-repeat=\"(k, v) in vm.indicator.targets\">\n<td md-cell>{{k | date:\'dd/MM/yyyy\'}}</td><td md-cell>{{v.target}}</td><td md-cell>{{v.source}}</td><td md-cell>\n<md-button class=\"md-icon-button\" ng-click=\"vm.removeTarget(k)\" aria-label=\"Remover meta\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div><div \nlayout=\"row\"><div flex=\"initial\" style=\"margin-top: 15px\"><md-datepicker md-placeholder=\"Início\" \nng-model=\"vm.selectedTarget.validFromTmp\" \nng-change=\"vm.selectedTarget.validFrom = vm.selectedTarget.validFromTmp.toISOString()\"></div><md-input-container \nclass=\"md-block\" layout=\"column\" flex=\"15\"><label>Meta</label><input type=\"number\" ng-model=\"vm.selectedTarget.target\" \nng-disabled=\"!vm.selectedTarget.validFrom\" min=\"0\" max=\"10000000\" step=\"0.25\"></md-input-container><md-input-container \nclass=\"md-block\" layout=\"column\" flex=\"45\" flex-offset=\"3\"><label>Fonte de Referencia</label><input type=\"text\" \nng-model=\"vm.selectedTarget.source\" ng-disabled=\"!vm.selectedTarget.validFrom\"></md-input-container><md-button \nng-click=\"vm.addTarget()\" ng-disabled=\"!vm.selectedTarget.validFrom\">Adicionar</md-button></div></md-tab><md-tab \nlabel=\"Extra&ccedil;&atilde;o Automatizada\"><div layout=\"row\"><md-input-container class=\"md-block\" layout=\"column\" \nflex=\"100\"><label>Fonte de Dados</label><md-select ng-model=\"vm.indicator.automatedExtractionQuery.datasource\">\n<md-option ng-repeat=\"ds in vm.kpiDataSources\" value=\"{{ds}}\">{{ds}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" layout=\"column\" flex=\"100\"><label>Tipo de Express&atilde;o</label><md-select \nng-model=\"vm.indicator.automatedExtractionQuery.type\"><md-option ng-repeat=\"qt in vm.kpiQueryTypes\" value=\"{{qt}}\">\n{{qt}}</md-option></md-select></md-input-container></div><md-input-container class=\"md-block\" layout=\"column\" \nflex=\"100\"><label>Consulta</label><textarea placeholder=\"select x from ...\" \nng-model=\"vm.indicator.automatedExtractionQuery.query\"></textarea></md-input-container></md-tab></md-tabs>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"!formKpi.$valid\" type=\"submit\" \nclass=\"send-button md-primary md-raised\" ng-click=\"vm.saveIndicator()\" aria-label=\"Criar tarefa\">SALVAR</md-button>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" class=\"send-button md-primary md-raised\" \nng-click=\"vm.closeDialog()\" aria-label=\"Finalizar tarefa\">CANCELAR</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/home/apps/kpi/dialogs/manual-results/manual-results-dialog.html","<md-dialog class=\"indicator-dialog\" aria-label=\"Indicador\" md-theme=\"{{vm.themes.active.name}}\" md-theme-watch>\n<md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.indicator.name}} - Adicionar Resultado</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Fechar\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"md-block\" layout=\"column\" flex=\"100\"><label>Categoria</label><md-select ng-model=\"vm.indicator.category\" \nng-disabled=\"true\"><md-option ng-repeat=\"c in vm.kpiCategories\" value=\"{{c}}\">{{c}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" layout=\"column\" flex=\"100\"><label>Unidade de Medida</label>\n<md-select ng-model=\"vm.indicator.measureUnit\" ng-disabled=\"true\"><md-option ng-repeat=\"i in vm.kpiMeasureUnits\" \nvalue=\"{{i.measureUnitId}}\">{{i.measureUnitName}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" layout=\"column\" flex=\"100\"><label>Freq de Apura&ccedil;&atilde;o</label><md-select \nng-model=\"vm.indicator.verificationFrequency\" ng-disabled=\"true\"><md-option \nng-repeat=\"i in vm.kpiVerificationFrequencies\" value=\"{{i}}\">{{i}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" layout=\"column\" flex=\"100\"><label>Orienta&ccedil;&atilde;o</label><md-select \nng-model=\"vm.indicator.orientation\" ng-disabled=\"true\"><md-option ng-repeat=\"i in vm.orientations\" \nvalue=\"{{i.orientation}}\">{{i.orientationDesc}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" layout=\"column\" flex=\"100\"><label>Utiliza Ref Externo</label><md-select \nng-model=\"vm.indicator.useExternaReference\" ng-disabled=\"true\"><md-option value=\"yes\">Sim</md-option><md-option \nvalue=\"no\">Não</md-option></md-select></md-input-container></div><div layout=\"column\"><div layout=\"row\" \nng-show=\"vm.indicator.results\"><md-table-container class=\"targets-table\" flex=\"50\"><table md-table \nng-model=\"vm.selected\"><thead md-head><tr md-row><th md-column flex=\"20\"><span>Encerramento</span></th><th md-column \nflex=\"10\"><span>Resultado</span></th><th md-column flex=\"10\"></th></tr></thead><tbody md-body><tr md-row \nmd-select=\"result\" md-select-id=\"month\" md-auto-select ng-repeat=\"(k, v) in vm.indicator.results\"><td md-cell>\n{{k | date:\'dd/MM/yyyy\'}}</td><td md-cell>{{v.value}}</td><td md-cell><md-button class=\"md-icon-button\" \nng-click=\"vm.removeResult(k)\" ng-hide=\"v.resultAnalysis\" aria-label=\"Remover resultado\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div><div \nlayout=\"row\" layout-align=\"start start\" layout-padding><div flex=\"initial\" style=\"margin-top: 15px\"><md-datepicker \nmd-placeholder=\"Data\" md-date-filter=\"vm.onlyFirstDay\" ng-model=\"vm.selectedResult.date\"></div><div flex=\"25\">\n<md-input-container class=\"md-block\" layout=\"column\"><label ng-click=\"console.warn(vm.selectedResult.value)\">Resultado\n</label><input type=\"number\" step=\"0.1\" ng-model=\"vm.selectedResult.value\" ng-disabled=\"!vm.selectedResult.date\">\n</md-input-container></div><div flex=\"25\"><md-input-container class=\"md-block\" layout=\"column\"><label>\nResultado (Confirmação)</label><input type=\"number\" step=\"0.1\" ng-model=\"vm.selectedResult.confirm\" \nng-disabled=\"!vm.selectedResult.date\"></md-input-container></div><div flex=\"25\" style=\"margin-top: 15px\"><md-button \nng-click=\"vm.addResult()\" ng-disabled=\"vm.isAddDisabled()\">Adicionar</md-button></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\" flex><md-button \ntype=\"submit\" ng-disabled=\"!vm.btnSaveEnb\" class=\"send-button md-primary md-raised\" ng-click=\"vm.saveIndicator()\" \naria-label=\"Salvar\">{{ vm.btnSaveLbl }}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/home/apps/kpi/directives/chart/kpi-chart.html","<nvd3 id=\"ctrl.id\" options=\"ctrl.chart.options\" data=\"ctrl.chartData[ctrl.id]\" class=\"with-3d-shadow with-transitions\" \napi=\"api\"></nvd3>");
$templateCache.put("app/main/home/apps/kpi/directives/action-plan/action-plan.html","<div flex=\"100\" layout-padding><div layout=\"column\" ng-show=\"taskId\"><div flex><div layout=\"column\"><span>\nUm plano de ação já foi gerado para essa análise.</span> <span>ID do Plano de Ação: {{taskId}}</span></div>\n<md-table-container class=\"result-table\"><table md-table ng-model=\"ctrl.selected\"><thead md-head><tr md-row><th \nmd-column><span>Tarefa</span></th><th md-column><span>Responsável</span></th><th md-column>Data</th></tr></thead><tbody\n md-body><tr md-row md-select=\"subtask\" md-select-id=\"name\" md-auto-select ng-repeat=\"subtask in ctrl.subtasks\"><td \nmd-cell>{{subtask.name}}</td><td md-cell>{{subtask.assignee}}</td><td md-cell>{{subtask.dueDate | date:\'dd/MM/yyyy\'}}\n</td></tr></tbody></table></md-table-container></div><div flex><span>\nVocê pode adicionar novas tarefas ao plano de ação:</span></div></div><div layout=\"row\" flex \nng-repeat=\"task in ctrl.tasksList\" ng-show=\"!(readonly === \'true\')\"><div flex=\"70\"><md-input-container \nclass=\"md-block\" layout=\"column\" flex=\"100\"><label>Tarefa</label><input type=\"text\" maxlength=\"225\" md-maxlength=\"225\" \nng-model=\"task.name\" ng-blur=\"ctrl.newLine()\" placeholder=\"Descreva a ação a ser realizada\"></md-input-container></div>\n<div flex=\"15\"><md-input-container class=\"md-block\" layout=\"column\" flex=\"100\"><label>Quem deve executar?</label>\n<md-select ng-model=\"task.assignee\" ng-change=\"ctrl.newLine()\"><md-option ng-repeat=\"user in ctrl.users\" \nvalue=\"{{user.id}}\" placeholder=\"Quem deve executar?\">{{user.firstName}}</md-option></md-select></md-input-container>\n</div><div flex=\"15\" style=\"margin-top: 15px\"><md-datepicker md-placeholder=\"Quando?\" ng-model=\"task.dueDate\" \nng-change=\"ctrl.newLine()\"></div></div></div>");
$templateCache.put("app/main/home/apps/kpi/directives/result-analysis/result-analysis.html","<div class=\"page-layout simple\" layout=\"row\" layout-padding ui-view=\"attach-result\"><md-content flex=\"100\"><div \nflex=\"100\" layout-padding><h1>{{ctrl.indicator.code}} - {{ctrl.indicator.name}}</h1><div layout=\"row\"><div flex=\"10\">\n<b>Descrição:</b></div><div flex=\"90\">{{ctrl.indicator.description}}</div></div><div layout=\"row\"><div flex=\"10\"><b>\nFórmula de Medida:</b></div><div flex=\"90\">{{ctrl.indicator.descriptionOfMeasureFormula}}</div></div><div layout=\"row\">\n<div flex=\"10\"><b>Unidade de Medida:</b></div><div flex=\"90\">{{ctrl.indicator.kpiMeasureUnits}}</div></div></div><div \nflex=\"100\" layout-padding><div md-whiteframe=\"4\" layout=\"row\"><div flex=\"30\"><div flex=\"100\"><span>\nEvolução do indicador:</span><md-input-container><md-select ng-model=\"ctrl.evoIndicator\" flex=\"100\" \naria-label=\"Evolução\"><md-option ng-repeat=\"e in ctrl.evoIndicatorList\" value=\"{{e.value}}\">{{e.title}}</md-option>\n</md-select></md-input-container></div><md-table-container class=\"result-table\"><table md-table \nng-model=\"ctrl.selected\"><thead md-head md-order=\"results.order\"><tr md-row><th md-column><span>Mês</span></th><th \nmd-column><span>Resultado</span></th><th md-column>Referencial</th></tr></thead><tbody md-body><tr md-row \nmd-select=\"result\" md-select-id=\"month\" md-auto-select ng-repeat=\"result in ctrl.resultsData\"><td md-cell>\n{{result.month}}</td><td md-cell>{{result.res}}<md-button class=\"md-icon-button\" \nng-click=\"ctrl.attachResult(ctrl.indicator.code, result.month, $event)\" aria-label=\"Adicionar resultados\"><md-icon \nclass=\"icon-teal\" ng-class=\"{\'icon-transparent\': !result.resultAnalysis}\" md-font-icon=\"icon-attachment\"></md-icon>\n</md-button></td><td md-cell>{{result.ref}}</td></tr></tbody></table></md-table-container></div><div flex=\"70\"><div \nlayout=\"row\"><kpi-chart code=\"{{ctrl.indicator.code}}\" config=\"ctrl.chart.config\" height=\"ctrl.chartHeight\" \nwidth=\"ctrl.chartWidth\" options=\"ctrl.chart.options\" flex></kpi-chart></div></div></div></div></md-content></div>");
$templateCache.put("app/main/home/apps/kpi/results/attachment/attach-result.html","<div class=\"page-layout simple input-standard\" layout=\"row\" layout-padding flex=\"100\"><md-content flex=\"100\"><div \nflex=\"100\" layout-padding><h1>Análise Crítica do Resultado</h1><md-input-container><md-select \nng-model=\"vm.selectedPeriod\" flex=\"100\" aria-label=\"Período\"><md-option ng-repeat=\"r in vm.resultsData\" \nvalue=\"{{r.month}}\">{{r.month}}</md-option></md-select></md-input-container><div layout=\"row\"><div layout=\"column\" \nflex=\"20\"><span class=\"info-gt\"><b>32%</b></span> <span>Resultado</span></div><div layout=\"column\" flex=\"20\"><span \nclass=\"info-gt\"><b>100%</b></span> <span>Meta</span></div></div><div layout=\"row\" layout-padding><div layout=\"column\" \nflex=\"100\"><div><b>Posso melhorar?</b></div><md-input-container><md-radio-group \nng-model=\"vm.resultModel.improvementOption\" layout=\"row\"><md-radio-button ng-repeat=\"p in vm.improvementOptions\" \nvalue=\"{{p.value}}\">{{p.title}}</md-radio-button></md-radio-group></md-input-container><md-input-container \nclass=\"md-block\" layout=\"column\" flex=\"50\"><label>Análise do resultado</label><textarea type=\"text\" \nng-model=\"vm.resultModel.resultAnalysis\" md-maxlength=\"1000\" maxlength=\"1000\" required></textarea></md-input-container>\n<md-input-container><div><b>Elaborar um RACP?</b></div><md-radio-group ng-model=\"vm.resultModel.RACPOption\" \nlayout=\"row\"><md-radio-button ng-repeat=\"r in vm.RACPOptions\" value=\"{{r.value}}\">{{r.title}}</md-radio-button>\n</md-radio-group></md-input-container></div></div><div layout=\"column\" ng-show=\"vm.resultModel.RACPOption === \'true\'\">\n<md-input-container class=\"md-block\" layout=\"column\" flex=\"100\"><label>Título do RACP</label><input type=\"text\" \nng-model=\"vm.resultModel.RACPTitle\" required></md-input-container><md-input-container class=\"md-block\" layout=\"column\" \nflex=\"50\"><label>Análise de Causa</label><textarea type=\"text\" ng-model=\"vm.resultModel.causeAnalysis\" \nmd-maxlength=\"1000\" maxlength=\"1000\" required></textarea></md-input-container><md-input-container><md-radio-group \nng-model=\"vm.resultModel.actionPlanOption\" layout=\"row\"><md-radio-button ng-repeat=\"ap in vm.actionPlanOptions\" \nvalue=\"{{ap.value}}\">{{ap.title}}</md-radio-button></md-radio-group></md-input-container><action-plan \ntaskslist=\"vm.tasksList\"></action-plan><md-input-container class=\"md-block\" layout=\"column\" flex=\"50\"><label>\nForma de Análise da Eficácia das Ações Planejadas</label><textarea type=\"text\" \nng-model=\"vm.resultModel.methodAnalysis\" md-maxlength=\"250\" maxlength=\"250\" required></textarea></md-input-container>\n<md-input-container class=\"md-block\" layout=\"column\" flex=\"50\"><label>Resultado Esperado</label><textarea type=\"text\" \nng-model=\"vm.resultModel.expectedResult\" md-maxlength=\"1000\" maxlength=\"1000\" required></textarea></md-input-container>\n<div layout=\"row\" layout-padding flex><div layout=\"column\"><label>\nResponsável pela análise da eficácia das ações planejadas</label><md-input-container class=\"md-block\" layout=\"column\" \nflex=\"50\"><md-select ng-model=\"vm.resultModel.assignee\" aria-label=\"Delegar\" placeholder=\"Usuário\"><md-option \nng-repeat=\"user in vm.users\" value=\"{{user.id}}\">{{user.firstName}}</md-option></md-select></md-input-container></div>\n<div layout=\"column\" flex><label>Quando a análise deverá ser realizada</label><div flex class=\"date-container\" \nstyle=\"margin-top: 15px\"><md-datepicker flex ng-model=\"vm.dueDateTmp\" md-placeholder=\"Data\" \nng-change=\"vm.resultModel.dueDate = vm.dueDateTmp.toISOString()\"></md-datepicker></div></div></div></div>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\">\n<md-button type=\"submit\" class=\"send-button md-primary md-raised\" ng-click=\"vm.save()\" aria-label=\"Salvar\">SALVAR\n</md-button></div></md-dialog-actions></div></md-content></div>");}]);